import { CommonPullupMenuComponent } from './../modal-screens/common-pullup-menu/common-pullup-menu.component';
import { ManageMembershipPageComponent } from './../profile/manage-membership-page/manage-membership-page.component';
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Apiurl } from '../commonServices/route';
import { NavigationEnd, NavigationExtras, Router } from '@angular/router';
import { CommonProvider } from '../commonServices/common';
import {
  ActionSheetController,
  AlertController,
  IonRefresher,
  IonSearchbar,
  IonSlides,
  IonicSlides,
  LoadingController,
  ModalController,
  Platform,
  ToastController,
} from '@ionic/angular';
import { CountryListPage } from '../modal-screens/country-list/country-list.page';
import { Dialogs } from '@ionic-native/dialogs/ngx';
import * as global from 'src/globals';
import { Country } from 'src/data/country-location';
import { forkJoin, Observable, of, Subscription } from 'rxjs';
import { SessionInfo, SessionState } from 'src/data/authentication-info';
import { FriendRequest, FriendRequestList, PlayerHomeInfo, PlayerInfo } from 'src/data/player-data';
import { CompetitionInfo } from 'src/data/competition-data';
import { distinctUntilChanged, filter, map, take, tap } from 'rxjs/operators';
import { CurrentScorecardDataService } from '../../../redux/scorecard/current-scorecard-data-service';
import { CurrentScorecardActions } from '../../../redux/scorecard/current-scorecard-actions';
import { PlayerHomeActions } from 'src/redux/player-home/player-home-actions';
import { ServerInfoService } from 'src/providers/serverinfo-service/serverinfo-service';
import { FriendService } from 'src/providers/friend-service/friend-service';
import { ServerInfo } from 'src/data/server-info';
import { PlayerHomeDataService } from 'src/redux/player-home/player-home-data-service';
import { PlayerService } from 'src/providers/player-service/player-service';
import { SessionDataService } from 'src/redux/session/session-data-service';
import { SessionActions } from 'src/redux/session/session-actions';
import { ClubFlightService } from 'src/providers/club-flight-service/club-flight-service';
import * as moment from 'moment';
import { JsonService } from 'src/json-util';
import {
  ClubCredit,
  ClubHandicap,
  ClubInfo,
  ClubMembership,
  ClubMembershipExtended,
  ClubMembershipStatusHistory,
  CompetitionData,
  DiscountCompany,
  HandicapCalculation,
  HandicapSystem,
  MembershipStatus,
  News,
  NewsPage,
  OfferAndAdvertisement,
  OffersAndAdvertisementPage,
  OnClickAction,
  PlainScoreCard,
  PlayerClubWalletBalance,
  StayAndPlayPackage,
  StayAndPlayPackagePage,
  TeeTimeBooking,
  CompetitionMatch,
  CompetitionMatchParticipant,
  FindTeeTimeCriteria,
} from 'src/data/mygolf.data';
import { HandicapService } from 'src/providers/handicap-service/handicap-service';
import { HandicapIndexSubscription } from 'src/data/premium-subscription';
import { MessageDisplayUtil } from 'src/message-display-utils';
import { AdhandlerComponent } from 'src/custom/adhandler-component';
import {
  AbstractNotificationHandlerPage,
  NotificationHandlerInfo,
} from 'src/providers/pushnotification-service/notification-handler-constructs';
import { CompetitionService } from 'src/providers/competition-service/competition-service';
import { ScorecardService } from 'src/providers/scorecard-service/scorecard-service';
import { JsonPipe } from '@angular/common';
import { ProfileImageEditComponent } from '../edit-profile/profile-image-edit/profile-image-edit.component';
import { MyGolfStorageService } from 'src/storage/mygolf-storage.service';
import { PlayerVoucherPage } from '../modal-screens/player-voucher/player-voucher.page';
import { PushNotificationService } from 'src/providers/pushnotification-service/pushnotification-service';
import { mygolfUtils } from 'src/custom/mygolf2u-utils';
import { ClubMembershipListPage } from '../modal-screens/club-membership-list/club-membership-list';
import { PlayerWalletHistoryPage } from '../modal-screens/player-wallet-history/player-wallet-history';
import { ClubPlayerWalletTopupModal } from '../modal-screens/club-player-wallet-topup/club-player-wallet-topup';
import { PackageService } from 'src/providers/package-service/package-service';
import { Item, PackageSearchCriteria } from 'src/data/package-data';
import { MyApp } from 'src/app/app.component';
import { ClubListPage } from '../normalgame/club-list/club-list.page';
import { SearchDiscountCompanyPage } from '../modal-screens/player-voucher/search-discount-company/search-discount-company.page';
import { HamerburgMenuComponent } from './hamerburg-menu/hamerburg-menu.component';
import { PlayerDetailsClubMembershipPage } from '../player-club-membership/player-details-club-membership/player-details-club-membership.page';
import { DeleteRoomModalComponent } from '../package-details/package-booking/delete-room-modal/delete-room-modal.component';
import { UpdateNhsModalComponent } from '../normalgame/flight-setup/update-nhs-modal/update-nhs-modal.component';
import { ensureHttpPrefix, isPresent } from 'src/providers/common-service';
import { NewsDetailsComponent } from '../news/news-details/news-details.component';
import { InAppBrowserOptions, InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import { PromoAdsDetailsComponent } from '../promo-ads/promo-ads-details/promo-ads-details.component';
import { HelpURLs } from '../contact-us/contact-us.page';
import { PlayerAddClubMembershipPage } from '../player-club-membership/player-add-club-membership/player-add-club-membership.page';
import { HandicapMembershipService } from 'src/providers/handicap-membership/handicap-membership.service';
import Swiper from 'swiper';
import Grid from 'swiper';
import { SearchTeeTimeComponent } from '../booking/booking-home/search-tee-time/search-tee-time.component';
import { BookingService } from 'src/providers/tee-booking-service/tee-booking-service';
import { ConnectionService } from 'src/providers/connection-service/connection-service';
@Component({
  selector: 'app-player-home',
  templateUrl: './player-home.page.html',
  styleUrls: ['./player-home.page.scss'],
})
export class PlayerHomePage implements OnInit, OnDestroy {
  swiperPromoModules = [IonicSlides];
  swiperNewsModules = [IonicSlides];
  swiperMenuModules = [IonicSlides];
  searchQuery: any;
  activeSlide: number = 0;
  @ViewChild('PlayerHomeManu') slides: IonSlides;
  isShowSearch: boolean = false;
  packageList: Array<StayAndPlayPackage>;
  @ViewChild('searchRef', { static: false }) searchRef: IonSearchbar;
  navigationExtras: NavigationExtras = {};
  packageSearchCriteria = {} as PackageSearchCriteria;
  public playerHomeInfo$: Observable<PlayerHomeInfo>;
  public player$: Observable<PlayerInfo>;
  public playerPhoto$: Observable<string>;
  public selectedCompetition$: Observable<any>;
  public multipleComps: Observable<boolean>;
  public activeCompsToday: Observable<number>;
  public singleActiveComp: Observable<CompetitionInfo>;
  public loading: LoadingController;
  public refresher: IonRefresher;
  public normalGameOn: Observable<boolean>;
  public currentGameClub: Observable<string>;
  public competitionOn: Observable<boolean>;
  private scoringSubscription: Subscription;
  private sessionSubscription: Subscription;
  private stateChangeSubscription: Subscription;
  session: SessionInfo;
  countryId: string;
  // countryId: Observable<string>;
  countryList: Array<Country>;
  country: Country;
  countrySel: Country;
  defaultCountry: string;
  public country$: Observable<string>;
  public countryId$: Observable<string>;
  public activeComp: number;
  public hcpIdxSubs: HandicapIndexSubscription;
  public handicapHistory: HandicapCalculation;

  public clubHandicap: Array<ClubHandicap>;
  public playerClubHcp: any;

  friendCount: number;
  _activeCompsToday: number;

  playerCredits: Array<any>;
  totalClubCredits: number;
  totalWalletBalance: number;

  activeComps: any;

  isBookingRegistrationEnabled: boolean;

  @ViewChild('adhandler') adHandler: AdhandlerComponent;
  @ViewChild('swiperPromoContainer', { static: false }) swiperPromoContainer: ElementRef;
  swiperPromo: any; //Swiper | undefined;
  @ViewChild('swiperNewsContainer', { static: false }) swiperNewsContainer: ElementRef;
  swiperNews: any; //Swiper | undefined;
  @ViewChild('swiperMenuContainer', { static: false }) swiperMenuContainer: ElementRef;
  swiperMenu: any; //Swiper | undefined;

  handicapSystem: Array<HandicapSystem> = new Array<HandicapSystem>();

  handicapIndex: number;

  totalActiveBookings: number = 0;

  /**
   * @param overrideBooking Set to True to always override server's flag - booking enabled
   */
  overrideBooking: boolean = false;

  teetimeBookingSubscription: Subscription;

  memberships: Array<ClubMembership>;
  homeClubId: number;

  isClubSpecific: boolean = false;

  selClubMembership: ClubMembershipExtended;

  appType;

  hasParam: boolean = false;
  clubSpecificSelected: boolean = false;
  dataExtras: any;
  selectedClub: ClubInfo;
  hcpIdxList: Array<number>;
  hcpList: Array<number>;
  mg2uIdList: Array<number>;
  clubInfo: ClubInfo;

  iabOptions: InAppBrowserOptions = {
    location: 'yes',
    hidden: 'no',
    clearcache: 'yes',
    clearsessioncache: 'yes',
    zoom: 'yes',
    hardwareback: 'yes',
    mediaPlaybackRequiresUserAction: 'no',
    shouldPauseOnSuspend: 'no',
    closebuttoncaption: 'Close',
    disallowoverscroll: 'no',
    toolbar: 'yes',
    enableViewportScale: 'no',
    allowInlineMediaPlayback: 'no',
    presentationstyle: 'pagesheet',
    fullscreen: 'yes',
  };

  homeClubMembership: ClubMembershipExtended;

  pageLoader: HTMLIonLoadingElement | null = null; // any;
  constructor(
    private http: HttpClient,
    private router: Router,
    public playerService_: PlayerHomeDataService,
    private commonProvider: CommonProvider,
    private currentScorecardService: CurrentScorecardDataService,
    private actionSheetCtl: ActionSheetController,
    private platform: Platform,
    private currentScorecardActions: CurrentScorecardActions,
    private modalCtl: ModalController,
    private flightService: ClubFlightService,
    private loadingCtl: LoadingController,
    private alertCtl: AlertController,
    private toastCtl: ToastController,
    // private dialogs: Dialogs,
    private competitionService: CompetitionService,
    private scorecardService: ScorecardService,
    private alertCtrl: AlertController,
    private compService: CompetitionService,
    private dialogs: Dialogs,
    private playerHomeActions: PlayerHomeActions,
    private serverInfoService: ServerInfoService,
    private friendService: FriendService,
    private playerHomeService: PlayerHomeDataService,
    private packageService: PackageService,
    private sessionService: SessionDataService,
    private sessionActions: SessionActions,
    private handicapService: HandicapService,
    private ref: ChangeDetectorRef,
    private mg2uUtil: mygolfUtils,

    private playerService: PlayerService,

    private storage: MyGolfStorageService,
    private pushService: PushNotificationService,
    private appComp: MyApp,
    private iab: InAppBrowser,
    private hcpMemberService: HandicapMembershipService,
    private changeDetectorRef: ChangeDetectorRef,
    private bookingService: BookingService,
    private connService: ConnectionService
  ) {
    this.dataExtras = this.router.getCurrentNavigation().extras.state;

    this.serverInfoService.serverInfo().subscribe((data: ServerInfo) => {
      if (data && !this.overrideBooking) {
        this.isBookingRegistrationEnabled = data.enablePlayerAppBooking;
      }
    });
    if (this.overrideBooking) this.isBookingRegistrationEnabled = this.overrideBooking;
    this.playerHomeInfo$ = this.playerHomeService.playerHomeInfo();

    // this.ref.detectChanges();
    this.player$ = this.playerHomeInfo$.pipe(
      filter(Boolean),
      map((playerHome: PlayerHomeInfo) => playerHome.player)
    );
    this.player$.subscribe(res => {});

    this.playerPhoto$ = this.playerHomeService.playerPhoto();
    this.multipleComps = this.playerHomeInfo$.pipe(
      filter(Boolean),
      map((homeInfo: PlayerHomeInfo) => {
        return homeInfo.compsActiveToday && homeInfo.compsActiveToday.length > 1;
      })
    );
    this.normalGameOn = this.currentScorecardService.normalGameScoring();
    this.currentGameClub = this.currentScorecardService.clubName();
    this.competitionOn = this.currentScorecardService.competitionScoring();
    this.activeCompsToday = this.playerHomeInfo$.pipe(
      filter(Boolean),
      map((homeInfo: PlayerHomeInfo) => {
        this._activeCompsToday = homeInfo.compsActiveToday ? homeInfo.compsActiveToday.length : 0;
        if (homeInfo.compsActiveToday) {
          return homeInfo.compsActiveToday.length;
        } else {
          return 0;
        }
      })
    );
    this.singleActiveComp = this.playerHomeInfo$.pipe(
      filter(Boolean),
      map((homeInfo: PlayerHomeInfo) => {
        if (homeInfo.compsActiveToday && homeInfo.compsActiveToday.length === 1)
          return homeInfo.compsActiveToday[0];
        else return null;
      })
    );
    this.selectedCompetition$ = this.playerHomeService.competitionSelectedForScoring();

    this.appType = global.appType;
    // let _param: any = this.platform.getQueryParam('param');
    // let _param: any = this.mg2uUtil.getClubParam();
    // // this.hasParam = true;
    //
    // if (_param) {
    //   this.mg2uUtil.setClubSpecific(true);
    //   // this.mg2uUtil.setClubId(_param);
    //   this.hasParam = true;
    //   this.getClubInfo(this.mg2uUtil.getClubId());
    // }

    // let _param: any = this.platform.getQueryParam('param');
    let _param = Number(this.mg2uUtil.getClubId());
    // this.hasParam = true;

    if (_param) {
      this.mg2uUtil.setClubSpecific(true);
      this.mg2uUtil.setClubId(_param);
      this.hasParam = true;
      this.getClubInfo(_param);
      this.mg2uUtil.setPersistClubTheme(String(_param));

      // this.updateColor(cc.themeName);
      setTimeout(() => {
        let _hasClubThemes;
        let _appAttribute = this.mg2uUtil.getSpecificAppAttributePage('playerHome');

        if (_appAttribute && _appAttribute.clubSpecificThemes) {
          // _hasClubThemes =

          _appAttribute.clubSpecificThemes
            .filter(cc => {
              return cc.clubId === Number(_param) && cc.enableTheme;
            })
            .map(cc => {
              this.updateColor(cc.themeName);
              this.isClubSpecific = true;
              // // this.selClubMembership.club.clubId = cc.clubId;
              // memberships.filter((m: ClubMembership) => {
              //     return m.club.clubId === cc.clubId;
              // }).map((club) => {
              this.selClubMembership = {};
              this.selClubMembership['club'] = this.selectedClub;
              // this.setCompClubId()
            });
        }
      }, 750);
    }
    let currentUrl = '';
    let previousUrl = '';
    // this.router.events.subscribe(
    //   (event: any) => {
    //     if (event instanceof NavigationEnd) {
    //       previousUrl = currentUrl;
    //       currentUrl = event.url;
    //       console.log(previousUrl);
    //       if(previousUrl==='/tabs/pre-2020'){

    //       }
    //       else if(previousUrl==='/tabs/pre-2020'){}
    //       else if(previousUrl==='/booking-home'){}

    //     }
    //   }
    // );

    // this.playerHomeInfo$.filter(Boolean).subscribe((c: PlayerHomeInfo)=>{
    //     this.activeComps = c.compsActiveToday[0];
    // })

    // if(this.playerHomeInfo$) {
    //     this.playerHomeInfo$
    //     .map((playerHome: PlayerHomeInfo) => playerHome.player)
    //     .distinctUntilChanged()
    //     .subscribe((p: PlayerInfo) => {
    //
    //     })
    // }

    // this.countryId = countryId
    window.addEventListener('resize', () => {
      this.slideOpts = {
        initialSlide: 0,
        slidesPerView: !this.isMobileLayout() ? 2.4 : this.isMobileLayout() ? 1.1 : 4,
        speed: 400,
        spaceBetween: 15,
        responsiveClass: true,
        scrollbar: {
          el: '.swiper-scrollbar',
          draggable: true,
        },
      };
      this.playerSlide = {
        initialSlide: 0,
        allowSlideNext: true,
        allowSlidePrev: true,
        speed: 300,
        loop: false,
        pagination: true,
        slidesPerView: 4,
        StartSlides: true,
        responsiveClass: true,
        responsive: {
          0: {
            slidesPerView: 4,
          },
          768: {
            slidesPerView: 8,
          },
          992: {
            slidesPerView: 10,
          },
        },
      };

      this.slideNews = {
        slidesPerView: !this.isMobileLayout() ? 2 : this.isMobileLayout() ? 1.3 : 3,
        speed: 400,
        spaceBetween: 15,
        responsiveClass: true,
        scrollbar: {
          el: '.swiper-scrollbar',
          draggable: true,
        },
        // direction: 'vertical',
        // grid: {
        //   rows: 2,
        //   fill: 'column'
        // }
      };
    });

    // console.debug("load player home : ", this.mg2uUtil.webPartner, this.mg2uUtil.webPartnerId)

    this.clearVariables();

    // this.router.events.pipe(
    //   filter(event => event instanceof NavigationEnd)
    // ).subscribe(async () => {

    //   console.debug("router re-entry player home : ", this.dataExtras, this.router)
    //   if (this.router.url === '/tabs/player-home') {

    //     if(this.dataExtras?.needRefresh) {
    //       await Promise.all([this.refreshHome(!this.clubSpecificSelected),this.refreshHome(!this.clubSpecificSelected)])
    //       // this.playerHomeActions.refreshHomeInfo();
    //       // this.refreshHome(null);
    //     }
    //   }
    // });

    this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe(async (event: NavigationEnd) => {
        // console.debug("2 router re-entry player home : ", this.currentUrl, event.url, event.urlAfterRedirects)
        this.previousUrl = this.currentUrl;
        this.currentUrl = event.url;
        if (
          this.previousUrl?.toLowerCase()?.includes('matchplay-scoring') &&
          event.url?.toLowerCase()?.includes('player-home')
        ) {
          console.debug(
            '222 router re-entry player home : ',
            this.previousUrl,
            this.currentUrl,
            event.url,
            event.urlAfterRedirects
          );
          forkJoin([
            this.playerHomeRefresh(),
            this.refreshHome(!this.clubSpecificSelected),
            this.refresh(null),
          ]);
          // await Promise.all([this.playerHomeRefresh(),this.refreshHome(!this.clubSpecificSelected),this.refresh(null)])
        }
        if (
          this.previousUrl?.toLowerCase()?.includes('leaderboard') &&
          event.url?.toLowerCase()?.includes('player-home')
        ) {
          console.debug(
            '222 router re-entry player home : ',
            this.previousUrl,
            this.currentUrl,
            event.url,
            event.urlAfterRedirects
          );
          forkJoin([
            this.playerHomeRefresh(),
            this.refreshHome(!this.clubSpecificSelected),
            this.refresh(null),
          ]);
          // await Promise.all([this.playerHomeRefresh(),this.refreshHome(!this.clubSpecificSelected),this.refresh(null)])
        }
        // else if(this.previousUrl?.toLowerCase()?.includes('gameround-scoring')) {
        //   forkJoin([this.playerHomeRefresh(),this.refreshHome(!this.clubSpecificSelected),this.refresh(null)]);
        // }
      });
  }
  previousUrl: string = '';
  currentUrl: string = '';
  // url:any;

  async initPageLoader(message: string = '') {
    this.pageLoader = await this.loadingCtl.create({
      cssClass: 'custom-loading',
      message: message,
      backdropDismiss: false,
      duration: 7500,
      showBackdrop: true,
    });
  }

  async ionViewWillEnter() {
    this.playCompClicked = false;

    this.refreshHome(!this.clubSpecificSelected);
    this.getPageRoleAccess();
    // this.playerHomeActions.setNeedRefresh(true);
  }

  getPageRoleAccess() {
    if (this.appComp && this.appComp.pageRoleAccess) {
    }
  }

  goPlayerClubMembership() {
    // this.nav.push(PlayerDetailsClubMembershipPage, {
    //   player: this.player$
    // });
  }

  clearVariables() {
    this.homeClubMembership = null;
    this.isClubSpecific = false;
    this.handicapIndex = null;

    this.totalClubCredits = null;
    this.totalWalletBalance = null;
    this.mg2uUtil.setPref('communalMode', true);
  }
  swiperBreakpoints = {
    '0': {
      slidesPerView: 3.5,
      spaceBetween: 22,
    },
    '320': {
      slidesPerView: 3.5,
      spaceBetween: 22,
    },
    '375': {
      slidesPerView: 4.5,
      spaceBetween: 22,
    },
    '768': {
      slidesPerView: 6.5,
      spaceBetween: 22,
    },
    '1024': {
      slidesPerView: 10,
      spaceBetween: 22,
    },
    '1440': {
      slidesPerView: 10,
      spaceBetween: 22,
    },
  };
  initSwiper(type?: string) {
    const swiperOptions = {
      centeredSlides: false,
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 0,
      breakpoints: {
        // when window width is >= 320px
        320: {
          slidesPerView: 1,
          spaceBetween: 0,
        },
      },
      on: {
        beforeInit: swiper => {
          swiper.classNames.push('swiper-container-custom');
        },
        slideChange: swiper => {
          if (swiper.isEnd) {
            swiper.slideTo(swiper.slides.length - 1, 0);
          }
        },
      },
      // Your Swiper options here
      // slidesPerView: this.isMobileLayout() ? 1.1 : 2.4, //this.isMobileLayout() ? 1.1 : 4, //1,
      // spaceBetween: 15,
      // initialSlide: 0,
      // responsiveClass: true,
      // ... other options
    };

    const promoOpts = {
      slidesPerView: this.isMobileLayout() ? 1.1 : 2.4,
      centeredSlides: false,
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 0,
      // breakpoints: {
      //   // when window width is >= 320px
      //   320: {
      //     slidesPerView: 1,
      //     spaceBetween: 0
      //   }
      // },
      on: {
        beforeInit: swiper => {
          swiper.classNames.push('swiper-container-custom');
        },
        slideChange: swiper => {
          if (swiper.isEnd) {
            swiper.slideTo(swiper.slides.length - 1, 0);
          }
        },
      },
    };

    const newsOpts = {
      // modules: [Grid],
      slidesPerView: this.isMobileLayout() ? 1.5 : 2,
      centeredSlides: false,
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 0,
      // grid: {
      //   rows: 2,
      //   fill: 'column'
      // },
      // breakpoints: {
      //   // when window width is >= 320px
      //   320: {
      //     slidesPerView: 1,
      //     spaceBetween: 0
      //   }
      // },
      on: {
        beforeInit: swiper => {
          swiper.classNames.push('swiper-container-custom');
        },
        slideChange: swiper => {
          if (swiper.isEnd) {
            swiper.slideTo(swiper.slides.length - 1, 0);
          }
        },
      },
    };

    const menuOpts = {
      // slidesPerView: this.isMobileLayout()?3.5:4.5,
      centeredSlides: false,
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 0,
      on: {
        beforeInit: swiper => {
          swiper.classNames.push('swiper-container-custom');
        },
        slideChange: swiper => {
          if (swiper.isEnd) {
            swiper.slideTo(swiper.slides.length - 1, 0);
          }
        },
      },
      scrollbar: {
        el: '.swiper-scrollbar',
        hide: true,
      },
      // responsive: {
      //   0: {
      //     slidesPerView: 3.5,
      //   },
      //   350: {
      //     slidesPerView: 4.5,
      //   },
      //   768: {
      //     slidesPerView: 6.5,
      //   },
      //   992: {
      //     slidesPerView: 10,
      //   }
      // }
    };

    if (type === 'promo' && this.swiperPromoContainer && this.swiperPromoContainer.nativeElement) {
      this.swiperPromo = new Swiper(this.swiperPromoContainer.nativeElement, promoOpts);
    } else if (
      type === 'news' &&
      this.swiperNewsContainer &&
      this.swiperNewsContainer.nativeElement
    ) {
      this.swiperNews = new Swiper(this.swiperNewsContainer.nativeElement, newsOpts);
    } else {
      if (this.swiperPromoContainer && this.swiperPromoContainer.nativeElement)
        this.swiperPromo = new Swiper(this.swiperPromoContainer.nativeElement, promoOpts);

      if (this.swiperNewsContainer && this.swiperNewsContainer.nativeElement)
        this.swiperNews = new Swiper(this.swiperNewsContainer.nativeElement, newsOpts);
      if (this.swiperMenuContainer && this.swiperMenuContainer.nativeElement)
        this.swiperMenu = new Swiper(this.swiperMenuContainer.nativeElement, menuOpts);
    }
  }

  refreshSwiper(type?: string) {
    if (type === 'promo') {
      if (this.swiperPromo && typeof this.swiperPromo.destroy === 'function') {
        this.swiperPromo.destroy(true, true);
      }
    } else if (type === 'news') {
      if (this.swiperNews && typeof this.swiperNews.destroy === 'function') {
        this.swiperNews.destroy(true, true);
      }
    } else if (!type) {
      if (this.swiperPromo && typeof this.swiperPromo.destroy === 'function')
        this.swiperPromo.destroy(true, true);
      if (this.swiperNews && typeof this.swiperNews.destroy === 'function')
        this.swiperNews.destroy(true, true);
      if (this.swiperMenu && typeof this.swiperMenu.destroy === 'function')
        this.swiperMenu.destroy(true, true);
    }

    // Update slides array here if needed
    // For example: this.slides = ['New Slide 1', 'New Slide 2'];

    this.changeDetectorRef.detectChanges(); // Force view update

    setTimeout(() => {
      this.initSwiper(type);
      if (type === 'promo' && this.swiperPromo) {
        this.swiperPromo?.update(); // Update Swiper after initialization
      } else if (type === 'news' && this.swiperNews) {
        this.swiperNews?.update();
      } else {
        this.swiperPromo?.update(); // Update Swiper after initialization
        this.swiperNews?.update();
        this.swiperMenu?.update();
      }
    }, 0);
  }

  searchCriteriaBooking: FindTeeTimeCriteria;
  ngOnInit() {
    let searchCriteriaBooking = this.bookingService.getSearch();
    if (isPresent(this.bookingService.getSearch()))
      this.searchCriteriaBooking = searchCriteriaBooking;
    // if(!this.pageLoader) this.initPageLoader();
    this.mg2uUtil.getPref('communalMode').subscribe(mode => {
      console.debug('communal mode', mode);
    });

    // const _communalMode = this.mg2uUtil.getPref('communalMode');
    // console.debug("communal mode ", _communalMode, this.mg2uUtil.getPref('communalMode'));
    // this.setCommunalMode(_communalMode==='true'?true:false);
    this.initSwiper();
    // await this.storage.create()

    // this.refreshHome(null);

    // this.teetimeBookingSubscription = this.currentScorecardService.getTeetimeBooking()
    //                                     .subscribe((teetimeBooking: any) => {
    //
    // });

    // this.msgSubscription = this.currentScorecardService.getCurrentScorecard()
    //                            .map(curr=>curr.reloadReason)
    //                            .distinctUntilChanged()
    //                            .subscribe(reason=>{
    //                                if(reason){
    //                                    let toast = this.toastCtl.create({
    //                                        message: reason + " Scorecard is reloaded.",
    //                                        showCloseButton: true,
    //                                        closeButtonText: 'OK',
    //                                        duration: 5000
    //                                    });
    //                                    toast.present().then(()=>{
    //                                        this.currentScorecardActions.clearReloadFlag();
    //                                    });
    //                                }

    //                            });

    this.playerHomeActions.setNeedRefresh(true);
    this.getCountry(() => {
      if (this.player$) {
        this.player$.pipe(filter(Boolean)).subscribe((p: PlayerInfo | any) => {
          this.getActiveComps();

          if (!this.defaultCountry) {
            // console.debug("setting default country", p.addressInfo, p.countryId)
            if (p?.countryId) {
              this.countryId = p.countryId;
              this.defaultCountry = p.countryId;
            } else if (p?.addressInfo) {
              this.countryId = p.addressInfo.countryId;
              this.defaultCountry = p.addressInfo.countryId;
            }
            this.countrySelected(this.countryId);
          } else {
            this.countryId = this.defaultCountry;
            this.countrySelected(this.countryId);
          }
          setTimeout(() => {
            // console.debug("setting default country [1]", this.defaultCountry)
            // move this up!!!
            this.getPlayerCredits();
            this.refreshMygolfHandicap();
            this._refreshHcpIdxSubscriptions();
            this.getActiveBookings();
            // this.refreshMembership();
            if (!this.subNewClubMship)
              this.getNewClubMembership(true)
                .then(() => {
                  this.getHomeNews();
                  this.getHomePromoAds();
                })
                .catch(() => {
                  this.getHomeNews();
                  this.getHomePromoAds();
                });
            //
            if (!this.defaultCountry) {
              MessageDisplayUtil.showErrorToast(
                'Please update your Residing In Country in Profile for better experience',
                this.platform,
                this.toastCtl,
                3000,
                'bottom'
              );
            }
            // if(!p.birthdate) {
            //     MessageDisplayUtil.showErrorToast("Please update your Date of Birth to get amazing booking deals",
            //     this.platform, this.toastCtl, 3000, "bottom")
            // }
          }, 500);

          //
          let data: Array<any> = new Array<any>();
          let _payload: any; //OSNotificationPayload;

          // this.defaultCountry = null;
          // p.birthdate = null;
          if (!this.defaultCountry) {
            _payload = {
              title: 'Update Residing In Country',
              body: 'Please update your Residing In Country in Profile for better experience',
              additionalData: {
                type: 'updateProfile',
              },
            };
            data.push(_payload);
          }
          if (!p.birthdate) {
            _payload = {
              title: 'Update Date of Birth',
              body: 'Please update your Date of Birth to get amazing booking deals',
              additionalData: {
                type: 'updateProfile',
              },
            };
            data.push(_payload);
          }

          // {
          //     title: 'Competition Started',
          //     body: 'Competition Round has started Competition Round has started Competition Round has started Competition Round has started',
          //     additionalData: {
          //         type: 'bookingFailure'
          //     }
          // }

          this.storage.getPreference('notifications').subscribe(
            a => {
              if (a) _payload = a; //_payload.push(a);
              if (data)
                data.forEach(payload => {
                  let _data = false;
                  if (a && a.length > 0) {
                    a.filter(p => {
                      if (payload.title.toLowerCase().includes(p.title.toLowerCase())) {
                        _data = true;
                        return true;
                        // return false
                      }
                      // else {
                      //     _data = false
                      //     // return true
                      // }
                    });
                    if (!_data) {
                      _payload.push(payload);
                    }
                  }
                });
              if (data && _payload && _payload.length > 0) this.storage.getPreference(_payload);
              //  _payload.push(...data);
            },
            error => {}
          );
        });

        this.refreshHandicapSystem();
      }
    });
    // let compRef = this.nav.getActive()._cmp.instance;
    this.sessionSubscription = this.sessionService
      .getSession()
      .pipe(distinctUntilChanged())
      .subscribe((session: SessionInfo) => {
        if (session.status !== SessionState.LoggedIn) {
          //    this.nav.insert(0, SignIn, {
          //        signOut: true
          //    })
          //    this.nav.popToRoot();
          this.router.navigate(['sign-in'], { replaceUrl: true, queryParams: { signOut: true } });
          //  this.nav.setRoot(SignIn, {
          //      signOut: true
          //  });
        } else if (session.status === SessionState.LoggedIn) {
          this.registerAppVisit();
        }
      });

    // this.refreshHome(null);
    this.getFriendRequestCount();
    this.getAppAttribute();
  }
  hasAnyActiveCompsToday: boolean = false;

  getClubInfo(clubId) {
    let _clubId = clubId;
    this.flightService.getClubInfo(_clubId).subscribe((data: ClubInfo) => {
      this.selectedClub = data;
    });
  }

  ngOnDestroy() {
    if (this.sessionSubscription) this.sessionSubscription.unsubscribe();
    this.ionViewWillLeave();
  }

  // ionViewWillUnload() {
  //   if (this.sessionSubscription) this.sessionSubscription.unsubscribe();
  //   // if(this.teetimeBookingSubscription) this.teetimeBookingSubscription.unsubscribe();
  // }

  ngAfterViewInit() {
    this.notificationClass = this.hasNotifications();
    this.hasAnyActiveCompsToday = this.hasActiveCompsToday();

    this.loadURLParams();
  }

  _compRegister: any;
  loadURLParams() {
    this._compRegister = this.platform.getQueryParam('compRegister');
    if (!!this._compRegister && Number(this._compRegister) > 0) {
      this.getCompetitionData(Number(this._compRegister))
        .then((result: any) => {
          console.debug('get comp data', Number(this._compRegister), result);
          let navigationExtras: NavigationExtras = {
            state: {
              competition: result,
              compId: result?.id,
              animate: false,
            },
          };
          this.router.navigate(['competition-details'], navigationExtras);

          // this.removeUrlParam('compRegister');
        })
        .catch(error => {
          if (error === true) {
            MessageDisplayUtil.showErrorToast(
              'There is no competition with this id',
              this.platform,
              this.toastCtl,
              3000,
              'bottom'
            );
          } else {
            let _message = 'There is no competition with this id';
            if (error?.errorMessage) _message = error?.errorMessage;
            MessageDisplayUtil.showErrorToast(
              _message,
              this.platform,
              this.toastCtl,
              3000,
              'bottom'
            );
          }
        });
    }
  }

  getCompetitionData(compId: number) {
    return new Promise((resolve, reject) => {
      if (!compId) reject(true);
      this.flightService.getCompetitionDetails(compId).subscribe(
        compData => {
          resolve(compData);
        },
        error => {
          reject(error);
        }
      );
    });
  }

  async ionViewDidEnter() {
    this.playCompClicked = false;
    // if(this.pageLoader) this.pageLoader = null;
    if (this.adHandler) {
      this.adHandler.refresh();
    }
  }

  subGetHomeInfo: Subscription;
  subPlHcpIdx: Subscription;
  subPlayerBookings: Subscription;
  subInfoServer: Subscription;
  subNewsList: Subscription;
  subPromoList: Subscription;
  ionViewWillLeave() {
    if (this.adHandler) {
      this.adHandler.stop();
    }
    if (this.scoringSubscription) {
      this.scoringSubscription.unsubscribe();
      this.scoringSubscription = null;
    }
    if (this.stateChangeSubscription) {
      this.stateChangeSubscription.unsubscribe();
      this.stateChangeSubscription = null;
    }
    if (this.subPlayerCredits) {
      this.subPlayerCredits.unsubscribe();
      this.subPlayerCredits = null;
    }
    if (this.subFriendReq) {
      this.subFriendReq.unsubscribe();
      this.subFriendReq = null;
    }
    if (this.subHcpSystemList) {
      this.subHcpSystemList.unsubscribe();
      this.subHcpSystemList = null;
    }
    if (this.subHcpIdx) {
      this.subHcpIdx.unsubscribe();
      this.subHcpIdx = null;
    }
    if (this.subGetHomeInfo) {
      this.subGetHomeInfo.unsubscribe();
      this.subGetHomeInfo = null;
    }
    if (this.subPlHcpIdx) {
      this.subPlHcpIdx.unsubscribe();
      this.subPlHcpIdx = null;
    }
    if (this.subPlayerBookings) {
      this.subPlayerBookings.unsubscribe();
      this.subPlayerBookings = null;
    }
    if (this.subInfoServer) {
      this.subInfoServer.unsubscribe();
      this.subInfoServer = null;
    }
    if (this.subNewClubMship) {
      this.subNewClubMship.unsubscribe();
      this.subNewClubMship = null;
    }

    if (this.subNewsList) {
      this.subNewsList.unsubscribe();
      this.subNewsList = null;
    }

    if (this.subPromoList) {
      this.subPromoList.unsubscribe();
      this.subPromoList = null;
    }
    if (this.subRegisterAppVisit) {
      this.subRegisterAppVisit.unsubscribe();
      this.subRegisterAppVisit = null;
    }
    if (this.subAppAttribute) {
      this.subAppAttribute.unsubscribe();
      this.subAppAttribute = null;
    }
    if (this.subNormalGameOn) {
      this.subNormalGameOn.unsubscribe();
      this.subNormalGameOn = null;
    }

    if (this.subHcpHistory) {
      this.subHcpHistory.unsubscribe();
      this.subHcpHistory = null;
    }

    this.playGolfClicked = false;
    this.playCompClicked = false;
    this.onDismissPageLoader();
  }
  subFriendReq: Subscription;
  subHcpSystemList: Subscription;
  subPlayerMemberships: Subscription;
  subHcpIdx: Subscription;
  ionViewDidLeave() {}

  public getNotifications() {
    let notifications = new Array<NotificationHandlerInfo>();
    notifications.push({
      type: AbstractNotificationHandlerPage.TYPE_COMP_ROUND_STARTED,
      whenActive: 'showToast',
      whenInactive: 'none',
      needRefresh: true,
    });
    return notifications;
  }

  public refreshPage(pushData: any): Observable<boolean> {
    this.refreshHome(null);
    return of(true);
  }

  refreshOnViewEntered(refresh: boolean) {
    // this.homeInfo.needRefresh = refresh;
    this.playerHomeActions.setNeedRefresh(true);
  }

  defaultHcpSystem: string;
  subHcpHistory: Subscription;
  refreshMygolfHandicap() {
    if (this.subPlHcpIdx) return;
    if (this.subHcpHistory) return;
    this.handicapIndex = null;
    let _player: PlayerInfo;
    let _forDate = moment().add(1, 'days').format('YYYY-MM-DD');
    this.player$.pipe(take(1)).subscribe(player => {
      _player = player;
    });
    let _playerId = _player?.playerId || _player?.id;
    let _defaultHcpSystem = _player?.defaultHandicapSystem || 'WHS2020';
    this.defaultHcpSystem = _player?.defaultHandicapSystem || 'WHS2020';
    this.subPlHcpIdx = this.flightService
      .getPlayerHandicapIndex(_playerId, _defaultHcpSystem, _forDate)
      .subscribe(
        (data: any) => {
          if (data) this.handicapIndex = data;

          if (this.subPlHcpIdx) {
            this.subPlHcpIdx.unsubscribe();
            this.subPlHcpIdx = null;
          }
        },
        err => {
          if (this.subPlHcpIdx) {
            this.subPlHcpIdx.unsubscribe();
            this.subPlHcpIdx = null;
          }
        }
      );
    (this.subHcpHistory = this.handicapService
      .getHandicapHistory()
      .subscribe((data: Array<HandicapCalculation>) => {
        //
        if (data.length > 0) {
          // this.hasM2u = true;
          this.handicapHistory = data[0];
          this.handicapService.getClubHandicap(data[0].player.playerId).subscribe(
            (data: Array<ClubHandicap>) => {
              this.clubHandicap = data;
              let _homeClubId;
              this.clubHandicap
                .filter(hcp => {
                  return hcp.homeClub;
                })
                .map(hcp => {
                  _homeClubId = hcp.clubInfo.clubId;
                });

              // this.playerClubHcp = this.memberships;
              // this.playerClubHcp.hcpDetail = [];
              // this.memberships.forEach((m: ClubMembership) => {
              //     this.clubHandicap.forEach((ch: ClubHandicap) => {
              //         if(m.club.clubId === ch.clubInfo.clubId) {
              //             m.hcpDetail = ch
              //         }
              //         else {
              //             m.hcpDetail = new ClubHandicap();
              //         }
              //     })
              //     this.playerClubHcp.hcpDetail.push(m.hcpDetail);
              // })

              // if(_loadingCtrl) _loadingCtrl.dismiss().then(()=>{
              //         this._refreshHcpIdxSubscriptions(_loadingCtrl);
              //     })
            },
            error => {
              // if(_loadingCtrl) _loadingCtrl.dismiss().then();
            },
            () => {
              // if(_loadingCtrl) _loadingCtrl.dismiss().then();
            }
          );
        }
        if (this.subHcpHistory) {
          this.subHcpHistory.unsubscribe();
          this.subHcpHistory = null;
        }
      })),
      error => {
        this.handicapHistory = null; //new HandicapCalculation();
        if (this.subHcpHistory) {
          this.subHcpHistory.unsubscribe();
          this.subHcpHistory = null;
        }
        // this.hasM2u = false;
      };
  }

  getCountry(cb) {
    this.playerService.getCountryList().subscribe((data: Array<Country>) => {
      //

      this.countryList = data;
      // this.countryList.push({
      //     id: 'ALL',
      //     name: 'ALL',
      //     flagUrl: 'img/flag/default-worldwide.png'
      // })
      //
    });

    setTimeout(() => {
      cb();
    }, 250);
  }

  getM2uhcp(handicapSystem?: any, attribute?: string) {
    let clubHcp: ClubHandicap;
    let _playerHandicapSystem = handicapSystem;
    if (!this.clubHandicap) return;
    if (!this.homeClubId) return;
    this.clubHandicap
      .filter((c: ClubHandicap) => {
        // if(c.homeClub && c.handicapSystem.id === _playerHandicapSystem) clubHcp = c
        if (!this.isClubSpecific) {
          if (
            this.homeClubId === c.clubInfo.clubId &&
            c.handicapSystem.id === _playerHandicapSystem
          ) {
            clubHcp = c;
            return true;
          }
        } else if (this.isClubSpecific) {
          if (
            this.selClubMembership &&
            this.selClubMembership.club &&
            this.selClubMembership.club.clubId === c.clubInfo.clubId &&
            c.handicapSystem.id === _playerHandicapSystem
          ) {
            clubHcp = c;
            return true;
          } else if (
            this.homeClubId === c.clubInfo.clubId &&
            c.handicapSystem.id === _playerHandicapSystem
          ) {
            clubHcp = c;
            return true;
          }
        }
        // else {
        //     if(this.homeClubId === c.clubInfo.clubId && c.handicapSystem.id === _playerHandicapSystem) {
        //         clubHcp = c;
        //         return true
        //     }
        // }
        // return c.handicap + ' (' + c.clubInfo.clubTag + ')'
      })
      .map((c: ClubHandicap) => {
        clubHcp = c;
      });

    //
    if (clubHcp && attribute === 'hcpOnly') {
      if (clubHcp.handicap) return clubHcp.handicap;
      else return 'n/a';
    } else if (clubHcp && attribute === 'hcpHome') {
      return ' (' + clubHcp.clubInfo.clubTag + ')';
    }
    // else if(clubHcp && attribute === 'hcpIdx') {
    //     return clubHcp.handicapIndex
    // }
    else if (clubHcp) return clubHcp.handicap + ' (' + clubHcp.clubInfo.clubTag + ')';
    else return;
  }

  getNhsHcp(attribute?: string) {
    let _player: PlayerInfo;

    this.player$.pipe(take(1)).subscribe(player => {
      _player = player;
    });
    let clubHcp: ClubHandicap;
    // let _playerHandicapSystem = handicapSystem;
    if (!this.clubHandicap) return;
    if (this.clubHandicap && this.clubHandicap.length === 0) return;
    this.clubHandicap.forEach((c: ClubHandicap) => {
      if (this.appType === 'club' && global.clubId) {
        if (
          c.clubInfo.clubId === this.homeClubId &&
          c.handicapSystem.id.toLowerCase().includes('nhs')
        )
          clubHcp = c;
      } else {
        if (c.homeClub && c.handicapSystem.id.toLowerCase().includes('nhs')) clubHcp = c;
        else clubHcp = null;
      }
      // return c.handicap + ' (' + c.clubInfo.clubTag + ')'
    });

    if (clubHcp && attribute === 'hcpOnly') {
      return clubHcp.handicap;
    } else if (clubHcp && attribute === 'hcpIdx') {
      let _hcpIdx;
      if (clubHcp && clubHcp.handicapIndex) return clubHcp.handicapIndex;
      else if (_player && _player.handicapIndex) return _player.handicapIndex;
    } else if (clubHcp && attribute === 'hcpHome') {
      return ' (' + clubHcp.clubInfo.clubTag + ')';
    } else if (clubHcp) return clubHcp.handicap + ' (' + clubHcp.clubInfo.clubTag + ')';
    else return false;
  }

  onClubPicklist() {
    return new Promise(async (resolve, reject) => {
      let clubId;
      let club = await this.modalCtl.create({
        component: ClubListPage,
        componentProps: {
          openedModal: true,
        },
      });
      club.onDidDismiss().then((data: any) => {
        if (data) {
          clubId = data.data.clubId;
          // this.getClubSession(data.clubId);
        }
        // else if(this.clubId && !data) {
        //     // this.getClubSession(this.clubId)
        // }
        else {
          this.onClubPicklist();
        }
        if (!clubId) {
          reject({
            status: 'failed',
            message: 'No Club Id provided',
          });
        } else if (clubId) {
          this.flightService.getClubInfo(clubId).subscribe((data: ClubInfo) => {
            if (data) {
              resolve({
                status: 'success',
                message: 'club info',
                clubInfo: data,
              });
            }
          });
        }
      });
      club.present();
    });
  }

  async goCaddieMaster() {
    this.onClubPicklist().then(async (result: any) => {
      if (result && result.status === 'success') {
        let params: NavigationExtras = {
          state: {
            clubId: result.clubInfo.clubId,
            fromClub: true,
          },
        };
        this.router.navigate(['tee-flight-lists'], params);
      } else {
        let prompt = await this.alertCtrl.create({
          // Flight Name
          header: 'Enter a club Id to proceed',
          // subTitle: _required,
          message: 'Enter a club Id to proceed',
          inputs: [
            {
              name: 'title',
              placeholder: 'Club Id',
              type: 'number',
            },
          ],
          buttons: [
            {
              text: 'Cancel',
              handler: data => {
                prompt.dismiss().then(() => {
                  // this.keyboard.close();
                });
                return false;
              },
            },
            {
              text: 'Go',
              handler: data => {
                // _required = '';
                if (data.title)
                  prompt.dismiss().then(() => {
                    let params: NavigationExtras = {
                      state: {
                        clubId: data.title,
                      },
                    };
                    this.router.navigate(['tee-flight-lists'], params);
                    // this.nav.push(TeeFlightListsPage, {
                    //   clubId: data.title
                    // });
                  });
                else {
                  // _required = 'Please enter Group Name';
                  // _message = '<br>Please enter the Group Name';
                  let msg = MessageDisplayUtil.getErrorMessage('', 'Please enter Club Id');
                  MessageDisplayUtil.showErrorToast(
                    msg,
                    this.platform,
                    this.toastCtl,
                    5000,
                    'bottom'
                  );
                }
                return false;
              },
            },
          ],
        });
        prompt.present();
      }
    });

    // this.navCtrl.push(TeeFlightListsPage)
  }

  getActiveComps() {
    if (this.subGetHomeInfo) return;

    this.subGetHomeInfo = this.playerService
      .getHomeInfo(this.countryId)
      .pipe(filter(Boolean))
      .subscribe((p: PlayerHomeInfo) => {
        if (p.activeCompetitions) this.activeComp = p.activeCompetitions;
        else if (!p.activeCompetitions) this.activeComp = 0;

        // return this.activeComp
      });
  }

  async goCaddieMarshall() {
    this.onClubPicklist().then(async (result: any) => {
      if (result && result.status === 'success') {
        let params: NavigationExtras = {
          state: {
            clubId: result.clubInfo.clubId,
            userRoles: this.session.user.roles,
            fromClub: true,
          },
        };
        this.router.navigate(['starter-flight-lists'], params);
      } else {
        let prompt = await this.alertCtrl.create({
          // Flight Name
          header: 'Enter a club Id to proceed',
          // subTitle: _required,
          message: 'Enter a club Id to proceed',
          inputs: [
            {
              name: 'title',
              placeholder: 'Club Id',
              type: 'number',
              value: this.isClubSpecific ? this.selClubMembership.club.clubId.toString() : '',
            },
          ],
          buttons: [
            {
              text: 'Cancel',
              handler: data => {
                prompt.dismiss().then(() => {
                  // this.keyboard.close();
                });
                return false;
              },
            },
            {
              text: 'Go',
              handler: data => {
                // _required = '';
                if (data.title)
                  prompt.dismiss().then(() => {
                    let params: NavigationExtras = {
                      state: {
                        clubId: data.title,
                        userRoles: this.session.user.roles,
                      },
                    };
                    this.router.navigate(['starter-flight-lists'], params);
                  });
                else {
                  // _required = 'Please enter Group Name';
                  // _message = '<br>Please enter the Group Name';
                  let msg = MessageDisplayUtil.getErrorMessage('', 'Please enter Club Id');
                  MessageDisplayUtil.showErrorToast(
                    msg,
                    this.platform,
                    this.toastCtl,
                    5000,
                    'bottom'
                  );
                }
                return false;
              },
            },
          ],
        });
        prompt.present();
      }
    });

    // this.nav.push(StarterFlightListsPage)
  }

  async goCaddieList() {
    let prompt = await this.alertCtrl.create({
      // Flight Name
      header: 'Enter a club Id to proceed',
      // subTitle: _required,
      message: 'Enter a club Id to proceed',
      inputs: [
        {
          name: 'title',
          placeholder: 'Club Id',
          type: 'number',
        },
      ],
      buttons: [
        {
          text: 'Cancel',
          handler: data => {
            prompt.dismiss().then(() => {
              // this.keyboard.close();
            });
            return false;
          },
        },
        {
          text: 'Go',
          handler: data => {
            // _required = '';
            if (data.title)
              prompt.dismiss().then(() => {
                let params: NavigationExtras = {
                  state: {
                    clubId: data.title,
                  },
                };
                this.router.navigate(['caddy-list'], params);
                // this.nav.push(CaddyListPage, {
                //   clubId: data.title
                // });
              });
            else {
              // _required = 'Please enter Group Name';
              // _message = '<br>Please enter the Group Name';
              let msg = MessageDisplayUtil.getErrorMessage('', 'Please enter Club Id');
              MessageDisplayUtil.showErrorToast(msg, this.platform, this.toastCtl, 5000, 'bottom');
            }
            return false;
          },
        },
      ],
    });
    prompt.present();
  }

  async goBuggyList() {
    let prompt = await this.alertCtrl.create({
      // Flight Name
      header: 'Enter a club Id to proceed',
      // subTitle: _required,
      message: 'Enter a club Id to proceed',
      inputs: [
        {
          name: 'title',
          placeholder: 'Club Id',
          type: 'number',
        },
      ],
      buttons: [
        {
          text: 'Cancel',
          handler: data => {
            prompt.dismiss().then(() => {
              // this.keyboard.close();
            });
            return false;
          },
        },
        {
          text: 'Go',
          handler: data => {
            // _required = '';
            //
            if (data.title)
              prompt.dismiss().then(() => {
                let params: NavigationExtras = {
                  state: {
                    clubId: data.title,
                  },
                };
                this.router.navigate(['tabs/buggy-list'], params);

                // this.nav.push(BuggyListPage, {
                //   clubId: data.title,
                //   // userRoles: this.userRoles
                // });
              });
            else {
              // _required = 'Please enter Group Name';
              // _message = '<br>Please enter the Group Name';
              let msg = MessageDisplayUtil.getErrorMessage('', 'Please enter Club Id');
              MessageDisplayUtil.showErrorToast(msg, this.platform, this.toastCtl, 5000, 'bottom');
            }
            return false;
          },
        },
      ],
    });
    prompt.present();
  }

  getPlayerData() {
    let country = 'country=' + 'MYS';
    //
    // this.url = Apiurl.playerMain;

    // this.commonProvider.GetMethod(Apiurl.RoutePath + Apiurl.playerMain,country).then(res =>
    //
    // // this.http.get(this.url).subscribe(data => {
    // //
    // // })
  }

  signout() {
    if (global.appType === 'main') this.updateColor(null, true);

    // let _playerId
    // this.player$.pipe(take(1))
    //   .subscribe(player => {
    //     _playerId = player.playerId;
    //     this.storage.removePreference(`CurrentScorecard.${_playerId}`)
    //   });
    //! this was to remove scorecards from other players
    //! this.storage.clearAllPreferences();
    // this.removeUrlParam('compRegister');
    // this.removeUrlParam('register');
    this.setCompClubId(true);
    this.homeClubMembership = null;
    this.isClubSpecific = false;
    this.handicapIndex = null;

    this.totalClubCredits = null;
    this.totalWalletBalance = null;
    this.clearAllStates();
    this.sessionActions.logout();
    // setTimeout(()=>{
    // },250)
  }

  // removeUrlParam(paramToRemove: string) {
  //   const currentUrl = this.router.url;
  //   const urlTree = this.router.parseUrl(currentUrl);

  //   // Remove specific query parameter
  //   delete urlTree.queryParams[paramToRemove];

  //   // Navigate without triggering a route change
  //   this.router.navigateByUrl(urlTree);
  // }
  async setCompClubId(clear?: boolean) {
    let searchCriteriaComp = this.compService.getSearch();
    if (clear) searchCriteriaComp.clubId = null;
    else searchCriteriaComp.clubId = this.selClubMembership?.club?.clubId;
    if (clear) {
      this.mg2uUtil.setPersistClubTheme();
    } else this.mg2uUtil.setPersistClubTheme(String(this.selClubMembership?.club?.clubId));
    this.compService.setSearch(searchCriteriaComp);
    console.debug('comp service - set search - set compClubId', searchCriteriaComp);
  }
  onHomeClick() {
    this.router.navigate(['/tabs/player-home']);
    // this.nav.popToRoot();//this.nav.setRoot(PlayerHomePage);
  }

  // onBookingClick() {

  //   this.router.navigate(['booking-home'])
  // }

  async Menu() {
    if (this.subNewClubMship) return;
    let homeClubMship = null;
    if (!this.subNewClubMship)
      this.getNewClubMembership()
        .then((result: any) => {
          if (result) {
            homeClubMship = result?.find((cm: ClubMembershipExtended) => {
              return cm?.playerHomeClub || cm?.homeClub;
            });
            this.onProceedMenu(homeClubMship);
          }
        })
        .catch(() => {
          this.onProceedMenu();
        });
  }
  async onProceedMenu(homeClubMship?: ClubMembershipExtended) {
    let isNormaleGameOn: boolean;
    this.normalGameOn.subscribe(value => {
      isNormaleGameOn = value;
    });

    let _multipleComps;
    this.multipleComps.pipe(filter(Boolean)).subscribe((a: any) => {
      _multipleComps = a;
    });

    let _normalGameOn;
    this.normalGameOn.pipe(filter(Boolean)).subscribe(a => {
      _normalGameOn = a;
    });

    let _competitionOn;
    this.competitionOn.pipe(filter(Boolean)).subscribe(a => {
      _competitionOn = a;
    });

    let _activeCompsToday;
    this.activeCompsToday.pipe(filter(Boolean)).subscribe(a => {
      _activeCompsToday = a;
    });

    let _singleActiveComp;
    this.singleActiveComp.pipe(filter(Boolean)).subscribe(a => {
      _singleActiveComp = a;
    });

    let _compDetails;
    this.playerHomeInfo$.pipe(take(1)).subscribe((home: PlayerHomeInfo) => {
      console.debug('phi ', home);

      if (home && home.compsActiveToday && home.compsActiveToday.length > 0) {
        let _compId = home.compsActiveToday[0].competitionId;
        _compDetails = home.activeCompetitions;
        this.competitionService.getScoringRoundNumber(_compId).subscribe(data => {
          if (!data || data === 0) return;
        });
      }
    });

    console.log('isNormaleGameOn: ', isNormaleGameOn);
    console.log(
      'isCompOn: ',
      _competitionOn,
      this.multipleComps,
      this.activeComps,
      this.activeCompsToday
    );

    console.debug('home membership [0] ', homeClubMship, this.clubMemberships);
    const modal = await this.modalCtl.create({
      component: HamerburgMenuComponent,
      // cssClass:'homburger-modal',
      backdropDismiss: false,
      cssClass: this.platform.is('mobile')
        ? 'self-adjustable-modal'
        : 'self-adjustable-modal-desktop',
      componentProps: {
        isNormaleGameOn: isNormaleGameOn,
        isCompSingleOrMulti: _activeCompsToday ? (_multipleComps ? 'multi' : 'single') : null,
        isCompOn: _activeCompsToday,
        appAttribute: this.appAttribute,
        menuItems: this.appAttribute?.menuItems,
        homeMembership: homeClubMship,
        // compDetails: _compDetails,
        signout: () => {
          return this.signout();
        },
        main: this.modalCtl,
      },
      mode: 'ios',
    });
    await modal.present();
    modal.onDidDismiss().then((data: any) => {
      this.checkMenuItem(data?.data?.item).then((result: any) => {
        console.debug('promise return : ', result, data.item, this.appAttribute?.menuItems);
        if (result?.hasMenu && !result?.item?.enable) {
          let _message = result?.item?.message || 'Error message';
          MessageDisplayUtil.showErrorToast(_message, this.platform, this.toastCtl, 3000, 'bottom');
          return false;
        } else {
          if (data.data?.selectMenu) {
            console.log(data.data.selectMenu, 'Select Menu');
            switch (data.data.selectMenu) {
              // Booking
              case 'My Bookings':
                this.onBookingMenuClick();
                break;
              case 'Find Tee Times':
                // this.onFindTeeTimes();
                this.onBookingMenuClick(true);
                break;
              case 'Other Facilities':
                this.goFacilityBookings();
                break;
              case 'Stay & Play':
                this.router.navigate(['/package-booking']);
                break;

              // Scoring
              case 'New Game / Score Round':
                this.onPlayGolfClick();
                break;
              case 'Game in progress':
                this.onPlayGolfClick();
                break;
              case 'Find / Join Tournaments':
                this.goCompList();
                break;
              case 'Tournament Scoring':
                this.onCompClick();
                break;
              case 'View Scorecards':
                this.onScorecardMenuClick();
                break;
              case 'Statistics':
                this.onPerformanceMenuClick();
                break;
              case 'Performance at Golf Club':
                this.onAnalysisMenuClick();
                break;

              // Handicap
              case 'National Handicap Subscription':
                this.openHandicapMembership();
                break;
              case 'View Handicap & History':
                this.onHandicapMenuClick();
                break;
              case 'Peer Review':
                this.onHandicapMenuClick(true);
                break;
              case 'Handicap Calculator':
                this.goHandicapCalculator();
                break;

              // Essentials
              case 'Friends':
                this.onFriendMenuClick();
                break;
              case 'Notifications':
                this.onNotificationsClick();
                break;
              case 'Old Membership':
                this.goOldMemberManagement();
                break;
              case 'Membership':
                this.goMemberManagement();
                break;
              case 'Account / eWallet':
                this.onMygolfCredit();
                // this.goRefundRedeemHistory()
                break;
              case 'Discount Profiles':
                // this.goRefundRedeemHistory()
                this.goPlayerVoucher();
                break;

              //Settings
              case 'Help Content':
                this.callHelpPage();
                break;

              //club memberships related
              case 'addMembership':
                this.goMemberManagement(true);
                break;
              case 'viewMembership':
                this.onClickGoClubMembership();
                break;
              case 'updateMembership':
                this.onClickEditClubMembership();
                break;
              case 'otherClubMemberships':
                this.onClickGoClubMembership(false);
                break;
              case 'Matchplay Scoring':
                this.goMatchplayScoring();
                break;
            }
          }
        }
      });
    });
  }
  countrySelected(countryId?: string) {
    this.countryId = countryId;
    // if(this.countrySel && this.countrySel.name !== 'ALL') {

    // (countryId !== '' || countryId !== null)

    if (this.countryList && countryId) {
      this.countrySel = this.countryList
        .filter((c: Country, idx: number) => {
          //
          //
          //
          //
          return c.id === countryId;
        })
        .pop();
    }

    if (this.countrySel) this.updatePreference(this.countrySel);
    // }

    // setTimeout(()=>{
    let searchCriteriaComp = this.compService.getSearch();
    // searchCriteriaComp.countryId = this.countryId;
    this.compService.setSearch(searchCriteriaComp);
    console.debug('comp service - set search country selected', searchCriteriaComp);

    this.getPlayerCredits();
  }

  getPreference() {
    this.updatePreference();
  }

  updatePreference(country?: Country) {
    this.sessionService
      .getSession()
      .pipe(take(1))
      .subscribe((session: SessionInfo) => {
        var objSession = Object.assign({}, session);

        if (country && (country.id === null || country.id === '')) {
          objSession.countryId = null;
          objSession.countryName = 'ALL';
          objSession.flagUrl = 'http://cls-play.mygolf2u.com/img/flag/MAS.png';
        } else if (country) {
          objSession.countryId = country.id;
          objSession.countryName = country.name;
          objSession.flagUrl = country.flagUrl;
        }
        this.session = objSession;
        this.sessionActions.updatePreference(this.session);
      });
  }

  async onChangePreferredOrigin() {
    let modal = await this.modalCtl.create({
      component: CountryListPage,
      componentProps: {
        country: this.countryList,
      },
    });

    modal.onDidDismiss().then((country?: any) => {
      if (country === null || country === -999) {
        this.countryId = '';
        this.countrySel.id = '';
        this.countrySel.name = 'ALL';
        this.countrySel.flagUrl = 'http://cls-play.mygolf2u.com/img/flag/MAS.png';

        this.countrySelected(this.countryId);
        //
      } else {
        let _country: Country = country;

        this.countryId = _country['data'].id;
        //
        // this.countrySelected(_country.id)

        this.countrySelected(country['data'].id);

        setTimeout(() => {
          this.getActiveComps();
        }, 500);
        // adjustViewZIndex(this.nav, this.renderer);
      }
    });
    modal.present();
  }

  // async getCountrieList() {
  //   let token: any = null;
  //   await this.storage.getPreference('authToken').subscribe((value) => {
  //     token = value

  //   })
  //   const headers = new HttpHeaders({
  //     "X-AUTH-TOKEN": token
  //   })

  //   this.http.get(Apiurl.RoutePath + Apiurl.getCountries, { headers: headers }).subscribe((res: any) => {
  //     this.countryList = res;
  //   })
  // }

  async refresh(refresher) {
    if (!refresher) return;
    this.refresher = refresher;
    this.playerHomeActions.refreshHomeInfo();
    //
    if (this.player$ !== null) {
      this.player$.pipe(filter(Boolean)).subscribe((p: PlayerInfo) => {
        this.countryId = p.countryId;
        if (p.addressInfo.countryId) this.countryId = p.addressInfo.countryId;

        this.countrySelected(this.countryId);

        setTimeout(() => {
          this.getActiveComps();
        }, 500);
      });
    }
  }

  async confirmAndExit() {
    if (this.platform.is('capacitor')) {
      this.dialogs
        .confirm('Do you want to exit myGolf2u ?', 'Exit App', ['No', 'Exit'])
        .then((result: any) => {
          if (result && result === 2) {
            navigator['app'].exitApp();
          }
        });
    } else {
      let confirm = await this.alertCtl.create({
        header: 'Exit App',
        message: 'Do you want to exit myGolf2u ?',
        buttons: [
          {
            text: 'No',
            role: 'cancel',
            handler: () => {
              confirm.dismiss(false);
              return false;
            },
          },
          {
            text: 'Exit',
            handler: () => {
              confirm.dismiss(true);
              return false;
            },
          },
        ],
      });
      confirm.onDidDismiss().then(exit => {
        if (exit) navigator['app'].exitApp();
      });
      confirm.present();
    }
  }

  goCompList() {
    if (this.hasParam && this.selectedClub?.clubId)
      this.competitionService.setClubId(this.selectedClub?.clubId);
    else if (this.appType === 'club' && global.clubId) {
      this.competitionService.setClubId(global.clubId);

      // this.competitionService.setSearch({
      //     clubId: global.clubId
      // })
    } else if (this.homeClubMembership)
      this.competitionService.setClubId(
        this.homeClubMembership?.club?.id || this.homeClubMembership?.club?.clubId
      );
    this.playCompClicked = false;
    this.router.navigate(['competition-list']);
    // this.nav.push(CompetitionListPage, {}, {});
  }

  goTeeFlightList() {
    this.router.navigate(['tee-flight-lists']);
  }

  goStarterFlightList() {
    this.router.navigate(['starter-flight-lists']);
  }

  goScoringTest() {
    this.player$.pipe(take(1)).subscribe(player => {
      this.router.navigate(['scoring-test'], {
        queryParams: { playerId: JSON.stringify(player.playerId) },
      });
      // this.nav.push(ScoringTestPage, {
      //     playerId: player.playerId
      // });
    });
  }

  canCreateNewGame(): Observable<boolean> {
    return forkJoin(this.normalGameOn, this.competitionOn, this.multipleComps).pipe(
      map((values: boolean[]) => {
        return !values[0] && !values[1] && !values[2];
      })
    );
    // return !this.normalGameOn && !this.competitionGameOn && !(this.homeInfo.compsActiveToday && this.homeInfo.compsActiveToday.length > 1);
    // return true;
  }

  subCurrentScorecard: Subscription;
  subCompScoring: Subscription;
  playCompClicked: boolean = false;
  async onCompetitionScoringClick() {
    if (this.subCurrentScorecard) return;
    await this.initPageLoader('Getting scorecard. Please wait...');
    // this.playerHomeInfo$.pipe(take(1)).subscribe((home: PlayerHomeInfo) => {

    console.debug('competition scoring click ', this.playerHomeInfo);
    if (
      this.playerHomeInfo &&
      this.playerHomeInfo?.compsActiveToday &&
      this.playerHomeInfo?.compsActiveToday.length > 0
    ) {
      let _compId = this.playerHomeInfo?.compsActiveToday[0].competitionId;
      // this.competitionService.getScoringRoundNumber(_compId).subscribe((data) => {

      //   if (!data || data === 0)
      //     return;
      // })
    }
    // })
    // this.playerHomeService.playerHomeInfo().pipe(take(1),
    //   map(homeInfo => homeInfo.player),
    //   filter(Boolean))
    //   .subscribe(async (player: PlayerInfo) => {
    let loader = await this.loadingCtl.create({
      // cssClass: 'custom-loading-hide',
      message: 'Getting scorecard. Please wait...',
      backdropDismiss: false,
      duration: 3000,
    });
    // await this.pageLoader.present().then(()=>{

    // // Programmatically remove the backdrop
    // const loadingElement = await this.loadingCtl.getTop();
    // const backdropElement = loadingElement?.shadowRoot?.querySelector('.backdrop-no-tappable');

    // if (backdropElement && backdropElement instanceof HTMLElement) {
    //   backdropElement.style.background = 'transparent';
    //   backdropElement.style.pointerEvents = 'none';
    // }
    // (await loader).present().then(() => {

    let _compId;
    // this.playerHomeInfo$.pipe(

    // tap(value => console.log('Before filter:', value)),
    // filter(Boolean),
    // tap(value => console.log('After filter:', value))
    // ).subscribe((a: PlayerHomeInfo) => {
    if (this.playerHomeInfo?.compsActiveToday && this.playerHomeInfo?.compsActiveToday.length > 0) {
      _compId = this.playerHomeInfo?.compsActiveToday[0].competitionId;
      this.subCurrentScorecard = this.scorecardService.getCurrentScorecard().subscribe(
        (scorecard: PlainScoreCard) => {
          if (scorecard?.competition && !scorecard?.finished && scorecard?.dirty) {
            this.competitionService.getCompetitionInfo(_compId).subscribe(
              async (comp: CompetitionInfo) => {
                let navigationExtras: NavigationExtras = {
                  state: {
                    scorecard: scorecard,
                    competition: comp,
                    currentPlayer: this.playerHomeInfo?.player,
                    compId: comp?.competitionId || _compId,
                  },
                };
                if (this.playCompClicked) {
                  this.playCompClicked = false;
                  await this.router
                    .navigate(['gameround-scoring'], navigationExtras)
                    .then(async () => {
                      this.onDismissPageLoader();
                    });
                }
              },
              error => {
                this.playCompClicked = false;
              }
            );
          } else {
            _compId = this.playerHomeInfo?.compsActiveToday[0].competitionId;
            console.debug(
              'getting scorecard info : ',
              _compId,
              this.playerHomeInfo?.player,
              loader,
              this.playerHomeInfo?.player
            );

            this.playerHomeActions.getCompetitionScoring(
              _compId,
              this.playerHomeInfo?.player?.playerId,
              loader
            );
            let getScorecard = setTimeout(() => {
              if (this.subCurrentScorecard) return;
              this.subCurrentScorecard = this.scorecardService.getCurrentScorecard().subscribe(
                (scorecard: PlainScoreCard) => {
                  console.debug('getting scorecard info [2] : ', scorecard);
                  if (scorecard) {
                    clearTimeout(getScorecard);
                    this.competitionService.getCompetitionInfo(_compId).subscribe(
                      async (comp: CompetitionInfo) => {
                        // loader.dismiss().then(() => {
                        this.currentScorecardActions.setScoringPlayer(
                          this.playerHomeInfo?.player.playerId
                        );
                        let navigationExtras: NavigationExtras = {
                          state: {
                            scorecard: scorecard,
                            competition: comp,
                            currentPlayer: this.playerHomeInfo?.player,
                            compId: comp?.competitionId || _compId,
                          },
                        };
                        if (this.playCompClicked) {
                          this.playCompClicked = false;
                          await this.router
                            .navigate(['gameround-scoring'], navigationExtras)
                            .then(async () => {
                              this.onDismissPageLoader();
                              // this.router.events.subscribe(async event => {
                              //   console.debug("trying to dismiss : ", event, (event instanceof NavigationEnd))
                              //   // if (event instanceof NavigationEnd) {
                              //   //   // if (this.pageLoader)
                              //   // }
                              // });
                            });
                        } // this.nav.push(GameRoundScoringPage, {
                        //     scorecard    : scorecard,
                        //     competition  : comp,
                        //     currentPlayer: player
                        // })
                        // });
                      },
                      async error => {
                        if (loader) (await loader).dismiss();
                        // clearInterval(getScorecard);
                      },
                      async () => {
                        // if (loader) (await loader).dismiss();
                      }
                    );
                  }
                  if (this.subCurrentScorecard) {
                    this.subCurrentScorecard.unsubscribe();
                    this.subCurrentScorecard = null;
                  }
                },
                error => {
                  this.playCompClicked = false;
                  if (this.subCurrentScorecard) {
                    this.subCurrentScorecard.unsubscribe();
                    this.subCurrentScorecard = null;
                  }
                }
              );
            }, 500);
          }
          if (this.subCurrentScorecard) {
            this.subCurrentScorecard.unsubscribe();
            this.subCurrentScorecard = null;
          }
        },
        error => {
          if (this.subCurrentScorecard) {
            this.subCurrentScorecard.unsubscribe();
            this.subCurrentScorecard = null;
          }
        }
      );
    }
    // });

    // });
    // })
    // });
  }

  goFeedbackPage() {
    this.router.navigate(['feedback']);
    // this.nav.push(FeedbackPage);
  }

  onBookingMenuClick(startBooking: boolean = false, event?) {
    // if(this.playCompClicked) return;
    console.debug('on booking click', this.playCompClicked, this.pageLoader);

    if (!this.isBookingRegistrationEnabled) {
      MessageDisplayUtil.showErrorToast(
        'Booking & Registration feature will be coming soon.',
        this.platform,
        this.toastCtl,
        3000,
        'bottom'
      );
      return false;
    }
    let _isClubSpecific;
    let _club;
    if (this.isClubSpecific) {
      if (this.hasParam) _club = this.selectedClub;
      else if (this.homeClubMembership) _club = this.homeClubMembership.club;
      else if (this.selClubMembership) _club = this.selClubMembership.club;
      _isClubSpecific = this.isClubSpecific;
    } else {
      _isClubSpecific = false;
      _club = null;
    }
    if (!startBooking) {
      let params: NavigationExtras = {
        state: {
          userType: 'player',
          isClubSpecific: _isClubSpecific,
          club: _club,
          clubSpecificThemes: this.appAttribute.clubSpecificThemes,
        },
      };
      this.router.navigate(['booking-home'], params);
    } else {
      let params: NavigationExtras = {
        state: {
          userType: 'player',
        },
      };
      this.router.navigate(['find-tee-times'], params);
      // startDate: this.startDate,
      // fromTime: this.fromTime,
      // toTime: this.toTime,
      // filterCountry: this.filterCountry,
      // selectClubType: this.selectClubType,
      // isClubSpecific: this.isClubSpecific,
      // userType: this.userType,
      // countryList: this.countryList,
      // filteredLocation: this.filteredLocation,
      // courseInfo: this.courseInfo,
      // courseType: this.courseType,
      // searchDistance: this.searchDistance,
      // clubInfo: this.clubInfo,
      // appAttribute: this.appAttribute,
      // geo: this.geo,
      // botsOut: this.botsOut,
      // captchaResponse: this.captchaResponse
    }
  }

  async onFindTeeTimes() {
    let _params: NavigationExtras = {
      state: {
        startDate: moment().add(1, 'd').format('YYYY-MM-DD'),
        fromTime: '07:00',
        toTime: '19:00',
        filterCountry: 'MYS',
        selectClubType: 'allClubs',
        isClubSpecific: this.isClubSpecific,
        // userType: this.userType,
        countryList: this.countryList,
        filteredLocation: '', // this.filteredLocation,
        courseInfo: '', //this.courseInfo,
        courseType: '', //this.courseType,
        searchDistance: '', //this.searchDistance,
        clubInfo: '', //this.clubInfo,
        appAttribute: this.appAttribute,
        geo: '', //this.geo,
        botsOut: '', //this.botsOut,
        captchaResponse: '', //this.captchaResponse
      },
    };
    // console.log('open search tee time [appAttr] : ', this.appAttribute);
    // console.log('open search tee time [clubInfo] : ', this.clubInfo);
    // const modal = await this.modalCtl.create({
    //   component: SearchTeeTimeComponent,
    //   cssClass: 'search-tee-time-modal',
    //   componentProps: {
    //     startDate: this.startDate,
    //     fromTime: this.fromTime,
    //     toTime: this.toTime,
    //     filterCountry: this.filterCountry,
    //     selectClubType: this.selectClubType,
    //     isClubSpecific: this.isClubSpecific,
    //     userType: this.userType,
    //     countryList: this.countryList,
    //     filteredLocation: this.filteredLocation,
    //     courseInfo: this.courseInfo,
    //     courseType: this.courseType,
    //     searchDistance: this.searchDistance,
    //     clubInfo: this.clubInfo,
    //     appAttribute: this.appAttribute,
    //     geo: this.geo,
    //     botsOut: this.botsOut,
    //     captchaResponse: this.captchaResponse
    //   },
    //   mode: 'ios'
    // });

    let params = {
      // startDate: this.startDate,
      // fromTime: this.fromTime,
      // toTime: this.toTime,
      // filterCountry: this.filterCountry,
      // selectClubType: this.selectClubType,
      // isClubSpecific: this.isClubSpecific,
      // userType: this.userType,
      // countryList: this.countryList,
      // filteredLocation: this.filteredLocation,
      // courseInfo: this.courseInfo,
      // courseType: this.courseType,
      // searchDistance: this.searchDistance,
      // clubInfo: this.clubInfo,
      // appAttribute: this.appAttribute,
      // geo: this.geo,
      // botsOut: this.botsOut,
      // captchaResponse: this.captchaResponse
    };

    this.router.navigate(['find-tee-times'], params);

    // await modal.present();

    // modal.onDidDismiss().then(data => {});
  }
  onHandicapMenuClick(peerReview?: boolean) {
    let subsActive: boolean = false;
    if (this.hcpIdxSubs && this.hcpIdxSubs.active) {
      subsActive = true;
    }

    this.playerHomeService
      .playerHomeInfo()
      .pipe(
        take(1),
        map(homeInfo => homeInfo.player)
      )
      .subscribe(player => {
        let params: NavigationExtras = {
          state: {
            currentPlayer: player,
            fromMenu: 'menu',
            subsActive: subsActive,
            player: player,
            peerReviewMode: peerReview,
          },
        };

        this.router.navigate(['/tabs/pre-2020'], params);
        // this.nav.push(HandicapHistoryPage, {
        //     currentPlayer: player,
        //     fromMenu: 'menu',
        //     subsActive: subsActive,
        //     player: player,
        // });
      });
  }
  async onCompClick() {
    if (!this.checkAndDisplayConnection()) return;
    console.debug(
      'on comp click ',
      this.pageLoader,
      this.playCompClicked,
      this.playCompClicked,
      this.hasActiveCompsToday()
    );
    if (this.playCompClicked) return;
    this.playCompClicked = true;
    let _multipleComps;
    this.multipleComps.pipe(filter(Boolean)).subscribe((a: any) => {
      // if(a.compsActiveToday && a.compsActiveToday.length > 1)
      //     _multipleComps = true;
      if (this.isClubSpecificCompetition().length > 1) _multipleComps = a;
      else if (!this.isClubSpecific) _multipleComps = a;
      else _multipleComps = false;
    });

    let _normalGameOn;
    this.normalGameOn.pipe(filter(Boolean)).subscribe(a => {
      _normalGameOn = a;
    });

    let _competitionOn;
    this.competitionOn.pipe(filter(Boolean)).subscribe(a => {
      _competitionOn = a;
      if (this.isClubSpecificCompetition().length > 0) _competitionOn = a;
      else if (!this.isClubSpecific) _competitionOn = a;
      else _competitionOn = false;
    });

    let _activeCompsToday;
    this.activeCompsToday.pipe(filter(Boolean)).subscribe(a => {
      if (this.isClubSpecificCompetition().length > 0) _activeCompsToday = a;
      else if (!this.isClubSpecific) _activeCompsToday = a;
      else _activeCompsToday = false;
    });

    let _singleActiveComp;
    this.singleActiveComp.pipe(filter(Boolean)).subscribe(a => {
      if (this.isClubSpecificCompetition().length > 0) _singleActiveComp = a;
      else if (!this.isClubSpecific) _singleActiveComp = a;
      else _singleActiveComp = false;
    });

    let _continue: boolean = true;
    if (1) {
      // this.getCompetitionD
      // await this.playerHomeInfo$.pipe(filter(Boolean)).subscribe(async (a: PlayerHomeInfo) => {
      console.debug('active comps today [0] ', this.playerHomeInfo);
      let _compId = 0;
      if (this.playerHomeInfo?.compsActiveToday?.length === 1)
        _compId = this.playerHomeInfo?.compsActiveToday[0]?.competitionId;

      // if(this.playerHomeInfo?.compsActiveToday?.length > 0)
      await this.checkWhetherCompMatch(this.playerHomeInfo?.compsActiveToday[0]).then(
        async (cont: any) => {
          _continue = cont;
          if (_continue) {
            if (_normalGameOn && (_activeCompsToday || _multipleComps)) {
              // || _competitionOn
              this.onPromptNormalGameDelete().then(async (result: any) => {
                console.debug('on prompt delete ', result);
                if (result) {
                  if (_activeCompsToday || _multipleComps) {
                    // _competitionOn ||
                    if (1) {
                      //! new
                      if (_multipleComps) this.onSelectCompetitionScoring();
                      else {
                        await this.initPageLoader('Getting scorecard. Please wait...');
                        this.pageLoader.present();
                        this.onCompetitionScoringClick();
                      }
                    } else if (0) {
                      if (_multipleComps) this.onScoringClick('multiple');
                      else this.onScoringClick('comp-click');
                    }
                  } else this.goCompList();
                }
              });
            } else {
              if (_activeCompsToday || _multipleComps) {
                // _competitionOn  ||

                if (1) {
                  //! new
                  if (_multipleComps) this.onSelectCompetitionScoring();
                  else {
                    await this.initPageLoader('Getting scorecard. Please wait...');
                    this.pageLoader.present();
                    this.onCompetitionScoringClick();
                  }
                } else if (0) {
                  if (_multipleComps) this.onScoringClick('multiple');
                  else this.onScoringClick('comp-click');
                }
              } else this.goCompList();
            }
          }
        }
      );
      // });
    }

    // this.router.navigate(['/tabs/competition-list'])
  }

  async onPromptNormalGameDelete() {
    return new Promise(async (resolve, reject) => {
      const modal = await this.modalCtl.create({
        mode: 'ios',
        component: CommonPullupMenuComponent,
        cssClass: 'self-adjustable-modal',
        componentProps: {
          mode: 'negative-confirmation',
          headerTitle: 'Active Scorecard Found',
          confirmMessage:
            'You have an active scorecard for a normal round. Tapping <b>Yes</b> will remove your active scorecard.<br><br>Tap <b>No</b> if you want to first save your active Scorecard.',
        },
      });
      await modal.present().then(() => {
        const height = this.platform.height() - 250;
        if (document.getElementsByClassName('inner-content')[0])
          document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
      });
      modal.onDidDismiss().then((data: any) => {
        console.debug('pullup dismiss', data);
        if (data?.data) {
          resolve(true);
        } else resolve(false);
      });

      // let prompt = await this.alertCtrl.create({
      //   header: 'Normal Game local scorecard found',
      //   message: 'There is ongoing Normal game scorecard. This will override the scorecard with Competition scorecard. Do you want to proceed?',
      //   buttons: [{
      //     text: 'No',
      //     handler: data => {
      //       prompt.dismiss().then(() => {
      //         // this.keyboard.close();
      //       });
      //       resolve(false)
      //     }
      //   },
      //   {
      //     text: 'Yes',
      //     handler: () => {
      //       resolve(true)
      //     }
      //   }
      //   ]
      // });
      // prompt.present();
    });
  }

  onPerformanceMenuClick() {
    this.router.navigate(['/tabs/performance']);
  }

  onAnalysisMenuClick() {
    // private playerPerformanceService: PlayerPerformanceService,
    //   this.playerPerformanceService.setPerformanceFilter(18, null);

    // let params: NavigationExtras = {
    //     state: {
    //         fromPerformance : true,
    //         needRefresh: true
    //     }
    //   }
    //     this.router.navigate(['/tabs/HoleAnalysis'], params)

    this.router.navigate(['hole-analysis']);
  }

  openProfile() {
    //this.router.navigate(['tabs/profile'], { queryParams: { type: 'playerProfile'} });
    let navigationExtras: NavigationExtras = {
      state: {
        type: 'playerProfile',
        player: this.player$,
      },
    };
    // this.router.navigate(['tabs/profile'], navigationExtras);
    this.router.navigate(['tabs/profile'], { queryParams: navigationExtras });
    //
    // // const params: NavigationExtras = {
    // //   state: {
    // //     type: 'playerProfile',
    // //     player: this.player$
    // //   }
    // // };

    // //
    // // this.router.navigate(['tabs/profile'], params);

    // let params: NavigationExtras = {
    //   state: {
    //     type: 'playerProfile',
    //     player: this.player$
    //   },
    // };
    // this.router.navigate(['tabs/profile'], params);
  }

  async goBookingChart() {
    let prompt = await this.alertCtrl.create({
      // Flight Name
      header: 'Enter a club Id to proceed',
      // subTitle: _required,
      message: 'Enter a club Id to proceed',
      inputs: [
        {
          name: 'title',
          placeholder: 'Club Id',
          type: 'number',
        },
      ],
      buttons: [
        {
          text: 'Cancel',
          handler: data => {
            prompt.dismiss().then(() => {
              // this.keyboard.close();
            });
            return false;
          },
        },
        {
          text: 'Go',
          handler: data => {
            // _required = '';
            if (data.title)
              prompt.dismiss().then(() => {
                //this.router.navigate(['booking-chart'], { queryParams: { clubId: JSON.stringify(data.title) } })
                // this.nav.push(BookingChartPage, {
                //   clubId: data.title
                // });

                let params: NavigationExtras = {
                  state: {
                    clubId: data.title,
                  },
                };

                this.router.navigate(['tabs/booking-chart'], params);
              });
            else {
              // _required = 'Please enter Group Name';
              // _message = '<br>Please enter the Group Name';
              let msg = MessageDisplayUtil.getErrorMessage('', 'Please enter Club Id');
              MessageDisplayUtil.showErrorToast(msg, this.platform, this.toastCtl, 5000, 'bottom');
            }
            return false;
          },
        },
      ],
    });
    prompt.present();
  }

  async goClubBooking() {
    // this.nav.push(BookingCalendarPage);
    let prompt = await this.alertCtrl.create({
      // Flight Name
      header: 'Enter a club Id to proceed',
      // subTitle: _required,
      message: 'Enter a club Id to proceed',
      inputs: [
        {
          name: 'title',
          placeholder: 'Club Id',
          type: 'number',
        },
      ],
      buttons: [
        {
          text: 'Cancel',
          handler: data => {
            prompt.dismiss().then(() => {
              // this.keyboard.close();
            });
            return false;
          },
        },
        {
          text: 'Go',
          handler: data => {
            prompt.dismiss().then(() => {
              // this.router.navigate(['booking-calendar'], {
              //   queryParams: {
              //     clubId: JSON.stringify(data.title),
              //     fromClub: true
              //   }
              // })

              let params: NavigationExtras = {
                state: {
                  clubId: data.title,
                  fromClub: true,
                },
              };

              this.router.navigate(['booking-calendar'], params);
              // this.nav.push(BookingCalendarPage, {
              //   clubId: data.title,
              //   fromClub: true,
              // });
            });
            // if (data.title)
            //               prompt.dismiss().then(()=> {
            //                 this.nav.push(BookingCalendarPage, {
            //                     clubId: data.title
            //                 })
            //               })
            // else {
            //     // _required = 'Please enter Group Name';
            //     // _message = '<br>Please enter the Group Name';
            //     let msg = MessageDisplayUtil.getErrorMessage('', "Please enter Club Id");
            //     MessageDisplayUtil.showErrorToast(msg, this.platform, this.toastCtl,
            //         5000, "bottom");
            // }
            return false;
          },
        },
      ],
    });
    prompt.present();
    // this.nav.push(ClubCalendarComponent);
  }

  async goUserManagement() {
    // this.nav.push(BookingCalendarPage);
    let prompt = await this.alertCtrl.create({
      // Flight Name
      header: 'Enter a club Id to proceed',
      // subTitle: _required,
      message: 'Enter a club Id to proceed',
      inputs: [
        {
          name: 'title',
          placeholder: 'Club Id',
          type: 'number',
        },
      ],
      buttons: [
        {
          text: 'Cancel',
          handler: data => {
            prompt.dismiss().then(() => {
              // this.keyboard.close();
            });
            return false;
          },
        },
        {
          text: 'Go',
          handler: data => {
            prompt.dismiss().then(() => {
              // this.router.navigate(['club-home/club-user-management'], {
              //   queryParams: { clubId: JSON.stringify(data.title) }
              // })

              let params: NavigationExtras = {
                state: {
                  clubId: data.title,
                },
              };
              this.router.navigate(['tabs/club-user-management'], params);
              return false;
            });
          },
        },
      ],
      // this.nav.push(ClubCalendarComponent);
    });
    prompt.present();
  }

  onMyBookingsClick() {
    this.router.navigate(['booking-home']);
  }

  onFAQClick() {
    this.router.navigate(['faq']);
  }

  onNotificationsClick() {
    this.router.navigate(['/tabs/notifications']);
  }

  async editPhoto() {
    let modal = await this.modalCtl.create({
      component: ProfileImageEditComponent,
      componentProps: {
        player: this.player$,
      },
    });
    modal.onDidDismiss().then((data: any) => {
      this.refreshHome(null);
      // if(data === true) {
      // }
      // setTimeout(()=> {
      //
      //     // this.refreshHome(null);
      // }, 500)
    });
    modal.present();
  }

  getPlayGolfBorderClass(type?: string) {
    let _multipleComps;
    this.multipleComps.pipe(filter(Boolean)).subscribe((a: any) => {
      // PlayerHomeInfo
      //
      _multipleComps = a;
      // if(a.compsActiveToday && a.compsActiveToday.length > 1)
      //     _multipleComps = true;
    });
    // this.multipleComps.take(1).subscribe((a: any)=>{
    //
    //     if(a.compsActiveToday && a.compsActiveToday.length > 1)
    //         _multipleComps = true;
    // })

    let _normalGameOn;
    this.normalGameOn.pipe(filter(Boolean)).subscribe(a => {
      _normalGameOn = a;
    });

    let _competitionOn;
    this.competitionOn.pipe(filter(Boolean)).subscribe(a => {
      _competitionOn = a;
    });

    let _activeCompsToday;
    this.activeCompsToday.pipe(filter(Boolean)).subscribe(a => {
      _activeCompsToday = a;
    });

    let _singleActiveComp;
    this.singleActiveComp.pipe(filter(Boolean)).subscribe(a => {
      _singleActiveComp = a;
    });
    if (type === 'style') {
      //
      //
      //
      //

      // if(!(_normalGameOn) && !(_competitionOn) && _activeCompsToday !== 1) return ''
      // if(_activeCompsToday=== 1 && _normalGameOn) return 'red'
      // else if(_competitionOn) return 'red'
      // else if(_normalGameOn) return 'red'
      if (_normalGameOn) return 'red';
      // else if(_multipleComps) return 'blue'
      else return '';
    }
    // let _class;
    // if(this.normalGameOn)
    //     _class = " blink_me" ;
    return 'home-box-inner';
    // + " blink_me"
  }

  isClubSpecificCompetition() {
    console.debug(
      'is club spec comp [0] ',
      this.isClubSpecific,
      this.selClubMembership,
      this.selectedClub,
      this.homeClubMembership
    );
    if (!this.isClubSpecific) return [];
    let _filteredComps = [];
    let _clubId = null;
    if (this.selClubMembership) _clubId = this.selClubMembership.club.clubId;
    else if (this.selectedClub) _clubId = this.selectedClub.clubId;
    else if (this.homeClubMembership)
      _clubId = this.homeClubMembership?.club.id || this.homeClubMembership?.club.clubId;
    console.debug('is club spec comp ', _clubId, this.isClubSpecific);
    this.playerHomeInfo$.subscribe(phi => {
      if (phi && phi.activeCompetitions > 0) {
        _filteredComps = phi.compsActiveToday.filter(comp => {
          return comp.clubId === _clubId;
        });
        if (_filteredComps && _filteredComps.length > 0) phi.compsActiveToday = _filteredComps;
      }
    });

    return _filteredComps;
  }

  getCompBorderClass(type?: string) {
    let _multipleComps;
    this.multipleComps.pipe(filter(Boolean)).subscribe((a: any) => {
      // PlayerHomeInfo
      // if(a.compsActiveToday && a.compsActiveToday.length > 1)
      //     _multipleComps = true;
      if (this.isClubSpecificCompetition().length > 1) _multipleComps = a;
      else if (!this.isClubSpecific) _multipleComps = a;
      else _multipleComps = false;
    });
    let _competitionOn;
    this.competitionOn.pipe(filter(Boolean)).subscribe(a => {
      _competitionOn = a;
    });

    let _activeCompsToday;
    this.activeCompsToday.pipe(filter(Boolean)).subscribe(a => {
      // _activeCompsToday = a
      if (this.isClubSpecificCompetition().length > 0) _activeCompsToday = a;
      else if (!this.isClubSpecific) _activeCompsToday = a;
      else _activeCompsToday = false;
    });

    let _singleActiveComp;
    this.singleActiveComp.pipe(filter(Boolean)).subscribe(a => {
      // _singleActiveComp = a
      if (this.isClubSpecificCompetition().length > 0) _singleActiveComp = a;
      else if (!this.isClubSpecific) _singleActiveComp = a;
      else _singleActiveComp = false;
    });

    //
    //
    //
    //
    if (type === 'style') {
      // if(_activeCompsToday=== 1 && _normalGameOn) return 'red'
      if (_activeCompsToday === 1) return 'red';
      // _competitionOn &&
      // else if(_normalGameOn) return 'red'
      else if (_multipleComps) return 'blue';
      else return '';
    }
    // let _class;
    // if(this.normalGameOn)
    //     _class = " blink_me" ;
    return 'home-box-inner';
    // + " blink_me"
  }

  getPlayGolfImageClass(type?: string) {
    let _multipleComps;
    this.multipleComps.pipe(filter(Boolean)).subscribe((a: any) => {
      // if(a.compsActiveToday && a.compsActiveToday.length > 1)
      //     _multipleComps = true;
      _multipleComps = a;
    });

    let _normalGameOn;
    this.normalGameOn.pipe(filter(Boolean)).subscribe(a => {
      _normalGameOn = a;
    });

    let _competitionOn;
    this.competitionOn.pipe(filter(Boolean)).subscribe(a => {
      _competitionOn = a;
    });

    let _activeCompsToday;
    this.activeCompsToday.pipe(filter(Boolean)).subscribe(a => {
      _activeCompsToday = a;
    });

    let _singleActiveComp;
    this.singleActiveComp.pipe(filter(Boolean)).subscribe(a => {
      _singleActiveComp = a;
    });
    //
    let _class = '';
    if (!_normalGameOn && !_competitionOn && _activeCompsToday !== 1) _class = '';
    // else if(_competitionOn) _class = " filter-red" + " blink_me"
    // else if(_multipleComps) _class = " filter-blue" + " blink_me"
    else if (_normalGameOn) _class = ' filter-red' + ' blink_me';
    // else if(_activeCompsToday === 1 && _normalGameOn)
    //     _class = " filter-red" + " blink_me";
    else _class = '';
    // if(type==='style')
    return 'home-image-play-golf' + _class;
    // else return 'home-image'
  }

  getCompImageClass(type?: string) {
    let _multipleComps;
    this.multipleComps.pipe(filter(Boolean)).subscribe((a: any) => {
      // if(a.compsActiveToday && a.compsActiveToday.length > 1)
      //     _multipleComps = true;
      if (this.isClubSpecificCompetition().length > 1) _multipleComps = a;
      else if (!this.isClubSpecific) _multipleComps = a;
      else _multipleComps = false;
    });
    let _competitionOn;
    this.competitionOn.pipe(filter(Boolean)).subscribe(a => {
      _competitionOn = a;
    });

    let _activeCompsToday;
    this.activeCompsToday.pipe(filter(Boolean)).subscribe(a => {
      // _activeCompsToday = a

      if (this.isClubSpecificCompetition().length > 0) _activeCompsToday = a;
      else if (!this.isClubSpecific) _activeCompsToday = a;
      else _activeCompsToday = false;
    });

    let _singleActiveComp;
    this.singleActiveComp.pipe(filter(Boolean)).subscribe(a => {
      // _singleActiveComp = a

      if (this.isClubSpecificCompetition().length > 0) _singleActiveComp = a;
      else if (!this.isClubSpecific) _singleActiveComp = a;
      else _singleActiveComp = false;
    });
    //
    let _class = '';
    if (_activeCompsToday === 1) _class = ' filter-red' + ' blink_me';
    else if (_multipleComps) _class = ' filter-blue' + ' blink_me';
    else _class = '';
    // if(type==='style')
    return 'home-image-play-golf' + _class;
    // else return 'home-image'
  }
  onPackageBooking() {}

  subNormalGameOn: Subscription;
  playGolfClicked: boolean = false;
  onPlayGolfClick() {
    if (this.playCompClicked) return;
    this.playGolfClicked = true;

    let _multipleComps;
    this.multipleComps.pipe(filter(Boolean)).subscribe((a: any) => {
      // if(a.compsActiveToday && a.compsActiveToday.length > 1)
      //     _multipleComps = true;
      _multipleComps = a;
    });

    let _normalGameOn;
    this.normalGameOn.pipe(filter(Boolean)).subscribe(a => {
      _normalGameOn = a;
    });

    let _competitionOn;
    this.competitionOn.pipe(filter(Boolean)).subscribe(a => {
      _competitionOn = a;
    });

    let _activeCompsToday;
    this.activeCompsToday.pipe(filter(Boolean)).subscribe(a => {
      _activeCompsToday = a;
    });

    let _singleActiveComp;
    this.singleActiveComp.pipe(filter(Boolean)).subscribe(a => {
      _singleActiveComp = a;
    });

    console.debug('play golf click ', _normalGameOn);
    if (!_normalGameOn) {
      this.onNewRoundMenuClick();
    } else if (_normalGameOn) {
      console.debug('normal game on ');
      this.onNormalGameScoringClick();
    }
  }

  onSelectCompetitionScoring() {
    let _playerHomeInfo;
    let _player: PlayerInfo;

    this.playerHomeInfo$.pipe(filter(Boolean)).subscribe((homeInfo: PlayerHomeInfo) => {
      _playerHomeInfo = homeInfo;
    });

    this.player$.pipe(take(1)).subscribe(player => {
      _player = player;
    });

    let _params: NavigationExtras = {
      state: {
        homeInfo: _playerHomeInfo, // this.playerHomeInfo$, // JSON.stringify(this.playerHomeInfo$),
        fromMultiple: true, //JSON.stringify(true)
        player: _player,
      },
    };
    this.playCompClicked = false;
    this.playGolfClicked = false;
    this.router.navigate(['competition-scoring'], _params);

    // {
    //   queryParams: {
    //     homeInfo: JSON.stringify(this.playerHomeInfo$),
    //     fromMultiple: JSON.stringify(true)
    //   }
    // }

    // this.nav.push(CompetitionScoring, {
    //     homeInfo: this.playerHomeInfo$,
    //     fromMultiple: true,
    // });
  }

  private deviceUnlocked(msg: any) {
    let players: number[] = msg['flightMembers'];
    // if(players && this.homeInfo && this.homeInfo.playerId){
    //     let count  = players.filter(v=>v===this.homeInfo.playerId).length;
    //     if(count) this.refreshHome(null);
    // }
  }

  async onScoringClick(type: string) {
    let _title;
    let _message;
    if (type === 'multiple') {
      _title = 'Multiple competitions';
      _message = 'You have multiple active tournaments. Would you like to select one?';
    } else if (type === 'single') {
      //     <p class="competition-name"><i class="fa fa-flag ph-fa" aria-hidden="true"></i>
      //     {{(selectedCompetition$|async)?.competitionName}}
      //     {{"PlayerHomePage.isInProgress"|translate}}
      // </p>
      // <p class="go-scoring">Tee-off at {{(selectedCompetition$|async)?.startTime}} from hole
      //     {{(selectedCompetition$|async)?.startingHole}}. {{"PlayerHomePage.clickHereScoring"|translate}}</p>
      let _comp;
      let _compName;
      let _teeOffTime;
      let _startHole;
      let _clubName;

      // _compName =
      this.playerHomeInfo$.pipe(filter(Boolean)).subscribe((homeInfo: PlayerHomeInfo) => {
        // if(homeInfo.compsActiveToday && homeInfo.compsActiveToday.length === 1)
        //     return homeInfo.compsActiveToday[0].competitionName;
        // else return '';
        if (homeInfo.compsActiveToday && homeInfo.compsActiveToday.length === 1) {
          _compName = homeInfo.compsActiveToday[0].competitionName;
          _clubName = homeInfo.compsActiveToday[0].clubName;
        }
      });
      // .map((homeInfo: PlayerHomeInfo)=>{
      //     if(homeInfo.compsActiveToday && homeInfo.compsActiveToday.length === 1)
      //         return homeInfo.compsActiveToday[0].competitionName;
      //     else return '';
      // });

      // _comp =
      // if(!_compName)
      // this.selectedCompetition$.filter(Boolean).subscribe((a: SelectedCompetition)=>{
      // //
      // //     if(a) {

      //         _compName = a.competitionName
      //         _teeOffTime = a.startTime
      //         _startHole = a.startingHole
      // //     }
      // })
      // if(!_clubName)
      // this.currentGameClub.filter(Boolean).subscribe((c)=>{
      //     _clubName = c
      // })

      // this.selectedCompetition$.filter(Boolean)
      // .map((competition: any)=>{
      //         return competition[0]
      // });

      _title = 'Competition in progress';
      _message =
        `You are registered to play in <br><b>` +
        _compName +
        '</b><br>at <b>' +
        _clubName +
        `</b>` +
        `.<br>
        Would you like to view scorecard now or search other tournaments?`;
      // _message = `You are registered to play in <b>`+_clubName+`</b>, Tee-off at <b>`+_teeOffTime+`</b> starting on hole <b>`+_startHole+`</b>.<br>
      // You are a scorer, would you like to score now or search other tournaments?`;
      // _message = `Competition <b>`+ _compName +`</b> is in progress.<br>` + `<br>Playing in <b>`+_clubName+`</b><br>`+
      // `Tee-off at <b>` + _teeOffTime+ `</b> from hole <b>`+ _startHole +`</b>`+
      // `<br>You are the scorer, tap Go to start or finish`;
    } else if (type === 'comp-in-progress') {
      let _compName;

      this.playerHomeInfo$.pipe(filter(Boolean)).subscribe((homeInfo: PlayerHomeInfo) => {
        // if(homeInfo.compsActiveToday && homeInfo.compsActiveToday.length === 1)
        //     return homeInfo.compsActiveToday[0].competitionName;
        // else return '';
        if (homeInfo.compsActiveToday && homeInfo.compsActiveToday.length === 1) {
          _compName = homeInfo.compsActiveToday[0].competitionName;
        }
      });
      // _compName = this.playerHomeInfo$
      // .filter(Boolean)
      // .map((homeInfo: PlayerHomeInfo)=>{
      //     if(homeInfo.compsActiveToday && homeInfo.compsActiveToday.length === 1)
      //         return homeInfo.compsActiveToday[0].competitionName;
      //     else return '';
      // });

      let msg = MessageDisplayUtil.getErrorMessage(
        'Competition in progress',
        _compName + ' is in progress'
      );
      //         MessageDisplayUtil.showErrorToast(msg, this.platform, this.toastCtl,
      return false;
    } else if (type === 'comp-click') {
      let _comp;
      let _compName;
      let _teeOffTime;
      let _startHole;
      let _clubName;

      this.playerHomeInfo$.pipe(filter(Boolean)).subscribe((homeInfo: PlayerHomeInfo) => {
        // if(homeInfo.compsActiveToday && homeInfo.compsActiveToday.length === 1)
        //     return homeInfo.compsActiveToday[0].competitionName;
        // else return '';
        if (homeInfo.compsActiveToday && homeInfo.compsActiveToday.length === 1) {
          _compName = homeInfo.compsActiveToday[0].competitionName;
          _clubName = homeInfo.compsActiveToday[0].clubName;
        }
      });

      // _comp = this.selectedCompetition$.filter(Boolean).subscribe((a: SelectedCompetition)=>{
      //
      //     if(a) {

      //         _compName = a.competitionName
      //         _teeOffTime = a.startTime
      //         _startHole = a.startingHole
      //     }
      // })
      // this.currentGameClub.filter(Boolean).subscribe((c)=>{
      //     _clubName = c
      // })

      _title = 'Competition in progress';
      // _message = `You are registered to play in <br><b>`+_clubName+`</b>`+`.<br>
      _message =
        `You are registered to play in <br><b>` +
        _compName +
        '</b><br>at <b>' +
        _clubName +
        `</b>` +
        `.<br>
        Would you like to view scorecard now or search other tournaments?`;
      // _message = `You are registered to play in <b>`+_clubName+`</b>, Tee-off at <b>`+_teeOffTime+`</b> starting on hole <b>`+_startHole+`</b>.<br>
      // You are a scorer, would you like to score now or search other tournaments?`;
      // _message = `Competition <b>`+ _compName +`</b> is in progress.<br>` + `<br>Playing in <b>`+_clubName+`</b><br>`+
      // `Tee-off at <b>` + _teeOffTime+ `</b> from hole <b>`+ _startHole +`</b>`+
      // `<br>You are the scorer, do you want to score or search tournaments?`;
    }
    if (1) {
      this.onClickNewMultipleCompetitions(_title, _message);
      return;
    }
    let prompt = await this.alertCtrl.create({
      // Flight Name
      header: _title,
      // subTitle: _required,
      message: _message,
      // inputs: [{
      //     name: 'title',
      //     placeholder: 'Club Id',
      //     type: 'number'
      // }, ],
      buttons: [
        {
          text: 'Close',
          role: 'cancel',
          handler: data => {
            prompt.dismiss();
            return false;
          },
        },
        {
          text: 'Search',
          handler: data => {
            prompt.dismiss().then(() => {
              // this.keyboard.close();
              // if(type==='comp-click') this.goCompList();
              this.goCompList();
            });
            return false;
          },
        },
        {
          text: type === 'comp-click' ? 'Scorecard' : type === 'multiple' ? 'Select' : 'Go',
          handler: () => {
            if (type === 'multiple') this.onSelectCompetitionScoring();
            else if (type === 'single') this.onCompetitionScoringClick();
            else if (type === 'comp-click') this.onCompetitionScoringClick();
            // _required = '';
            //     if (data.title)
            //                   prompt.dismiss().then(()=> {
            //                     this.nav.push(BuggyListPage, {
            //                         clubId: data.title
            //                     })
            //                   })
            //     else {
            //         // _required = 'Please enter Group Name';
            //         // _message = '<br>Please enter the Group Name';
            //         let msg = MessageDisplayUtil.getErrorMessage('', "Please enter Club Id");
            //         MessageDisplayUtil.showErrorToast(msg, this.platform, this.toastCtl,
            //             5000, "bottom");
            //     }
            //     return false;
          },
        },
      ],
    });
    prompt.present();
  }
  private async _refreshHcpIdxSubscriptions() {
    if (this.subHcpIdx) return;
    // _loadingCtrl?: any
    let _loadingCtrl;
    if (!_loadingCtrl) {
      _loadingCtrl = await this.loadingCtl.create({
        cssClass: 'custom-loading-hide',
        message: 'Please wait...',
        showBackdrop: false,
        backdropDismiss: false,
        duration: 1000,
      });

      // // await _loadingCtrl.present();

      // // Programmatically remove the backdrop
      // const loadingElement = await this.loadingCtl.getTop();
      // const backdropElement = loadingElement?.shadowRoot?.querySelector('.backdrop-no-tappable');

      // if (backdropElement && backdropElement instanceof HTMLElement) {
      //   backdropElement.style.background = 'transparent';
      //   backdropElement.style.pointerEvents = 'none';
      // }

      // _loadingCtrl.present().then(() => {
      this.subHcpIdx = this.playerService.getHcpIdxSubs().subscribe(
        (data: HandicapIndexSubscription) => {
          // if (data.length > 0) {
          let hIS = data[0];
          this.hcpIdxSubs = data;
          // setTimeout(() => {

          //     //
          //     //
          // }, 250);

          // }
          // _loadingCtrl.dismiss(memberships);
          // setTimeout(() => {
          if (_loadingCtrl)
            _loadingCtrl.dismiss().then(() => {
              //
              // if(this.hcpIdxSubs)
              //
            });
          // }, 250);

          if (this.subHcpIdx) {
            this.subHcpIdx.unsubscribe();
            this.subHcpIdx = null;
          }
        },
        error => {
          if (this.subHcpIdx) {
            this.subHcpIdx.unsubscribe();
            this.subHcpIdx = null;
          }
          if (_loadingCtrl)
            _loadingCtrl.dismiss().then(() => {
              if (error) {
                let msg = MessageDisplayUtil.getErrorMessage(error);
                MessageDisplayUtil.displayErrorAlert(this.alertCtl, 'Subscription', msg, 'OK');
              }
            });
        }
      );
      // });
    }

    // });
  }
  onNewRoundMenuClick() {
    let _clubInfo;
    let params: NavigationExtras = {
      state: {
        clubType: 'Games',
        recentClubType: 'Games',
      },
    };
    if (this.appType === 'club' && global.clubId) {
      if (this.selClubMembership) {
        _clubInfo = this.selClubMembership.club;
      }
      params['isClubSpecific'] = this.isClubSpecific;
      params['homeClub'] = _clubInfo;
      console.debug('course listing [0]', params);
      this.router.navigate(['tabs/course-lists'], params);
    } else {
      console.debug('course listing [1]', params);
      this.router.navigate(['tabs/course-lists'], params);
    }
  }

  subGetScorecard: Subscription;
  onNormalGameScoringClick() {
    let player = this.playerHomeInfo?.player;
    // this.player$.pipe(take(1))
    //   .subscribe((player: PlayerInfo) => {

    let _scorecardType = ''; //'NormalGame';
    this.currentScorecardActions.setScoringPlayer(player.playerId);
    this.currentScorecardService
      .scorecard(_scorecardType)
      .pipe()
      .subscribe(scorecard => {
        let params: NavigationExtras = {
          state: {
            scorecard: scorecard,
            currentPlayer: player,
            clearHistory: true,
          },
        };
        console.debug('on normal game scoring click', params);
        if (this.playGolfClicked) this.router.navigate(['/gameround-scoring'], params);
      });
    // });
  }

  onScorecardMenuClick() {
    this.playerHomeService
      .playerHomeInfo()
      .pipe(
        take(1),
        map(homeInfo => homeInfo.player)
      )
      .subscribe(player => {
        let currentplayer: NavigationExtras = {
          state: {
            currentPlayer: player,
          },
        };
        this.router.navigate(['/scorecard-list'], currentplayer);
        // { queryParams: { currentPlayer: JSON.stringify(player) } }
        // this.nav.push(ScorecardListPage, {
        //     currentPlayer: player
        // });
      });
  }

  getFlagUrl(flagUrl: string) {
    if (flagUrl == null || flagUrl == '') {
      return 'http://cls-play.mygolf2u.com/img/flag/MAS.png';
    } else {
      let flagIcon = flagUrl.split('/');
      return 'assets/img/flag/' + flagIcon[2];
    }
  }

  getClubCreditsCurrency() {
    if (!this.playerCredits) return;
    let _currency = this.playerCredits
      .filter((a: ClubCredit) => {
        return a.club.address.countryData.id === this.countryId;
      })
      .map(a => {
        return a.currency.symbol;
      });
    return _currency[0];
  }

  getClubCredits(type?: string, inNumber?: boolean) {
    let _totalClubCredits = this.totalClubCredits; //858234200000;
    let _totalWallet = this.totalWalletBalance; //858234200000;

    if (!_totalClubCredits) return 0;
    if (!_totalWallet && type === 'wallet') return 0;
    switch (type) {
      case 'wallet':
        // if (_totalWallet >= 1000 && _totalWallet < 1000000)
        //     return (_totalWallet / 1000).toFixed(2) + 'K'
        if (inNumber) return _totalWallet;
        if (_totalWallet >= 1000000 && _totalWallet < 1000000000)
          return this.mg2uUtil.numberWithCommas((_totalWallet / 1000000).toFixed(2)) + 'M';
        else if (_totalWallet >= 1000000000 && _totalWallet < 1000000000000)
          return this.mg2uUtil.numberWithCommas((_totalWallet / 1000000000).toFixed(2)) + 'B';
        else return this.mg2uUtil.numberWithCommas(Number(_totalWallet));
      default:
        if (inNumber) return _totalClubCredits;
        if (_totalClubCredits >= 1000 && _totalClubCredits < 1000000)
          return this.mg2uUtil.numberWithCommas((_totalClubCredits / 1000).toFixed(2)) + 'K';
        else if (_totalClubCredits >= 1000000 && _totalClubCredits < 1000000000)
          return this.mg2uUtil.numberWithCommas((_totalClubCredits / 1000000).toFixed(2)) + 'M';
        else if (_totalClubCredits >= 1000000000 && _totalClubCredits < 1000000000000)
          return this.mg2uUtil.numberWithCommas((_totalClubCredits / 1000000000).toFixed(2)) + 'B';
        else return _totalClubCredits.toFixed(2);
    }
  }

  subPlayerCredits: Subscription;

  getPlayerCredits() {
    if (this.subPlayerCredits) return;
    let _playerId;
    this.player$.pipe(take(1)).subscribe(player => {
      _playerId = player.playerId;
    });
    if (!_playerId) return false;
    this.totalClubCredits = 0;
    this.totalWalletBalance = 0;
    this.playerCredits = [];
    this.subPlayerCredits = this.flightService.getPlayerCredits(_playerId).subscribe(
      (data: any) => {
        if (data) {
          if (data && data.length > 0) {
            data.forEach((cc: ClubCredit) => {
              JsonService.deriveFulImageURL(cc.club, 'clubImage');
              JsonService.deriveFulImageURL(cc.club, 'clubLogo');
            });
            this.playerCredits = data.filter((a: ClubCredit) => {
              if (this.isClubSpecific && this.selClubMembership && this.selClubMembership.club)
                return a.club.id === this.selClubMembership.club.clubId;
              else if (!this.isClubSpecific)
                return a.club.address.countryData.id === this.countryId;
              else return a.club.address.countryData.id === this.countryId;
            });

            if (this.playerCredits && this.playerCredits.length > 0) {
              console.debug('get player credits : ', this.playerCredits, this.countryId);
              this.totalClubCredits = this.playerCredits
                .map((a: ClubCredit) => {
                  if (a) return a.balance + a.creditLimit;
                  else return;
                })
                .reduce((a, b) => {
                  return a + b;
                });

              this.totalWalletBalance = this.playerCredits
                .map((a: ClubCredit) => {
                  if (a) return a.walletBalance;
                  else return;
                })
                .reduce((a, b) => {
                  return a + b;
                });
            }
          }
        }

        if (this.subPlayerCredits) {
          this.subPlayerCredits.unsubscribe();
          this.subPlayerCredits = null;
        }
      },
      error => {
        if (this.subPlayerCredits) {
          this.subPlayerCredits.unsubscribe();
          this.subPlayerCredits = null;
        }
      }
    );
  }

  resolved(captchaResponse: string) {}

  refreshingHome: boolean = false;
  async refreshHome(refresher) {
    this.playerHomeInfo$.pipe(filter(Boolean)).subscribe((homeInfo: PlayerHomeInfo) => {
      // console.debug("player home info ", homeInfo)
      this.playerHomeInfo = homeInfo;
    });
    console.debug('refreshing home [0]', this.refreshingHome);
    this.refreshingHome = true;
    let done = await Promise.all([
      this.refresh(refresher),
      this.getFriendRequestCount(),
      this.getPlayerCredits(),
      this.refreshHandicapSystem(),
      this.getActiveBookings(),
      this.refreshMygolfHandicap(),
      this.getPackage(),
    ]).then((result: any) => {
      console.debug('refreshing home [1]', this.refreshingHome, result);
      this.refreshingHome = false;
      console.debug('refreshing home [2]', this.refreshingHome, result);
      setTimeout(() => {
        console.debug('refreshing home 000', this.refreshingHome, result);
      }, 2000);
    });
    // this.refresh(refresher);
    // this.getFriendRequestCount();
    // this.getPlayerCredits();
    // this.refreshHandicapSystem();
    // this.getActiveBookings();
    // this.refreshMygolfHandicap();
    // this.getPackage();
    if (!this.subNewClubMship)
      this.getNewClubMembership()
        .then(() => {
          this.getHomeNews();
          this.getHomePromoAds();
        })
        .catch(() => {
          this.getHomeNews();
          this.getHomePromoAds();
        });
    if (!this.subInfoServer)
      this.subInfoServer = this.serverInfoService.serverInfo().subscribe((data: ServerInfo) => {
        if (data && !this.overrideBooking) {
          this.isBookingRegistrationEnabled = data.enablePlayerAppBooking;
        }
      });
  }
  refreshHandicapSystem() {
    if (this.subHcpSystemList) return;
    this.handicapSystem = [];
    this.subHcpSystemList = this.flightService
      .getHandicapSystemList()
      .subscribe((handicap: any) => {
        // Array<HandicapSystem>
        if (handicap && handicap.length > 0) {
          this.handicapSystem = handicap;
        }
      });
  }

  getActiveBookings() {
    if (1) return;
    if (this.subPlayerBookings) return;
    let _playerId;
    let _fromDate = moment().format('YYYY-MM-DD');
    this.player$.pipe(take(1)).subscribe(player => {
      _playerId = player.playerId;
    });

    let _clubId;
    if (this.hasParam && this.selectedClub) _clubId = this.selectedClub.clubId;
    else if (this.isClubSpecific && this.selClubMembership)
      _clubId = this.selClubMembership.club.clubId;
    // this.flightService.getBookingByPlayer(_playerId,_fromDate)

    this.subPlayerBookings = this.flightService
      .getBookingForPlayer(_playerId, _fromDate, null, _clubId)
      .subscribe((bookingByPlayerList: Array<TeeTimeBooking>) => {
        let _bookingList: Array<TeeTimeBooking>;
        if (bookingByPlayerList) {
          _bookingList = bookingByPlayerList;
          // _bookingList.forEach((b: TeeTimeBooking, idx: number)=>{
          //     // b.bookingStatus = 'CancelledByClub';
          //     if(idx === 0) b.bookingStatus = 'Booked';
          //     if(idx === 1) b.bookingStatus = 'CancelledByPlayer';

          //     if(idx === 0) {
          //         b.flight = {
          //             status: 'Abandoned'
          //         };
          //     }
          //     if(idx === 1) {
          //         b.flight = {
          //             status: 'PlayFinished'
          //         };
          //     }
          // });
          _bookingList = _bookingList.filter((booking: TeeTimeBooking) => {
            if (
              booking.bookingStatus !== 'CancelledByClub' &&
              booking.bookingStatus !== 'CancelledByPlayer'
            )
              return true;
            // if(booking.flight && booking.flight.status) {
            //     if(booking.flight.status === 'Abandoned' ||  booking.flight.status === 'PlayFinished')
            //         return false
            //     else return true
            // } else return true
          });

          this.totalActiveBookings = _bookingList.length;
        }
      });
  }

  getFriendRequestCount() {
    if (this.subFriendReq) return;
    this.subFriendReq = this.friendService.searchFriendRequests().subscribe(
      (data: FriendRequestList) => {
        let frq;
        frq = data.friendRequests.filter((fr: FriendRequest) => {
          return !fr.requestByPlayer;
        });

        this.friendCount = frq.length;
      },
      error => {
        if (error.status === 403) {
          this.sessionService
            .getSession()
            .pipe(take(1))
            .subscribe((session: SessionInfo) => {
              if (session && session.password) {
                this.sessionActions.login(session.userName, session.password);
              } else if (session && !session.password) {
                this.sessionActions.logout();
              }
            });
        }
      }
    );
  }
  appAttribute: any;
  subAppAttribute: Subscription;
  getAppAttribute() {
    if (this.subAppAttribute) return;
    this.subAppAttribute = this.flightService.getAppAttributes().subscribe((data: any) => {
      if (data) {
        this.mg2uUtil.setAppAttributes(data);
        data
          .filter(d => {
            return d.page === 'playerHome';
          })
          .map(d => {
            this.appAttribute = d;
          });

        if (this.appAttribute) {
          // let _maintenance = this.appAttribute.maintenance;
          if (this.appAttribute.maintenance) {
            // this.displayMaintenance(this.appAttribute);
          }
          // let _announcement = this.appAttribute.annoucement;
          if (this.appAttribute.announcement) {
            // this.displayAnnouncement(this.appAttribute);
          }
        }
      }
    });
  }

  async displayAnnouncement(appAttribute) {
    console.debug('display announcement - player home', appAttribute);
    if (!appAttribute) return;
    if (appAttribute?.announcement?.preV5only) return;
    let _announcement = appAttribute.announcement;
    let _fromDate = moment(_announcement.fromDate, 'YYYY-MM-DD');
    let _toDate = moment(_announcement.toDate, 'YYYY-MM-DD');

    if (_announcement.showAnnouncement) {
      let _msg = 'Welcome to myGolf2u';
      if (_announcement.announcementMessage) {
        _msg = _announcement.announcementMessage;
      }
      let _buttons = [];
      _buttons.push({
        text: 'Okay',
        role: 'cancel',
        handler: () => {
          _alert.dismiss(false);
          return false;
        },
      });
      let _alert = await this.alertCtl.create({
        header: 'Announcement',
        message: _msg,
        buttons: _buttons,
      });
      _alert.onDidDismiss().then(exit => {
        if (exit) this.platform.pause;
      });
      if (moment().isBetween(_fromDate, _toDate, 'day', '[]')) _alert.present();
    }
  }

  async displayMaintenance(appAttribute) {
    if (!appAttribute) return false;
    let _maintenance = appAttribute.maintenance;
    let _fromDate = _maintenance.fromDate;
    let _daysBefore = _maintenance.daysBefore;
    let _dateBefore;
    if (_daysBefore) _dateBefore = moment(_fromDate).add(-1 * _daysBefore, 'days');
    let _toDate = _maintenance.toDate;
    // if(_daysBefore) _dateBefore = moment(_toDate).add(-1*_daysBefore, "days");
    let _fromTime = _maintenance.fromTime;
    let _toTime = _maintenance.toTime;

    let _fromDateTime = moment(_fromDate + _fromTime, 'YYYY-MM-DDHH:mm');
    // moment(_dateBefore).format("YYYY-MM-DD")

    let _toDateTime = moment(_toDate + _toTime, 'YYYY-MM-DDHH:mm');

    if (_maintenance.showMaintenanceMessage) {
      // let _msg = "Server is currently under maintenance. <br>Scheduled time <br><b>"+moment(_fromDateTime).format("ddd, DD MMM YYYY HH:mm") + "</b> to <b>" + moment(_toDateTime).format("ddd, DD MMM YYYY HH:mm")+"</b>";
      let _msg =
        'The system will be unavailable during the following period : <br><b>' +
        moment(_fromDateTime).format('ddd, DD MMM YYYY HH:mm') +
        '</b> to <br><b>' +
        moment(_toDateTime).format('ddd, DD MMM YYYY HH:mm') +
        '</b>';
      if (_maintenance.maintenanceMessage) {
        _msg =
          _maintenance.maintenanceMessage +
          '<br><b>' +
          moment(_fromDateTime).format('ddd, DD MMM YYYY HH:mm') +
          '</b> to <br><b>' +
          moment(_toDateTime).format('ddd, DD MMM YYYY HH:mm') +
          '</b>';
      }
      let _buttons = [];
      if (
        _maintenance.blockForMaintenance &&
        moment().isBetween(_fromDateTime, _toDateTime, 'minute')
      ) {
        if (this.platform.is('capacitor'))
          _buttons.push({
            text: 'Close',
            role: 'cancel',
            handler: () => {
              if (this.platform.is('capacitor')) _alert.dismiss(true);
              return false;
            },
          });
      } else {
        _buttons.push({
          text: 'Okay',
          role: 'cancel',
          handler: () => {
            _alert.dismiss(false);
            return false;
          },
        });
      }
      let _alert = await this.alertCtl.create({
        header: 'Server Maintenance',
        message: _msg,
        buttons: _buttons,
        backdropDismiss: _maintenance.blockForMaintenance ? false : true,
      });
      _alert.onDidDismiss().then((exit: any) => {
        if (exit) this.platform.pause;
      });
      // if(moment().isBetween(_fromDate + " " + _fromTime, _toDate + " " + _toTime ))

      // if(moment().isBetween(_fromDateTime, _toDateTime,'minute') ||  moment().isBetween(_dateBefore,moment(_toDate,"YYYY-MM-DD")))
      if (moment().isBetween(_dateBefore, _toDateTime, 'minute')) _alert.present();
      // .endOf('day')
    }
  }

  onFriendMenuClick() {
    this.router.navigate(['/tabs/friend-list']);
  }

  async goOldMemberManagement() {
    const modal = await this.modalCtl.create({
      component: ManageMembershipPageComponent,
      cssClass: 'ion-infinite-scroll',
      mode: 'ios',
      componentProps: {
        player$: this.player$,
      },
    });
    await modal.present();
  }

  async onClickGoClubMembership(viewSingle: boolean = true) {
    const modal = await this.modalCtl.create({
      component: PlayerDetailsClubMembershipPage,
      mode: 'ios',
      componentProps: {
        player$: this.player$,
        selectedClub: viewSingle ? this.homeClubMembership : false,
        viewSingle: viewSingle,
      },
    });
    await modal.present();
    modal.onDidDismiss().then((data: any) => {
      this.getNewClubMembership(true)
        .then(() => {
          this.getHomeNews();
          this.getHomePromoAds();
        })
        .catch(() => {
          this.getHomeNews();
          this.getHomePromoAds();
        });
    });
  }

  async onClickEditClubMembership() {
    let _editMode = true;
    let _player;
    this.player$.pipe(take(1)).subscribe((player: PlayerInfo) => {
      _player = player;
    });
    let modal = await this.modalCtl.create({
      component: PlayerAddClubMembershipPage,
      componentProps: {
        clubInfo: this.homeClubMembership?.club,
        player: this.player$,
        editMode: _editMode,
        clubMembership: this.homeClubMembership,
      },
    });
    modal.onDidDismiss().then((data: any) => {
      console.debug('membership detail dismiss', data);
      this.getNewClubMembership(true)
        .then(() => {
          this.getHomeNews();
          this.getHomePromoAds();
        })
        .catch(() => {
          this.getHomeNews();
          this.getHomePromoAds();
        });
    });
    modal.present();
  }

  async goMemberManagement(addNew?: boolean) {
    const modal = await this.modalCtl.create({
      component: PlayerDetailsClubMembershipPage,
      mode: 'ios',
      componentProps: {
        player$: this.player$,
        addNew: addNew,
        homeClubMembership: this.homeClubMembership,
      },
    });
    await modal.present();
    if (1) return;
    let prompt = await this.alertCtrl.create({
      // Flight Name
      header: 'Enter a club Id to proceed',
      // subTitle: _required,
      message: 'Enter a club Id to proceed',
      inputs: [
        {
          name: 'title',
          placeholder: 'Club Id',
          type: 'number',
        },
      ],
      buttons: [
        {
          text: 'Cancel',
          handler: data => {
            prompt.dismiss().then(() => {
              // this.keyboard.close();
            });
            return false;
          },
        },
        {
          text: 'Go',
          handler: data => {
            prompt.dismiss().then(() => {
              //this.router.navigate(['member-menu'], { queryParams: { clubId: data.title, fromClub: true, } })
              // this.nav.push(MemberMenuModal), {
              //   clubId: data.title,
              //   fromClub: true,
              // };

              let params: NavigationExtras = {
                state: {
                  clubId: data.title,
                  fromClub: true,
                },
              };
              this.router.navigate(['tabs/member-menu'], params);
            });
            return false;
          },
        },
      ],
    });
    prompt.present();
  }

  async goPlayerVoucher() {
    let _player: PlayerInfo;
    this.player$.pipe(take(1)).subscribe((player: PlayerInfo) => {
      //
      _player = player;
    });
    let modal = await this.modalCtl.create({
      component: PlayerVoucherPage,
      componentProps: {
        type: 'voucher',
        player: _player,
        forBooking: false,
        fromClub: false,
        who: 'player',
        showPlayerCard: true,
      },
    });
    // this.router.navigate(['player-voucher'])
    modal.present();
  }

  async goPlayerCredits() {
    let modal = await this.modalCtl.create({
      component: PlayerVoucherPage,
    });
    // this.router.navigate(['player-voucher'])
    modal.present();
  }

  async goVoucherManagement(type?: string) {
    let _type = type ? type : 'club';
    if (_type !== 'club') {
      let params: NavigationExtras = {
        state: {
          fromClub: true,
          type: _type,
        },
      };
      this.router.navigate(['manage-voucher'], params);
    } else {
      let prompt = await this.alertCtrl.create({
        // Flight Name
        header: 'Enter a club Id to proceed',
        // subTitle: _required,
        message: 'Enter a club Id to proceed',
        inputs: [
          {
            name: 'title',
            placeholder: 'Club Id',
            type: 'number',
          },
        ],
        buttons: [
          {
            text: 'Cancel',
            handler: data => {
              prompt.dismiss().then(() => {
                // this.keyboard.close();
              });
              return false;
            },
          },
          {
            text: 'Go',
            handler: data => {
              prompt.dismiss().then(() => {
                // this.router.navigate(['manage-voucher'], {
                //   queryParams: {
                //     clubId: JSON.stringify(data.title),
                //     fromClub: true
                //   }
                // })

                let params: NavigationExtras = {
                  state: {
                    clubId: data.title,
                    fromClub: true,
                  },
                };
                this.router.navigate(['/tabs/manage-voucher'], params);

                // this.nav.push(ManageVoucherModal, {
                //   fromClub: true,
                //   clubId: data.title
                // });
              });
              return false;
            },
          },
        ],
      });
      prompt.present();
    }
  }

  onPartnerPicklist(service?: string, excludePrograms?: boolean) {
    return new Promise(async (resolve, reject) => {
      let partnerId: string = '';
      let modal = await this.modalCtl.create({
        component: SearchDiscountCompanyPage,
        componentProps: {
          headerTitle: 'Select Partner',
          partnerType: service,
        },
      });
      modal.onDidDismiss().then((data: any) => {
        if (!!data?.data) {
          partnerId = data?.data?.discCompany.id;
          // this.getClubSession(data.clubId);
        }
        // else if(this.clubId && !data) {
        //     // this.getClubSession(this.clubId)
        // }
        else {
          this.onPartnerPicklist(service, excludePrograms);
        }
        if (!partnerId) {
          reject({
            status: 'failed',
            message: 'No Partner Id provided',
          });
        } else if (partnerId) {
          this.flightService.getPartnerDetails(partnerId).subscribe((data: any) => {
            if (data) {
              resolve({
                status: 'success',
                message: 'partner info',
                partnerInfo: data,
              });
            }
          });
        }
      });
      modal.present();
    });
  }

  async goPrivilegeManagement(type?: string) {
    if (type === 'partner') {
      this.onPartnerPicklist()
        .then(async (result: any) => {
          if (result && result.status === 'success') {
            let params: NavigationExtras = {
              state: {
                title: 'Partner Membership',
                type: 'membership',
                // player: _player,
                // player$: this.player$,
                forBooking: false,
                fromClub: true,
                who: 'player',
                showPlayerCard: true,
                userType: 'Partner',
                partnerId: result.partnerInfo.id,
                partnerInfo: result.partnerInfo,
              },
            };
            this.router.navigate(['/tabs/manage-discount-card'], params);
          } else {
            let prompt = await this.alertCtrl.create({
              // Flight Name
              header: 'Enter a Partner Id to proceed',
              // subTitle: _required,
              message: 'Enter a Partner Id to proceed',
              inputs: [
                {
                  name: 'title',
                  placeholder: 'Partner Id',
                  type: 'textarea',
                },
              ],
              buttons: [
                {
                  text: 'Cancel',
                  handler: data => {
                    prompt.dismiss().then(() => {
                      // this.keyboard.close();
                    });
                    return false;
                  },
                },
                {
                  text: 'Go',
                  handler: data => {
                    prompt.dismiss().then(() => {
                      let params: NavigationExtras = {
                        state: {
                          partnerId: data.title,
                        },
                      };
                      this.router.navigate(['manage-discount-card'], params);
                    });
                    return false;
                  },
                },
              ],
            });
            prompt.present();
          }
        })
        .catch(async error => {
          let prompt = await this.alertCtrl.create({
            // Flight Name
            header: 'Enter a Partner Id to proceed',
            // subTitle: _required,
            message: 'Enter a Partner Id to proceed',
            inputs: [
              {
                name: 'title',
                placeholder: 'Partner Id',
                type: 'textarea',
              },
            ],
            buttons: [
              {
                text: 'Cancel',
                handler: data => {
                  prompt.dismiss().then(() => {
                    // this.keyboard.close();
                  });
                  return false;
                },
              },
              {
                text: 'Go',
                handler: data => {
                  prompt.dismiss().then(() => {
                    let params: NavigationExtras = {
                      state: {
                        partnerId: data.title,
                      },
                    };
                    this.router.navigate(['/tabs/manage-discount-card'], params);
                  });
                  return false;
                },
              },
            ],
          });
          prompt.present();
        });
      return;
    } else {
      this.onClubPicklist().then(
        async (result: any) => {
          if (result && result.status === 'success') {
            let params: NavigationExtras = {
              state: {
                clubId: result.clubInfo.clubId,
                fromClub: true,
              },
            };
            this.router.navigate(['manage-discount-card'], params);
          } else {
            let prompt = await this.alertCtrl.create({
              // Flight Name
              header: 'Enter a club Id to proceed',
              // subTitle: _required,
              message: 'Enter a club Id to proceed',
              inputs: [
                {
                  name: 'title',
                  placeholder: 'Club Id',
                  type: 'number',
                },
              ],
              buttons: [
                {
                  text: 'Cancel',
                  handler: data => {
                    prompt.dismiss().then(() => {
                      // this.keyboard.close();
                    });
                    return false;
                  },
                },
                {
                  text: 'Go',
                  handler: data => {
                    prompt.dismiss().then(() => {
                      let params: NavigationExtras = {
                        state: {
                          clubId: data.title,
                        },
                      };
                      this.router.navigate(['manage-discount-card'], params);
                    });
                    return false;
                  },
                },
              ],
            });
            prompt.present();
          }
        },
        async onRejected => {
          let prompt = await this.alertCtrl.create({
            // Flight Name
            header: 'Enter a club Id to proceed',
            // subTitle: _required,
            message: 'Enter a club Id to proceed',
            inputs: [
              {
                name: 'title',
                placeholder: 'Club Id',
                type: 'number',
              },
            ],
            buttons: [
              {
                text: 'Cancel',
                handler: data => {
                  prompt.dismiss().then(() => {
                    // this.keyboard.close();
                  });
                  return false;
                },
              },
              {
                text: 'Go',
                handler: data => {
                  prompt.dismiss().then(() => {
                    let params: NavigationExtras = {
                      state: {
                        clubId: data.title,
                      },
                    };
                    this.router.navigate(['manage-discount-card'], params);
                  });
                  return false;
                },
              },
            ],
          });
          prompt.present();
        }
      );
    }
  }

  getPlayerHcpSysDetail(handicapSystem) {
    if (!handicapSystem) return;
    if (!this.handicapSystem) return;
    if (this.handicapSystem && this.handicapSystem.length === 0) return '';
    let _hcpSystem: HandicapSystem;
    this.handicapSystem.filter(hcpSys => {
      if (hcpSys.id === handicapSystem) {
        _hcpSystem = hcpSys;
        return true;
      } else return false;
    });
    return _hcpSystem.shortCode;
  }

  async goClubBookingList() {
    this.onClubPicklist().then(async (result: any) => {
      if (result && result.status === 'success') {
        let params: NavigationExtras = {
          state: {
            clubId: result.clubInfo.clubId,
          },
        };
        this.router.navigate(['club-booking-list'], params);
      } else {
        let prompt = await this.alertCtrl.create({
          // Flight Name
          header: 'Enter a club Id to proceed',
          // subTitle: _required,
          message: 'Enter a club Id to proceed',
          inputs: [
            {
              name: 'title',
              placeholder: 'Club Id',
              type: 'number',
              value: this.isClubSpecific ? this.selClubMembership.club.clubId.toString() : '',
            },
          ],
          buttons: [
            {
              text: 'Cancel',
              handler: data => {
                prompt.dismiss().then(() => {
                  // this.keyboard.close();
                });
                return false;
              },
            },
            {
              text: 'Go',
              handler: data => {
                prompt.dismiss().then(() => {
                  let params: NavigationExtras = {
                    state: {
                      clubId: data.title,
                    },
                  };
                  this.router.navigate(['club-booking-list'], params);
                });
                return false;
              },
            },
          ],
        });
        prompt.present();
      }
    });
  }

  async goCaddyScheduleDisplayPage() {
    let prompt = await this.alertCtrl.create({
      // Flight Name
      header: 'Enter a club Id to proceed',
      // subTitle: _required,
      message: 'Enter a club Id to proceed',
      inputs: [
        {
          name: 'title',
          placeholder: 'Club Id',
          type: 'number',
        },
      ],
      buttons: [
        {
          text: 'Cancel',
          handler: data => {
            prompt.dismiss().then(() => {
              // this.keyboard.close();
            });
            return false;
          },
        },
        {
          text: 'Go',
          handler: data => {
            prompt.dismiss().then(() => {
              //this.router.navigate([' caddy-schedule-display'], { queryParams: { clubId: data.title } })
              let params: NavigationExtras = {
                state: {
                  clubId: data.title,
                },
              };
              this.router.navigate(['caddy-schedule-display'], params);
              // this.nav.push(CaddyScheduleDisplayPage, {
              //   clubId: data.title
              // });
            });
            return false;
          },
        },
      ],
    });
    prompt.present();
  }

  async openSoundMenu() {
    let sound;
    // sound = new Howl({
    //     src: ['assets/sound.mp3']
    //   });

    // sound.play();
    let actionSheet = await this.actionSheetCtl.create({
      buttons: [
        {
          text: 'Sound 1',
          role: 'destructive',
          icon: !this.platform.is('ios') ? 'exit' : null,
          handler: () => {
            actionSheet.dismiss().then(() => {
              this.signout;
            });
            return false;
          },
        },
        {
          text: 'Settings',
          icon: !this.platform.is('ios') ? 'cog' : null,
          handler: () => {
            actionSheet.dismiss().then(() => {
              this.router.navigate(['settings']);
            });
            return false;
          },
        },
        {
          text: 'Local Scorecards',
          icon: 'albums',
          handler: () => {
            actionSheet.dismiss().then(() => {
              this.router.navigate(['scorecard-local-list']);
            });
            return false;
          },
        },
        {
          text: 'Event Logs',
          icon: 'buffer',
          handler: () => {
            actionSheet.dismiss().then(() => {
              this.router.navigate(['event-log']);
            });
            return false;
          },
        },
        {
          text: 'Cancel',
          role: 'cancel', // will always sort to be on the bottom
          icon: !this.platform.is('ios') ? 'close' : null,
          handler: () => {
            actionSheet.dismiss();
            return false;
          },
        },
      ],
    });
    actionSheet.present();
  }

  goFacilityBookings() {
    let _isClubSpecific;
    let _club;
    if (this.isClubSpecific) {
      if (this.hasParam) _club = this.selectedClub;
      else _club = this.homeClubMembership?.club || this.selClubMembership?.club;
      _isClubSpecific = this.isClubSpecific;
    } else {
      _isClubSpecific = false;
      _club = null;
    }

    let params: NavigationExtras = {
      state: {
        fromClub: false,
        fromHome: true,
        userType: 'player',
        isClubSpecific: _isClubSpecific,
        club: _club,
        clubSpecificThemes: this.appAttribute.clubSpecificThemes,
      },
    };
    this.router.navigate(['player-facility-home'], params);
  }

  async goRefundRedeemHistory() {
    this.onClubPicklist().then(async (result: any) => {
      if (result && result.status === 'success') {
        let params: NavigationExtras = {
          state: {
            clubId: result.clubInfo.clubId,
            fromClub: true,
          },
        };
        this.router.navigate(['club-refund-redeem-history'], params);
      } else {
        let modal = await this.modalCtl.create({
          component: UpdateNhsModalComponent,
          showBackdrop: true,
          mode: 'ios',
          cssClass: this.platform.is('mobile')
            ? 'self-adjustable-modal'
            : 'self-adjustable-modal-desktop',
          componentProps: {
            mode: 'profile_club',
            header: 'Enter a club Id to proceed',
            message: 'Enter a club Id to proceed',
            isClubSpecific: this.isClubSpecific,
            selClubMembership: this.selClubMembership,
          },
        });
        await modal.present().then(() => {
          const height = this.platform.height() - 180;
          document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
        });
        modal.onDidDismiss().then(data => {
          console.log('data: ', data);
        });

        // let prompt = await this.alertCtrl.create({
        //   // Flight Name
        //   header: 'Enter a club Id to proceed',
        //   // subTitle: _required,
        //   message: 'Enter a club Id to proceed',
        //   inputs: [{
        //     name: 'title',
        //     placeholder: 'Club Id',
        //     type: 'number',
        //     value: this.isClubSpecific ? this.selClubMembership.club.clubId.toString() : ''
        //   },],
        //   buttons: [{
        //     text: 'Cancel',
        //     handler: data => {
        //       prompt.dismiss().then(() => {
        //         // this.keyboard.close();
        //       });
        //       return false;
        //     }
        //   },
        //   {
        //     text: 'Go',
        //     handler: data => {
        //       prompt.dismiss().then(() => {
        //         let params: NavigationExtras = {
        //           state: {
        //             clubId: data.title,
        //             fromClub: true,
        //           }
        //         }
        //         this.router.navigate(['club-refund-redeem-history'], params)
        //         return false;
        //       })
        //     }
        //   }
        //   ]
        // });
        // prompt.present();
      }
    });
    // let prompt = await this.alertCtrl.create({
    //   header: 'Enter a club Id to proceed',
    //   message: 'Enter a club Id to proceed',
    //   inputs: [{
    //     name: 'title',
    //     placeholder: 'Club Id',
    //     type: 'number'
    //   },],
    //   buttons: [{
    //     text: 'Cancel',
    //     handler: data => {
    //       prompt.dismiss().then(() => {
    //       });
    //       return false;
    //     }
    //   },
    //   {
    //     text: 'Go',
    //     handler: data => {
    //       prompt.dismiss().then(() => {
    //         console.log('data: ', data);
    //         // let params: NavigationExtras = {
    //         //   state: {
    //         //     clubId: data.title,
    //         //     fromClub: true,
    //         //   }
    //         // }
    //         // this.router.navigate(['club-refund-redeem-history'], params)
    //       });
    //       return false;
    //     }
    //   }
    //   ]
    // });
    // prompt.present();

    let modal = await this.modalCtl.create({
      component: UpdateNhsModalComponent,
      showBackdrop: true,
      mode: 'ios',
      cssClass: this.platform.is('mobile')
        ? 'self-favorite-adjustable-modal'
        : 'self-adjustable-modal-desktop',
      componentProps: {
        mode: 'profile_club',
        header: 'Enter a club Id to proceed',
        message: 'Enter a club Id to proceed',
        isClubSpecific: this.isClubSpecific,
        selClubMembership: this.selClubMembership,
      },
    });
    await modal.present().then(() => {
      const height = this.platform.height() - 180;
      document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
    });
    modal.onDidDismiss().then(data => {
      console.log('data: ', data);
      if (data?.data) {
        let params: NavigationExtras = {
          state: {
            clubId: data?.data,
            fromClub: true,
          },
        };
        this.router.navigate(['club-refund-redeem-history'], params);
      }
    });
  }

  getClubPayTrxns() {
    this.onClubPicklist().then(async (result: any) => {
      if (result && result.status === 'success') {
        let params: NavigationExtras = {
          state: {
            clubId: result.clubInfo.clubId,
            fromClub: true,
          },
        };
        //  this.router.navigate(['club-refund-redeem-history'], params)
        // this.nav.push(ClubPaymentTransactionsPage, {

        // })
      } else {
        let prompt = await this.alertCtrl.create({
          // Flight Name
          header: 'Enter a club Id to proceed',
          // subTitle: _required,
          message: 'Enter a club Id to proceed',
          inputs: [
            {
              name: 'title',
              placeholder: 'Club Id',
              type: 'number',
              value: this.isClubSpecific ? this.selClubMembership.club.clubId.toString() : '',
            },
          ],
          buttons: [
            {
              text: 'Cancel',
              handler: data => {
                prompt.dismiss().then(() => {
                  // this.keyboard.close();
                });
                return false;
              },
            },
            {
              text: 'Go',
              handler: data => {
                prompt.dismiss().then(() => {
                  let params: NavigationExtras = {
                    state: {
                      clubId: data.title,
                      fromClub: true,
                    },
                  };
                  this.router.navigate(['club-refund-redeem-history'], params);

                  return false;
                });
              },
            },
          ],
        });
        prompt.present();
      }
    });
  }

  async onChangeClubSpecific() {
    let _menuLabel = this.appAttribute.clubSpecLabel;
    let _message = this.appAttribute.clubSpecMessage;
    let _dataList = [
      {
        id: 'communal',
        name: 'View All Clubs',
        iconUrl: 'assets/icons/golf-website.png',
      },
      // {
      //   id: 'clubSpecific',
      //   name: 'Club Specific',
      //   iconUrl: 'assets/icons/golf-website.png'
      // },
      {
        id: 'resetHomeClub',
        name: 'View Home Club',
        iconUrl: 'assets/icons/book.png',
      },
      // ,{
      //   id: 'info',
      //   name: _message,
      // }
    ];
    const modal = await this.modalCtl.create({
      mode: 'ios',
      component: CommonPullupMenuComponent,
      cssClass: 'self-adjustable-modal',
      componentProps: {
        app: null,
        dataList: _dataList,
        mode: 'common',
        headerTitle: 'Swap Communal-Club Mode',
        selectedValue: this.isClubSpecific ? 'resetHomeClub' : 'communal',
      },
    });
    await modal.present().then(() => {
      const height = this.platform.height() - 250;
      document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
    });
    modal.onDidDismiss().then((data: any) => {
      console.debug('pullup dismiss', data);
      if (data) {
        if (data?.data?.id === 'communal') {
          this.setCommunalMode(true);
          setTimeout(() => {
            this.refreshHome(null);
          }, 50);
        } else if (data?.data?.id === 'clubSpecific') {
          this.mg2uUtil.setPref('communalMode', false);

          this.onClickGoClubMembership(false);
          setTimeout(() => {
            this.refreshHome(null);
          }, 50);
          // this.openClubSpecificList();
        } else if (data?.data?.id === 'resetHomeClub') {
          this.setCommunalMode(false);
          setTimeout(() => {
            this.refreshHome(null);
          }, 50);
        } else if (data?.data?.id === 'cancel') {
        }
      }
      // if(data)
    });
  }
  // async OLDonChangeClubSpecific() {
  //   let _clubMemberships = this.memberships;
  //   let _buttons = [];
  //   let _d
  //   let actionSheet = await this.actionSheetCtl.create({
  //     buttons: [{
  //       text: 'Community',
  //       role: 'destructive',
  //       icon: !this.platform.is('ios') ? 'exit' : null,
  //       handler: () => {
  //         actionSheet.dismiss()
  //           .then(() => {

  //             this.clubSpecificSelected = false;
  //             this.isClubSpecific = false;
  //             this.getPlayerCredits();
  //             this.updateColor(null, true)
  //             this.mg2uUtil.setClubSpecific(this.isClubSpecific);
  //             this.setCompClubId(true);
  //             this.mg2uUtil.setPersistClubTheme('communal');
  //           });
  //         return false;
  //       }
  //     }
  //       // , {
  //       //     text   : 'Club Specific',
  //       //     icon   : !this.platform.is('ios') ? 'cog' : null,
  //       //     handler: () => {
  //       //         actionSheet.dismiss()
  //       //                    .then(() => {

  //       //                       this.openClubSpecificList();
  //       //                    });
  //       //         return false;
  //       //     }
  //       // }
  //     ]
  //   });
  //   if (_clubMemberships && _clubMemberships.length > 3) {
  //     let actionSheet = await this.actionSheetCtl.create({
  //       buttons: [{
  //         text: 'Club Specific',
  //         icon: !this.platform.is('ios') ? 'cog' : null,
  //         handler: () => {
  //           actionSheet.dismiss()
  //             .then(() => {

  //               this.openClubSpecificList();
  //             });
  //           return false;
  //         }
  //       }]
  //     })
  //   } else if (_clubMemberships && _clubMemberships.length <= 3) {
  //     _clubMemberships.forEach(async (cm: ClubMembership) => {
  //       let actionSheet = await this.actionSheetCtl.create({
  //         buttons: [{
  //           text: cm.club.clubName,
  //           icon: !this.platform.is('ios') ? 'cog' : null,
  //           handler: () => {
  //             actionSheet.dismiss()
  //               .then(() => {
  //                 this.selClubMembership = cm;
  //                 this.changeTheme(cm);

  //                 this.mg2uUtil.setClubMembership(this.selClubMembership);
  //                 this.mg2uUtil.setHomeClub(this.selClubMembership.club);
  //                 this.setCompClubId();
  //               });
  //             return false;
  //           }
  //         }]
  //       })
  //     })
  //   }
  //   if (!this.isClubSpecific || (this.selClubMembership && this.selClubMembership.club.clubId !== this.homeClubId)) {
  //     let actionSheet = await this.actionSheetCtl.create({
  //       buttons: [{
  //         text: 'Reset to Home Club',
  //         icon: !this.platform.is('ios') ? 'cog' : null,
  //         handler: () => {
  //           actionSheet.dismiss()
  //             .then(() => {
  //               let _cm = this.memberships.filter((cm) => {
  //                 return cm.club && cm.club.clubId === this.homeClubId
  //               }).pop();
  //               this.selClubMembership = _cm;
  //               this.changeTheme(_cm);

  //               this.mg2uUtil.setClubMembership(this.selClubMembership);
  //               this.mg2uUtil.setHomeClub(this.selClubMembership);
  //               this.setCompClubId();
  //             });
  //           return false;
  //         }
  //       }]
  //     })
  //   }
  //   if (this.appAttribute && this.appAttribute.enableClubSpecItem) {
  //     let _menuLabel = '';
  //     let _message = '';
  //     _menuLabel = this.appAttribute.clubSpecLabel;
  //     _message = this.appAttribute.clubSpecMessage;
  //     _buttons.push({
  //       text: 'Cancel',
  //       role: 'cancel', // will always sort to be on the bottom
  //       icon: !this.platform.is('ios') ? 'close' : null,
  //       handler: () => {
  //         actionSheet.dismiss();
  //         return false;
  //       }
  //     })

  //     let actionSheet = await this.actionSheetCtl.create({
  //       buttons: [{
  //         text: _menuLabel,
  //         icon: 'information',
  //         handler: async () => {
  //           let _alert = await this.alertCtl.create({
  //             header: _menuLabel,
  //             message: _message,
  //             cssClass: 'booking-alert',
  //             buttons: [{
  //               text: "Ok",
  //               role: "cancel",
  //               handler: () => {
  //                 _alert.dismiss();
  //                 return false;
  //               }
  //             }],
  //           });
  //           _alert.onDidDismiss().then((exit: any) => {
  //           });
  //           _alert.present();
  //           return false;
  //         }
  //       }]
  //     })
  //   }
  //   else {
  //     let actionSheet = await this.actionSheetCtl.create({
  //       buttons: [{
  //         text: 'Cancel',
  //         role: 'cancel', // will always sort to be on the bottom
  //         icon: !this.platform.is('ios') ? 'close' : null,
  //         handler: () => {
  //           actionSheet.dismiss();
  //           return false;
  //         }
  //       }]
  //     })
  //     actionSheet.present();
  //   }
  // }
  updatedColor: number = 0;
  updateColor(themeName?: string, reset?: boolean) {
    // document.documentElement.style.setProperty(`--color`, color);
    // if(1) return;

    // if(!themeName && !reset) return;
    let max = 5;
    if (reset) {
      this.updatedColor = max;
    }
    // this.updatedColor = !this.updatedColor;
    if (themeName && themeName.length > 0) {
      document.body.className = 'theme-' + themeName;
      return;
    } else {
      document.body.className = '';
      return;
    }
    // if (this.updatedColor === max)
    //     this.updatedColor = 0;
    // else this.updatedColor++;
    // if (this.updatedColor === 1)
    //     document.body.className = "theme-" + 'gold';
    // else if (this.updatedColor === 2)
    //     document.body.className = "theme-" + 'gold' + "All";
    // else if (this.updatedColor === 3)
    //     document.body.className = "theme-" + 'gold' + "3";
    //     else if (this.updatedColor === 4)
    //         document.body.className = "theme-" + 'blue';
    //         else if (this.updatedColor === 5)
    //             document.body.className = "theme-" + 'red';
    // else if (this.updatedColor === 0)
    //     document.body.className = "";
    // else document.body.className = "";
  }

  async openClubSpecificList() {
    let modal = await this.modalCtl.create({
      component: ClubMembershipListPage,
      componentProps: {
        clubMemberships: this.memberships,
      },
    });
    modal.onDidDismiss().then((data: any) => {
      let _hasClubThemes;
      if (!!data?.data) {
        let _clubMembership: ClubMembership;
        if (data?.data.selected) {
          this.clubSpecificSelected = true;
          _clubMembership = data?.data.membership;
          this.selClubMembership = data?.data.membership;
          this.mg2uUtil.setClubMembership(this.selClubMembership);
          this.mg2uUtil.setHomeClub(this.selClubMembership.club);
          this.changeTheme(data?.data.membership);
          this.setCompClubId();
          this.mg2uUtil.setPersistClubTheme(String(this.selClubMembership.club.clubId));
          // if (this.appAttribute && this.appAttribute.clubSpecificThemes) {
          //     _hasClubThemes = this.appAttribute.clubSpecificThemes.filter((cc) => {
          //         return cc.clubId === _clubMembership.club.clubId && cc.enableTheme
          //     }).map((cc) => {
          //         this.updateColor(cc.themeName);
          //         this.isClubSpecific = true;
          //     });
          //     if (!_hasClubThemes || (_hasClubThemes && _hasClubThemes.length === 0)) {
          //         this.updateColor(null, true)
          //         this.isClubSpecific = false;
          //     }
          // } else {
          //     this.updateColor(null, true)
          // }
        }
      }
    });
    modal.present();
  }

  changeTheme(clubMembership) {
    let _hasClubThemes;
    if (this.appAttribute && this.appAttribute.clubSpecificThemes) {
      _hasClubThemes = this.appAttribute.clubSpecificThemes
        .filter(cc => {
          return cc.clubId === clubMembership.club.clubId && cc.enableTheme;
        })
        .map(cc => {
          this.updateColor(cc.themeName);
          this.mg2uUtil.setClubSpecific(true);
        });
      if (!_hasClubThemes || (_hasClubThemes && _hasClubThemes.length === 0)) {
        this.updateColor(null, true);
        this.mg2uUtil.setClubSpecific(false);
      }
    } else {
      this.updateColor(null, true);
    }

    this.isClubSpecific = this.mg2uUtil.getClubSpecific();
    // this.mg2uUtil.setClubSpecific(this.isClubSpecific);
    this.getPlayerCredits();
  }

  getSVGImageClass(additionalClass: string) {
    if (this.updatedColor > 0) return additionalClass + ' ' + 'svg-filter';
    else if (this.mg2uUtil.getClubSpecific()) return additionalClass + ' ' + 'svg-filter';
    else return additionalClass;
  }

  cycleColor(reset?: boolean) {
    let max = 5;
    if (reset) {
      this.updatedColor = max;
    }
    if (this.updatedColor === max) this.updatedColor = 0;
    else this.updatedColor++;
    if (this.updatedColor === 1) document.body.className = 'theme-' + 'slgccA';
    else if (this.updatedColor === 2) document.body.className = 'theme-' + 'slgccB';
    else if (this.updatedColor === 3) document.body.className = 'theme-' + 'slgccC';
    // else if (this.updatedColor === 3)
    //     document.body.className = "theme-" + 'gold' + "3";
    //     else if (this.updatedColor === 4)
    //         document.body.className = "theme-" + 'blue';
    //         else if (this.updatedColor === 5)
    //             document.body.className = "theme-" + 'red';
    //         else if (this.updatedColor === 6)
    //         document.body.className = "theme-" + 'tpgcc';
    //         else if (this.updatedColor === 7)
    //             document.body.className = "theme-" + 'tpgccA';
    else if (this.updatedColor === 0) document.body.className = '';
    else document.body.className = '';
  }

  getClubSpecific(attribute) {
    return this.mg2uUtil.getClubSpecificHeader(attribute);
    // if(!attribute) return;
    // if(!this.selClubMembership) return;
    // if(1) return;
    // let _clubSpecific;
    // this.appAttribute.clubSpecificThemes.filter((cc)=>{
    //     return this.selClubMembership.club.clubId === cc.clubId;
    // }).map((cc)=>{
    //     _clubSpecific = cc;
    // });
    // JsonService.deriveFullUrl(_clubSpecific, "headerLogo");
    // switch(attribute) {
    //     case 'header-logo':
    //         return _clubSpecific.headerLogo;
    //     case 'header-title':
    //         return _clubSpecific.headerTitle;
    //     case 'enableHeaderLogo':
    //         return _clubSpecific.enableHeaderLogo;
    //     case 'enableHeaderTitle':
    //         return _clubSpecific.enableHeaderTitle;
    // }
  }

  getClubLogo(club) {
    if (!club) return;
    // if(!this.selClubMembership) return;
    // let club = this.selClubMembership.club;
    let _clubLogo;
    let _randomizer = Math.floor(Math.random() * 7777) + 1;
    let _cc;
    if (this.appAttribute && this.appAttribute.clubSpecificThemes) {
      this.appAttribute.clubSpecificThemes
        .filter(cc => {
          return cc.clubId === club.clubId && cc.enableTheme;
        })
        .map(cc => {
          _cc = JSON.parse(JSON.stringify(cc));
          JsonService.deriveFullUrl(_cc, 'clubLogo');
          if (_cc && _cc.clubLogo) _clubLogo = _cc.clubLogo;
          else _clubLogo = null;
        });
    }
    let _club = JSON.parse(JSON.stringify(club));
    JsonService.deriveFullUrl(_club, 'clubImage');
    JsonService.deriveFullUrl(_club, 'clubLogo');
    JsonService.deriveFullUrl(_club, 'clubThumbnail');

    if (_clubLogo !== null) return _clubLogo;
    else if (_club.clubLogo) return _club.clubLogo;
    else if (_club.clubThumbnail) return _club.clubThumbnail;
    else if (_club.clubImage) return _club.clubImage;
  }

  goPlayerWalletHistory() {
    let _player: PlayerInfo;
    this.player$.pipe(take(1)).subscribe((player: PlayerInfo) => {
      _player = player;
    });
    let _clubId;
    if (this.selClubMembership && this.selClubMembership.club)
      _clubId = this.selClubMembership.club.clubId;
    let _playerId = _player.playerId;
    let clubCredit;
    this.playerCredits
      .filter(cc => {
        return cc.club.id === _clubId;
      })
      .map((cc: ClubCredit) => {
        clubCredit = cc;
      });

    this.flightService
      .getPlayerWalletBalance(_clubId, _playerId)
      .subscribe(async (playerWallet: PlayerClubWalletBalance) => {
        if (playerWallet) {
          let _modal = await this.modalCtl.create({
            component: PlayerWalletHistoryPage,
            componentProps: {
              clubId: clubCredit.club.id,
              player: _player,
              clubCredit: clubCredit,
              preferredCountry: this.selClubMembership.club.country,
              playerWalletBalance: playerWallet,
              isClubSpecific: this.isClubSpecific,
            },
          });
          _modal.present();
        }
      });
  }

  clubIds: Array<number>;
  async refreshMembership() {
    if (this.subPlayerMemberships) return;
    let _loadingCtrl;
    if (!_loadingCtrl) {
      _loadingCtrl = await this.loadingCtl.create({
        cssClass: 'custom-loading-hide',
        message: 'Please wait...',
        showBackdrop: false,
        backdropDismiss: false,
        duration: 1000,
      });
    }
    // // Programmatically remove the backdrop
    // const loadingElement = await this.loadingCtl.getTop();
    // const backdropElement = loadingElement?.shadowRoot?.querySelector('.backdrop-no-tappable');

    // if (backdropElement && backdropElement instanceof HTMLElement) {
    //   // backdropElement.style.background = 'transparent';
    //   backdropElement.style.pointerEvents = 'none';
    // }

    this.player$.pipe(take(1)).subscribe((player: PlayerInfo) => {
      if (player) {
        this.subPlayerMemberships = this.playerService.getPlayerMemberships().subscribe(
          (memberships: any) => {
            // _loadingCtrl.dismiss(memberships);
            // _loadingCtrl.dismiss().then(() => {
            if (memberships) {
              this.memberships = memberships;
              this.mg2uUtil.setPlayerClubMembership(memberships);
              this.clubIds = [];

              if (this.appType === 'club' && global.clubId && !this.hasParam)
                this.homeClubId = global.clubId;
              else if (this.hasParam) this.homeClubId = this.mg2uUtil.clubId;
              else {
                memberships.forEach((m: ClubMembership) => {
                  let _clubId;
                  if (m && m.club && m.club.clubId) {
                    _clubId = m.club.clubId;
                    this.clubIds.push(_clubId);
                    if (m.homeClub) this.homeClubId = _clubId;
                  }
                });
              }

              let _hasClubThemes;
              if (
                this.mg2uUtil.isPersistClubTheme() &&
                this.mg2uUtil.isPersistClubTheme() === 'communal'
              ) {
              } else if (
                this.mg2uUtil.isPersistClubTheme() &&
                this.selClubMembership &&
                Number(this.mg2uUtil.isPersistClubTheme()) === this.selClubMembership.club.clubId
              ) {
              }
              // if(0) {

              // }
              else {
                if (this.appAttribute && this.appAttribute.clubSpecificThemes && this.homeClubId) {
                  _hasClubThemes = this.appAttribute.clubSpecificThemes
                    .filter(cc => {
                      return cc.clubId === this.homeClubId && cc.enableTheme;
                    })
                    .map(cc => {
                      this.updateColor(cc.themeName);
                      this.isClubSpecific = true;
                      // this.selClubMembership.club.clubId = cc.clubId;
                      memberships
                        .filter((m: ClubMembership) => {
                          return m.club.clubId === cc.clubId;
                        })
                        .map(club => {
                          this.selClubMembership = club;
                        });
                      this.setCompClubId();
                    });

                  if (this.hasParam) this.isClubSpecific = true;
                  else if (
                    this.appType === 'main' &&
                    (!_hasClubThemes || (_hasClubThemes && _hasClubThemes.length === 0))
                  ) {
                    this.updateColor(null, true);
                    this.isClubSpecific = false;
                    this.setCompClubId(true);
                  }
                } else if (this.appType === 'main') {
                  this.updateColor(null, true);
                  this.setCompClubId(true);
                } else {
                  this.setCompClubId(true);
                }

                // else this.updateColor(null, true)

                if (this.hasParam) this.mg2uUtil.setClubSpecific(true);
                else this.mg2uUtil.setClubSpecific(this.isClubSpecific);
                if (this.isClubSpecific) {
                  this.mg2uUtil.setClubMembership(this.selClubMembership);
                  if (this.hasParam)
                    this.mg2uUtil.setClubId(this.homeClubId); // .setHomeClub(this.homeClubId);
                  else this.mg2uUtil.setHomeClub(this.selClubMembership.club);
                }
              }
            }
            // }) // _loadingCtrl
          },
          error => {
            if (_loadingCtrl)
              _loadingCtrl.dismiss().then(() => {
                if (error) {
                  let msg = MessageDisplayUtil.getErrorMessage(error);
                  MessageDisplayUtil.displayErrorAlert(this.alertCtl, 'Membership', msg, 'OK');
                }
              });
          },
          () => {
            this._refreshHcpIdxSubscriptions();
            // this._refreshHcpIdxSubscriptions(_loadingCtrl);
          }
        );
      }
    });
  }

  avlPaymentForMain() {
    let _forMain: boolean = false;
    if (this.appAttribute && this.appAttribute.avlWalletPaymentForMain) _forMain = true;
    if (this.appType === 'club') return true;
    else if (this.appType === 'main') return _forMain;
  }

  onPayClick() {
    let _player: PlayerInfo;
    this.player$.pipe(take(1)).subscribe((player: PlayerInfo) => {
      _player = player;
    });
    if (this.isClubSpecific) {
      this.onPayTransaction();
    } else {
      this.navigationExtras.state = {
        player: _player,
        mode: 'wallet',
      };
      this.router.navigate(['player-mg2u-credits'], this.navigationExtras);
    }
  }

  async onPayTransaction() {
    let _player: PlayerInfo;
    this.player$.pipe(take(1)).subscribe((player: PlayerInfo) => {
      _player = player;
    });
    let _clubId;
    let _country;
    if (!this.selClubMembership) return;
    if (this.selClubMembership) {
      _country = this.selClubMembership.club.country;
      _clubId = this.selClubMembership.club.clubId;
    }
    let topupModal = await this.modalCtl.create({
      component: ClubPlayerWalletTopupModal,
      componentProps: {
        clubId: _clubId,
        mode: 'transaction',
        fromClub: false,
        currencySymbol: _country.currencySymbol,
        player: _player,
      },
    });

    topupModal.onDidDismiss().then((data: any) => {
      if (data) {
        this.refreshHome(null);
        // this.getPlayerTransactionHistory();
      }
      // this.refresh
    });
    topupModal.present();
  }

  // languageToggle: boolean = false;
  // onChangeLanguage() {
  //
  //     this.languageToggle = !this.languageToggle;
  //     if(this.languageToggle)
  //         this.translator.setLanguage("my");
  //     else if(!this.languageToggle)
  //         this.translator.setLanguage("en");

  // }
  slideOpts = {
    initialSlide: 0,
    slidesPerView: !this.isMobileLayout() ? 2.4 : this.isMobileLayout() ? 1.1 : 4,
    speed: 400,
    spaceBetween: 15,
    responsiveClass: true,
    scrollbar: {
      el: '.swiper-scrollbar',
      draggable: true,
    },
  };
  playerSlide = {
    initialSlide: 0,
    allowSlideNext: true,
    allowSlidePrev: true,
    speed: 300,
    loop: false,
    pagination: true,
    slidesPerView: 4,
    StartSlides: true,
    responsiveClass: true,
    responsive: {
      0: {
        slidesPerView: 4,
      },
      768: {
        slidesPerView: 8,
      },
      992: {
        slidesPerView: 10,
      },
    },
  };

  slideNews = {
    slidesPerView: !this.isMobileLayout() ? 2 : this.isMobileLayout() ? 1.3 : 3,
    speed: 400,
    spaceBetween: 15,
    responsiveClass: true,
    scrollbar: {
      el: '.swiper-scrollbar',
      draggable: true,
    },
  };

  isMobileLayout() {
    return this.mg2uUtil.isMobileLayout();
  }

  onSearchShow() {
    if (this.isShowSearch) {
      this.isShowSearch = false;
      this.searchRef.value = '';
    } else {
      this.isShowSearch = true;
    }
  }

  getPackage(search: any = '') {
    this.packageSearchCriteria.pageNo = 1;
    this.packageSearchCriteria.pageSize = 6;
    this.packageSearchCriteria.search = search;
    this.packageService
      .getPackages(this.packageSearchCriteria)
      .subscribe((resp: StayAndPlayPackagePage) => {
        if (resp != null && resp != undefined) {
          this.packageList = resp.items.filter(item => item.active);
          console.log('this.packageList: ', this.packageList);
          this.packageList.forEach(element => {
            if (!!element?.packageImages) {
              for (let index = 0; index < element?.packageImages.length; index++) {
                element.packageImages[index] =
                  global.MygolfServer + '/' + element?.packageImages[index];
              }
            }
          });
          this.packageList = this.packageList.sort((a, b) => b.id - a.id);
        }
      });
  }

  onPackgeClick(item: StayAndPlayPackage) {
    let params: NavigationExtras = {
      state: {
        packageId: item.id,
        newPackage: true,
      },
    };
    this.router.navigate(['package-details'], { state: params });
  }

  nextSlide() {
    this.slides.slideNext();
  }

  prevSlide() {
    this.slides.slidePrev();
  }

  changeSlide() {
    this.slides?.getActiveIndex().then(index => {
      this.activeSlide = index;
    });
  }

  onSearchInput(event) {
    if (typeof event?.detail?.value !== 'undefined') {
      this.getPackage(event?.detail?.value);
    }
  }

  onClickWallet() {
    let _player: PlayerInfo;
    this.player$.pipe(take(1)).subscribe((player: PlayerInfo) => {
      _player = player;
    });
    let _clubSpecific;
    this.appAttribute.clubSpecificThemes
      .filter(cc => {
        return this.selClubMembership.club.clubId === cc.clubId;
      })
      .map(cc => {
        _clubSpecific = cc;
      });

    let params: NavigationExtras = {
      state: {
        player: _player,
        isClubSpecific: this.isClubSpecific,
        selectedClub: this.selectedClub ? this.selectedClub : this.selClubMembership.club,
        clubSpecificThemes: _clubSpecific,
        mode: 'wallet',
      },
    };
    this.router.navigate(['player-mg2u-credits'], params);
  }

  async goFlightStartScreen() {
    let prompt = await this.alertCtrl.create({
      // Flight Name
      header: 'Enter a club Id to proceed',
      // subTitle: _required,
      message: 'Enter a club Id to proceed',
      inputs: [
        {
          name: 'title',
          placeholder: 'Club Id',
          type: 'number',
          value: this.isClubSpecific ? this.selClubMembership.club.clubId.toString() : '',
        },
      ],
      buttons: [
        {
          text: 'Cancel',
          handler: data => {
            prompt.dismiss().then(() => {
              // this.keyboard.close();
            });
            return false;
          },
        },
        {
          text: 'Go',
          handler: data => {
            // _required = '';
            if (data.title)
              prompt.dismiss().then(() => {
                let params: NavigationExtras = {
                  state: {
                    clubId: data.title,
                    userRoles: this.session.user.roles,
                  },
                };
                this.router.navigate(['player-mg2u-credits'], params);
                //new page and not  in this  scope
                // this.nav.push(DisplayFlightStartPage, {

                // })
              });
            else {
              // _required = 'Please enter Group Name';
              // _message = '<br>Please enter the Group Name';
              let msg = MessageDisplayUtil.getErrorMessage('', 'Please enter Club Id');
              MessageDisplayUtil.showErrorToast(msg, this.platform, this.toastCtl, 5000, 'bottom');
            }
            return false;
          },
        },
      ],
    });
    prompt.present();
    // this.nav.push(StarterFlightListsPage)
  }

  displayMembershipType() {
    return this.mg2uUtil.getMembershipType();
  }
  getMGALogo() {
    return this.mg2uUtil.getMGALogo();
  }

  goPartnerHandicapApplicationList() {
    this.onPartnerPicklist().then(async (result: any) => {
      if (result && result.status === 'success') {
        let params: NavigationExtras = {
          state: {
            title: 'Partner Membership',
            type: 'application',
            // player: _player,
            // player$: this.player$,
            forBooking: false,
            fromClub: true,
            who: 'player',
            showPlayerCard: true,
            userType: 'Partner',
            partnerId: result.partnerInfo.id,
            partnerInfo: result.partnerInfo,
          },
        };
        this.router.navigate(['player-mg2u-credits'], params);
        //new page
        // this.nav.push(PartnerManageMembershipsModal, {

        // })
        // this.nav.push(HandicapApplicationListPage, {
        //     title: 'Handicap Membership',
        //     type: 'handicap',
        //     // player: _player,
        //     // player$: this.player$,
        //     forBooking: false,
        //     fromClub: true,
        //     who: 'player',
        //     showPlayerCard: true,
        //     partnerId: result.partnerInfo.id
        // })
      } else {
        let prompt = await this.alertCtrl.create({
          // Flight Name
          header: 'Enter a Partner Id to proceed',
          // subTitle: _required,
          message: 'Enter a Partner Id to proceed',
          inputs: [
            {
              name: 'title',
              placeholder: 'Partner Id',
              type: 'textarea',
            },
          ],
          buttons: [
            {
              text: 'Cancel',
              handler: data => {
                prompt.dismiss().then(() => {
                  // this.keyboard.close();
                });
                return false;
              },
            },
            {
              text: 'Go',
              handler: data => {
                // _required = '';
                if (data.title)
                  prompt.dismiss().then(() => {
                    let params: NavigationExtras = {
                      state: {
                        title: 'Handicap Membership',
                        type: 'handicap',
                        // player: _player,
                        // player$: this.player$,
                        forBooking: false,
                        fromClub: true,
                        who: 'player',
                        showPlayerCard: true,
                        partnerId: data.title,
                        partnerInfo: result.partnerInfo,
                      },
                    };
                    this.router.navigate(['player-mg2u-credits'], params);
                    //new page
                    // this.nav.push(HandicapApplicationListPage, {

                    // })
                  });
                else {
                  // _required = 'Please enter Group Name';
                  // _message = '<br>Please enter the Group Name';
                  let msg = MessageDisplayUtil.getErrorMessage('', 'Please enter Club Id');
                  MessageDisplayUtil.showErrorToast(
                    msg,
                    this.platform,
                    this.toastCtl,
                    5000,
                    'bottom'
                  );
                }
                return false;
              },
            },
          ],
        });
        prompt.present();
      }
    });
  }

  getPartnerDetails(attribute?: string) {
    let _partnerDetails: DiscountCompany = this.mg2uUtil.getPartnerInfo();
    if (!_partnerDetails) return;
    switch (attribute) {
      case 'name':
        return _partnerDetails.name;
      case 'isBookingAgent':
        return this.mg2uUtil.getUserType() === 'booking_agent';
    }
  }

  onClickTrxnOrderList() {
    let _overClubId = 310510379; // 71010703;
    if (_overClubId) {
      let params: NavigationExtras = {
        state: {
          clubId: _overClubId,
          fromClub: true,
        },
      };
      this.router.navigate(['player-mg2u-credits'], params);
      // this.nav.push(TransactionOrderListPage, {
      //   clubId: _overClubId,
      //   fromClub: true,
      // })
      return;
    }
    this.onClubPicklist().then((result: any) => {
      if (result && result.status === 'success') {
        let params: NavigationExtras = {
          state: {
            clubId: result.clubInfo.clubId,
            fromClub: true,
          },
        };
        this.router.navigate(['player-mg2u-credits'], params);
        // this.nav.push(TransactionOrderListPage, {

        // })
      }
    });
  }

  goSetupData() {
    let _overClubId = 310510379; // 71010703;
    if (_overClubId) {
      let params: NavigationExtras = {
        state: {
          clubId: _overClubId, //result.clubInfo.clubId,
          fromClub: true,
          initTab: 'data',
          userType: 'Britesoft',
        },
      };
      this.router.navigate(['player-mg2u-credits'], params);
      // this.nav.push(SetupMaintenancePage, {
      // })
      return;
    }
    this.onClubPicklist().then((result: any) => {
      if (result && result.status === 'success') {
        let params: NavigationExtras = {
          state: {
            clubId: result.clubInfo.clubId,
            fromClub: true,
            initTab: 'data',
            userType: 'Britesoft',
            clubInfo: result.clubInfo,
          },
        };
        this.router.navigate(['player-mg2u-credits'], params);
        // this.nav.push(SetupMaintenancePage, {

        // })
      }
    });
  }

  goAgentBookingList() {
    this.onPartnerPicklist('booking_agent', true).then(async (result: any) => {
      if (result && result.status === 'success') {
        this.mg2uUtil.setUserType('booking_agent');
        let params: NavigationExtras = {
          state: {
            partnerId: result.partnerInfo.id,
            partnerInfo: result.partnerInfo,
            type: 'booking_agent',
          },
        };
        this.router.navigate(['player-mg2u-credits'], params);
        // this.nav.push(PartnerBookingListPage, {

        // })
      } else {
        let prompt = await this.alertCtrl.create({
          // Flight Name
          header: 'Enter a club Id to proceed',
          // subTitle: _required,
          message: 'Enter a club Id to proceed',
          inputs: [
            {
              name: 'title',
              placeholder: 'Club Id',
              type: 'number',
              value: this.isClubSpecific ? this.selClubMembership.club.clubId.toString() : '',
            },
          ],
          buttons: [
            {
              text: 'Cancel',
              handler: data => {
                prompt.dismiss().then(() => {
                  // this.keyboard.close();
                });
                return false;
              },
            },
            {
              text: 'Go',
              handler: data => {
                prompt.dismiss().then(() => {
                  let params: NavigationExtras = {
                    state: {
                      clubId: data.title,
                    },
                  };
                  this.router.navigate(['player-mg2u-credits'], params);
                  // this.nav.push(PartnerBookingListPage, {
                  //   clubId: data.title
                  // })
                });
                return false;
              },
            },
          ],
        });
        prompt.present();
      }
    });
  }

  onAgentBookingClick() {
    if (!this.isBookingRegistrationEnabled) {
      MessageDisplayUtil.showErrorToast(
        'Booking & Registration feature will be coming soon.',
        this.platform,
        this.toastCtl,
        3000,
        'bottom'
      );
      return false;
    }

    // let _isClubSpecific;
    // let _club;
    // if (this.isClubSpecific) {
    //     if(this.hasParam) _club = this.selectedClub;
    //     else _club = this.selClubMembership.club;
    //     _isClubSpecific = this.isClubSpecific;
    // } else {
    //     _isClubSpecific = false;
    //     _club = null;
    // }

    this.onPartnerPicklist('booking_agent', true)
      .then((result: any) => {
        let params: NavigationExtras = {
          state: {
            userType: 'booking_agent',
            partnerInfo: result.partnerInfo,
          },
        };
        this.router.navigate(['player-mg2u-credits'], params);
        // this.nav.push(BookingHomePage, {

        // });
      })
      .catch(() => {});
  }

  goInitiateFinance() {
    let _overClubId = 1808271420;
    if (_overClubId) {
      let params: NavigationExtras = {
        state: {
          clubId: _overClubId, //result.clubInfo.clubId,
          fromClub: true,
          initTab: 'integration',
          userType: 'Britesoft',
          // clubInfo: result.clubInfo
        },
      };
      this.router.navigate(['player-mg2u-credits'], params);
      // this.nav.push(InitiateFinancePage, {

      // })
      return;
    }
    this.onClubPicklist().then((result: any) => {
      if (result && result.status === 'success') {
        let params: NavigationExtras = {
          state: {
            clubId: result.clubInfo.clubId,
            fromClub: true,
            initTab: 'integration',
            userType: 'Britesoft',
            clubInfo: result.clubInfo,
          },
        };
        this.router.navigate(['player-mg2u-credits'], params);
        // this.nav.push(InitiateFinancePage, {

        // })
      }
    });
  }

  goUpdateTeeTimeSlots() {
    this.onClubPicklist().then((result: any) => {
      if (result && result.status === 'success') {
        let params: NavigationExtras = {
          state: {
            clubId: result.clubInfo.clubId,
            fromClub: true,
          },
        };
        this.router.navigate(['player-mg2u-credits'], params);
        // this.nav.push(TeeTimeSlotsPage, {

        // })
      }
    });
  }

  goToReports() {
    let params: NavigationExtras = {
      state: {
        userType: 'Britesoft',
      },
    };
    this.router.navigate(['player-mg2u-credits'], params);
    // this.nav.push(GenerateReportOptionPage, {

    // })
  }

  goSignUpPage() {
    // this.nav.push(SignUp);
    // this.router.navigate(['player-mg2u-credits'], params)
  }
  onClickOpenMg2u() {
    this.onClubPicklist().then((result: any) => {
      if (result && result.status === 'success') {
        let _url = 'https://player.mygolf2u.com/';
        let _param = '?param=';
        _url = _url + _param + result.clubInfo.clubId;
        let _attributes =
          'location=no,toolbar=no,scrollbars=yes,resizable=no,top=500,left=500,width=480,height=800';
        _attributes += ',titlebar=' + result.clubInfo.clubName;
        window.open(_url, '_blank', _attributes);
        // location=no,toolbar=no,scrollbars=yes,resizable=no,top=500,left=500,width=480,height=800,titlebar=<clubName>
        // this.nav.push(SetupMaintenancePage, {
        //     clubId: result.clubInfo.clubId,
        //     fromClub: true,
        //     initTab: 'data',
        //     userType: 'Britesoft',
        //     clubInfo: result.clubInfo
        // })
      }
    });
  }

  playerHomeRefresh() {
    this.playerHomeActions.setNeedRefresh(true);
    // this.getActiveComps();
    this.playerHomeInfo$ = this.playerHomeService.playerHomeInfo();
    this.player$ = this.playerHomeInfo$.pipe(
      filter(Boolean),
      map((playerHome: PlayerHomeInfo) => playerHome.player)
    );
    this.player$.subscribe(res => {});

    this.playerPhoto$ = this.playerHomeService.playerPhoto();
    this.multipleComps = this.playerHomeInfo$.pipe(
      filter(Boolean),
      map((homeInfo: PlayerHomeInfo) => {
        return homeInfo.compsActiveToday && homeInfo.compsActiveToday.length > 1;
      })
    );
    this.normalGameOn = this.currentScorecardService.normalGameScoring();
    // this.currentGameClub = this.currentScorecardService.clubName();
    // this.competitionOn = this.currentScorecardService.competitionScoring();
    this.activeCompsToday = this.playerHomeInfo$.pipe(
      filter(Boolean),
      map((homeInfo: PlayerHomeInfo) => {
        this._activeCompsToday = homeInfo.compsActiveToday ? homeInfo.compsActiveToday.length : 0;
        if (homeInfo.compsActiveToday) {
          return homeInfo.compsActiveToday.length;
        } else {
          return 0;
        }
      })
    );
    this.singleActiveComp = this.playerHomeInfo$.pipe(
      filter(Boolean),
      map((homeInfo: PlayerHomeInfo) => {
        if (homeInfo.compsActiveToday && homeInfo.compsActiveToday.length === 1)
          return homeInfo.compsActiveToday[0];
        else return null;
      })
    );
    this.selectedCompetition$ = this.playerHomeService.competitionSelectedForScoring();
  }
  playerHomeInfo: any;
  async handleRefresh(event) {
    // this.ngOnInit();
    this.playGolfClicked = false;
    this.playCompClicked = false;
    this.pageLoader = null;
    await this.playerHomeRefresh();
    this.ionViewWillLeave();
    setTimeout(() => {
      console.log('REFRESH BUTTON WORK');
      // this.refreshHome(null);
      this.refreshHome(event);
      event.target.complete();

      this.notificationClass = this.hasNotifications();
      this.hasAnyActiveCompsToday = this.hasActiveCompsToday();
    }, 250);

    if (this.subHasActiveCompsToday) {
      this.subHasActiveCompsToday.unsubscribe();
      this.subHasActiveCompsToday = null;
    }
  }

  // Club Credit Page
  async onMygolfCredit() {
    let _player: PlayerInfo;
    this.player$.pipe(take(1)).subscribe((player: PlayerInfo) => {
      _player = player;
    });

    let params: NavigationExtras = {
      state: {
        player: _player,
      },
    };
    this.router.navigate(['player-mg2u-credits'], params);
  }

  notificationClass: string;
  hasNotifications() {
    let _hasNotf: boolean = false;
    if (this.hasActiveCompsToday()) _hasNotf = true;
    if (this.hasNormalGame()) _hasNotf = true;
    if (_hasNotf) return 'blink_me';
    else return '';
  }

  subHasActiveCompsToday: Subscription;
  hasActiveCompsToday() {
    // if(this.subHasActiveCompsToday) return;
    // console.debug("has active comps today", this.activeCompsToday, this.multipleComps, this.singleActiveComp);
    let _activeCompsToday = 0;

    // this.playerHomeService.playerHomeInfo().pipe(take(1))
    //   .subscribe(async (homeInfo: PlayerHomeInfo) => {
    //     if (homeInfo.compsActiveToday) {
    //       _activeCompsToday = homeInfo.compsActiveToday.length;
    //     } else {
    //       _activeCompsToday = 0;
    //     }
    //   });

    this.subHasActiveCompsToday = this.activeCompsToday.pipe(filter(Boolean)).subscribe(a => {
      // if(this.isClubSpecificCompetition().length > 0 && this.isHomeClubActive() && this.isClubSpecific) _activeCompsToday = a
      _activeCompsToday = a;
    });
    if (this.isHomeClubActive() && this.isClubSpecific) {
      _activeCompsToday = this.isClubSpecificCompetition().length;
    }
    // if(_activeCompsToday > 0)
    //   this.hasAnyActiveCompsToday = true
    return _activeCompsToday > 0;
  }

  hasNormalGame() {
    // console.debug("has active comps today", this.activeCompsToday, this.multipleComps, this.singleActiveComp);
    let _normalGame;
    this.normalGameOn.pipe(filter(Boolean)).subscribe(a => {
      // console.debug("activeCompsToday", a)
      _normalGame = a;
    });
    return _normalGame > 0;
  }

  async onClickNewMultipleCompetitions(title, message) {
    let _message = {
      title: title,
      content: message,
    };

    let _multipleComps;
    this.multipleComps.pipe(filter(Boolean)).subscribe((a: any) => {
      // if(a.compsActiveToday && a.compsActiveToday.length > 1)
      //     _multipleComps = true;
      _multipleComps = a;
    });
    const modal = await this.modalCtl.create({
      mode: 'ios',
      component: CommonPullupMenuComponent,
      cssClass: 'self-adjustable-modal',
      componentProps: {
        app: null,
        // dataList: _dataList,
        mode: 'dualOptions',
        message: _message,
        firstBtnTxt: 'Search',
        secondBtnTxt: _multipleComps ? 'Select' : 'Score',
      },
    });
    await modal.present().then(() => {
      const height = this.platform.height() - 250;
      document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
    });
    modal.onDidDismiss().then((data: any) => {
      console.debug('pullup dismiss', data);
      if (data) {
        if (data?.data === 1) {
          this.goCompList();
          // this.selectedRound(data.data.id, null);
        } else if (data?.data === 2) {
          if (_multipleComps) {
            this.onSelectCompetitionScoring();
          } else this.onCompetitionScoringClick();
        }
      }
    });
  }

  newsList: Array<News>;
  promoAdsList: Array<OfferAndAdvertisement>;
  getHomeNews() {
    if (this.subNewsList) return;
    this.newsList = [];
    let _clubId = this.isClubSpecific ? this.homeClubMembership?.club?.clubId : null;
    let _partnerId = null;
    // if(this.session?.user?.clubId) _clubId = this.session.user.clubId;
    // if(this.session?.user?.partnerId) _partnerId = this.session.user.partnerId;
    let _params = {
      clubId: _clubId,
      partnerId: _partnerId,
      startDate: moment().format('YYYY-MM-DD'),
      activeOn: moment().format('YYYY-MM-DD'),
      endDate: null,
      activeOrInactive: 'A',
      pageSize: 6,
      includeMygolfNews: this.isClubSpecific,
    };
    this.subNewsList = this.flightService.getNewsList(_params).subscribe(
      (data: NewsPage) => {
        if (data?.totalItems > 0) {
          this.newsList.push(...data.items);
        }
        // if(this.isClubSpecific) {
        //   let _mg2uParams = {
        //     clubId: null,
        //     partnerId: null,
        //     mygolfOnly: true,
        //     startDate: moment().format("YYYY-MM-DD"),
        //     activeOn: moment().format("YYYY-MM-DD"),
        //     endDate: null,
        //     activeOrInactive: 'A',
        //     pageSize: 6
        //   }
        //   this.flightService.getNewsList(_mg2uParams)
        //   .subscribe((data: NewsPage)=>{
        //     if(data?.totalItems > 0) {
        //       this.newsList.push(...data.items);
        //     }
        //   },(error)=>{
        //     this.refreshSwiper('news');
        //   },()=>{
        //     this.refreshSwiper('news');
        //   });
        // }
        this.refreshSwiper('news');
      },
      error => {
        if (this.subNewsList) {
          this.subNewsList.unsubscribe();
          this.subNewsList = null;
        }
        this.refreshSwiper('news');
      },
      () => {
        if (this.subNewsList) {
          this.subNewsList.unsubscribe();
          this.subNewsList = null;
        }
        this.refreshSwiper('news');
      }
    );
  }

  getNewsPairs(newsList: any[]): any[][] {
    const newsPairs = [];
    for (let i = 0; i < newsList.length; i += 2) {
      newsPairs.push(newsList.slice(i, i + 2));
    }
    return newsPairs;
  }

  getNewsImage(news: News) {
    // console.debug(" getting news images ", news)
    if (!news) return;
    if (news?.images?.length > 0) return news?.images[0];
    else return '../../../assets/image/homeImg/NewsImage.png';
  }

  getHomePromoAds() {
    if (this.subPromoList) return;
    let _clubId = this.isClubSpecific ? this.homeClubMembership?.club?.clubId : null;
    let _partnerId = null;
    // if(this.session?.user?.clubId) _clubId = this.session.user.clubId;
    // if(this.session?.user?.partnerId) _partnerId = this.session.user.partnerId;
    let _params = {
      clubId: _clubId,
      partnerId: _partnerId,
      startDate: moment().format('YYYY-MM-DD'),
      activeOn: moment().format('YYYY-MM-DD'),
      endDate: null,
      activeOrInactive: 'A',
      pageSize: 6,
      includeMygolf: this.isClubSpecific,
    };
    this.subPromoList = this.flightService.getPromoAdsList(_params).subscribe(
      (data: OffersAndAdvertisementPage) => {
        this.promoAdsList = [];
        if (data?.totalItems > 0) {
          this.promoAdsList.push(...data.items);
        }
        // if(this.isClubSpecific) {
        //   let _mg2uParams = {
        //     mygolfOnly: true,
        //     clubId: null,
        //     partnerId: null,
        //     startDate: moment().format("YYYY-MM-DD"),
        //     activeOn: moment().format("YYYY-MM-DD"),
        //     endDate: null,
        //     activeOrInactive: 'A',
        //     pageSize: 6
        //   }
        //   this.flightService.getPromoAdsList(_mg2uParams)
        //   .subscribe((data: OffersAndAdvertisementPage)=>{
        //     if(data?.totalItems > 0) {
        //       this.promoAdsList.push(...data.items);
        //     }
        //   },(error)=>{
        //     this.refreshSwiper('promo');
        //   },()=>{
        //     this.refreshSwiper('promo');
        //   });
        // }
      },
      error => {
        if (this.subPromoList) {
          this.subPromoList.unsubscribe();
          this.subPromoList = null;
        }
        this.refreshSwiper('promo');
      },
      () => {
        if (this.subPromoList) {
          this.subPromoList.unsubscribe();
          this.subPromoList = null;
        }
        this.refreshSwiper('promo');
      }
    );
  }

  getPromoAdImage(promoAd: OfferAndAdvertisement) {
    // console.debug(" getting promo ads images ", promoAd)
    if (promoAd?.images?.length > 0) return promoAd?.images[promoAd?.images?.length - 1];
    else return '../../../assets/image/default/golf-promo1.jpg';
  }

  onClickViewNews() {
    let _params: NavigationExtras = {
      replaceUrl: true,
      state: {
        clubId: this.isClubSpecific ? this.homeClubMembership?.club?.clubId : null,
      },
    };
    this.router.navigate(['news-list'], _params);
  }
  onClickViewPromoAds() {
    let _params: NavigationExtras = {
      replaceUrl: true,
      state: {
        clubId: this.isClubSpecific ? this.homeClubMembership?.club?.clubId : null,
      },
    };
    this.router.navigate(['promo-ads-list'], _params);
  }

  onClickNewsPair(newsPair: any) {
    console.debug('on click news pair ', newsPair);
  }
  onClickNews(news: News) {
    console.debug('on click news ');
    console.debug('on click news ', news);
    if (1 && news) {
      console.debug('on click news ', news);
      this.goToNewsDetails(news);
      return;
    }
    // news?.onClick; - actionType values : None, OpenUrl, OpenPage
    let _onClickAction: OnClickAction = news?.onClick;
    let _actionValue = '';
    if (_onClickAction?.actionValue) _actionValue = _onClickAction.actionValue;
    switch (_onClickAction.actionType) {
      case 'None':
        this.goToNewsDetails(news);
        break;
      case 'OpenUrl':
        let _url = ensureHttpPrefix(_actionValue);
        if (this.platform.is('capacitor')) {
          this.openWithInAppBrowser(_url);
        } else {
          let win = window.open(_url, '_system');
        }
        break;
      case 'OpenPage':
        this.router.navigate([_actionValue]);
        break;
    }
  }

  public openWithInAppBrowser(url: string, target?: string) {
    let _target;
    if (target) _target = target;
    else _target = '_blank';
    if (this.platform.is('ios')) _target = '_blank';
    let _iab = this.iab.create(url, _target, this.iabOptions);

    if (this.platform.is('ios')) {
      _iab.on('loadstart').subscribe(event => {
        let loc = event.url.toLowerCase();
        // if (loc.includes(this.paymentRedirectURL.toLowerCase())) {
        //   setTimeout(function () {
        //     _iab.close();
        //   }, 5000);
        // }
      });
    } else {
      _iab.on('loadstop').subscribe(event => {
        let loc = event.url.toLowerCase();
        // if (loc.includes(this.paymentRedirectURL)) {
        //   setTimeout(function () {
        //     _iab.close();
        //   }, 5000);
        // }
      });
    }
    _iab.on('exit').subscribe(
      () => {},
      err => {}
    );
  }

  async goToNewsDetails(news: News) {
    const newsModal: any = await this.modalCtl.create({
      component: NewsDetailsComponent,
      cssClass: 'full-screen-modal',
      componentProps: {
        news: news,
      },
    });

    newsModal.onDidDismiss((data: any) => {
      //
      if (data) {
      }
    });
    newsModal.present();
  }
  async goToPromoAdsDetails(promoAds: OfferAndAdvertisement) {
    const promoAdsModal: any = await this.modalCtl.create({
      component: PromoAdsDetailsComponent,
      cssClass: 'full-screen-modal',
      componentProps: {
        promoAds: promoAds,
      },
    });

    promoAdsModal.onDidDismiss((data: any) => {
      //
      if (data) {
      }
    });
    promoAdsModal.present();
  }

  onClickPromoAds(promoAds: OfferAndAdvertisement) {
    if (this.playCompClicked) return;
    if (1 && promoAds) {
      this.goToPromoAdsDetails(promoAds);
      return;
    }
  }

  checkMenuItem(item) {
    return new Promise((resolve, reject) => {
      let _menuItems: Array<any> = this.appAttribute?.menuItems;
      console.debug('check menu item ', item, this.appAttribute?.menuItems);
      let _item = null;
      if (_menuItems?.length > 0) {
        _item = _menuItems.find(mi => {
          return mi.itemId === item?.itemId;
        });
        resolve({
          hasMenu: _item ? true : false,
          item: _item,
        });
      } else {
        resolve({
          hasMenu: false,
        });
      }
    });
  }

  helpURL: string;
  enableSettings: any;
  callHelpPage() {
    let _helpAttr = this.mg2uUtil.getSettingsAttribute();
    let _isClubSpecific = this.mg2uUtil.getClubSpecific();
    console.debug('settings page : ', _helpAttr, _isClubSpecific);
    if (_helpAttr) {
      if (_isClubSpecific) {
        _helpAttr.clubSpecific
          .filter(c => {
            return c.clubId === global.clubId;
          })
          .map(c => {
            // this.showSettings = c.showSettings;
            this.enableSettings = c.enableSettings;
          });
      } else {
        // this.showSettings = this.appAttribute.main.showSettings;
        this.enableSettings = _helpAttr.main.enableSettings;
      }
    }
    if (!this.enableSettings || (this.enableSettings && !this.enableSettings.help)) return;
    // if(this.mg2uUtil.getClubSpecific) return;
    let _helpJson;

    if (_isClubSpecific && global.appType && global.clubId) {
      _helpAttr.clubSpecific
        .filter(c => {
          return c.clubId === global.clubId;
        })
        .map(c => {
          _helpJson = c.helpPage;
        });
    } else {
      _helpJson = _helpAttr.main.helpPage;
    }
    this.flightService.getHelp(_helpJson).subscribe(
      (helpURL: Array<HelpURLs>) => {
        if (helpURL && helpURL.length > 0) {
          // && helpURL.length > 0
          this.helpURL = helpURL[0].url;
          console.log('get help url items', this.helpURL);
          window.open(this.helpURL, '_self');
        }
        // else this.helpURL = 'http://portal.mygolf2u.com/document/help-contents/mobile/help_content.html'
      },
      error => {},
      () => {}
    );
  }
  getPackageLocation(item: StayAndPlayPackage) {
    if (!item) return;
    let _location = [];
    if (item?.packageStayOptions) {
      if (item?.packageStayOptions[0]?.hotel?.address?.countryData)
        _location.push(item?.packageStayOptions[0]?.hotel?.address?.countryData?.name);
      if (item?.packageStayOptions[0]?.hotel?.address?.state)
        _location.push(item?.packageStayOptions[0]?.hotel?.address?.state);
      if (item?.packageStayOptions[0]?.hotel?.address?.city)
        _location.push(item?.packageStayOptions[0]?.hotel?.address?.city);
    }
    // if(item?.club) {
    //   if(item?.club?.address?.countryData) _location.push(item?.club?.address?.countryData?.name);
    //   if(item?.club?.address?.state) _location.push(item?.club?.address?.state);
    //   if(item?.club?.address?.city) _location.push(item?.club?.address?.city);
    // } else if(item?.partner) {
    //   if(item?.partner?.address?.countryData) _location.push(item?.partner?.address?.countryData?.name);
    //   if(item?.partner?.address?.state) _location.push(item?.partner?.address?.state);
    //   if(item?.partner?.address?.city) _location.push(item?.partner?.address?.city);
    // }
    return _location.join(', ');
  }

  subNewClubMship: Subscription;
  clubMemberships: Array<ClubMembershipExtended> = [];
  getNewClubMembership(clear?: boolean) {
    return new Promise((resolve, reject) => {
      // if(this.subNewClubMship) return;
      this.clubMemberships = [];
      if (clear) this.homeClubMembership = null;
      this.player$.pipe(take(1)).subscribe((player: PlayerInfo) => {
        console.debug('get new club membership', player);
        if (player) {
          this.subNewClubMship = this.flightService
            .getClubMembershipsForPlayer(player.playerId)
            .subscribe(
              (memberships: Array<ClubMembershipExtended>) => {
                if (memberships) {
                  this.clubMemberships = memberships;
                  if (memberships?.length > 1) {
                    this.homeClubMembership = memberships.find(cm => {
                      return cm?.playerHomeClub;
                    });
                  } else this.homeClubMembership = memberships[0];
                  if (this.homeClubMembership?.club)
                    this.homeClubMembership.club['clubId'] = this.homeClubMembership?.club?.id;

                  this.mg2uUtil.setPlayerClubMembership(memberships);
                  this.clubIds = [];

                  if (this.appType === 'club' && global.clubId && !this.hasParam)
                    this.homeClubId = global.clubId;
                  else if (this.hasParam) this.homeClubId = this.mg2uUtil.clubId;
                  else {
                    memberships.forEach((m: ClubMembership) => {
                      let _clubId;
                      if (m && m.club && m.club.clubId) {
                        _clubId = m.club.clubId;
                        this.clubIds.push(_clubId);
                        if (m.homeClub) this.homeClubId = _clubId;
                      }
                    });
                  }
                  resolve(memberships);
                  this.setClubSpecific(memberships);
                  if (this.subNewClubMship) {
                    this.subNewClubMship.unsubscribe();
                    this.subNewClubMship = null;
                  }
                }
              },
              error => {
                reject(false);
                if (this.subNewClubMship) {
                  this.subNewClubMship.unsubscribe();
                  this.subNewClubMship = null;
                }
              },
              () => {
                reject(false);
                if (this.subNewClubMship) {
                  this.subNewClubMship.unsubscribe();
                  this.subNewClubMship = null;
                }
              }
            );
        }
      });
    });
  }

  async openHandicapMembership() {
    let _player: PlayerInfo;
    this.player$.pipe(take(1)).subscribe((player: PlayerInfo) => {
      _player = player;
    });
    let _playerId = _player.playerId; // | _player.id;
    let _params = {
      partnerId: null,
      programId: null,
      startDate: null,
      endDate: null,
      playerId: _playerId,
      approvedOrNot: true,
      pageSize: 30,
    };

    this.hcpMemberService
      .getMembershipApplications(_params)
      .then(async (result: any) => {
        if (result && result.status === 'success') {
          if (result && result.data && result.data.length > 1) {
            let modal = await this.modalCtl.create({
              component: PlayerVoucherPage,
              componentProps: {
                title: 'Handicap Membership',
                type: 'handicap',
                player: _player,
                player$: this.player$,
                forBooking: false,
                fromClub: false,
                who: 'player',
                showPlayerCard: true,
              },
            });
            modal.present();
          } else if (result && result.data && result.data.length === 1) {
            let modal = await this.modalCtl.create({
              component: PlayerVoucherPage,
              componentProps: {
                title: 'Handicap Membership',
                type: 'handicap',
                player: _player,
                player$: this.player$,
                forBooking: false,
                fromClub: false,
                who: 'player',
                showPlayerCard: true,
                application: result.data[0],
                newMode: true,
              },
            });
            modal.present();
          } else {
            let modal = await this.modalCtl.create({
              component: PlayerVoucherPage,
              componentProps: {
                title: 'Handicap Membership',
                type: 'handicap',
                player: _player,
                player$: this.player$,
                forBooking: false,
                fromClub: false,
                who: 'player',
                showPlayerCard: true,
                newMode: true,
              },
            });
            modal.present();
          }
        }
      })
      .catch(error => {});
  }

  getHomeClubImage() {
    let _defaultImg =
      'assets/img/default/template-course-' + Math.floor(Math.random() * 5 + 1) + '.jpg';
    let _club = this.homeClubMembership?.club;

    if (_club && _club.clubLogo) return _club.clubLogo;
    else if (_club && _club.clubThumbnail) return _club.clubThumbnail;
    else if (_club && _club.clubImage) return _club.clubImage;
    else return './assets/image/default_club.png';
    // else return _defaultImg;
  }

  isHomeClubActive() {
    return this.homeClubMembership?.playerHomeClub;
  }

  setClubSpecific(memberships?: any) {
    // console.debug("setting club specific : ", memberships,
    // this.hasParam, this.isClubSpecific,this.mg2uUtil.getClubSpecific(),
    // this.homeClubMembership, this.selClubMembership, this.appAttribute)

    let _hasClubThemes;
    if (this.mg2uUtil.isPersistClubTheme() && this.mg2uUtil.isPersistClubTheme() === 'communal') {
    } else if (
      this.mg2uUtil.isPersistClubTheme() &&
      this.homeClubMembership &&
      Number(this.mg2uUtil.isPersistClubTheme()) === this.homeClubMembership.club.clubId
    ) {
    } else {
      if (this.appAttribute && this.appAttribute.clubSpecificThemes && this.homeClubMembership) {
        _hasClubThemes = this.appAttribute.clubSpecificThemes
          .filter(cc => {
            return cc.clubId === this.homeClubMembership?.club?.id && cc.enableTheme;
          })
          .map(cc => {
            this.updateColor(cc.themeName);
            // this.selClubMembership.club.clubId = cc.clubId;
            memberships
              .filter((m: ClubMembershipExtended) => {
                return m.club.clubId === cc.clubId;
              })
              .map(club => {
                this.homeClubMembership = club;
              });
            // if(_hasClubThemes?.length > 0) {
            //   this.isClubSpecific = true;
            //   this.mg2uUtil.setClubSpecific(true);
            //   this.setCompClubId()
            // }
            // else {
            //   this.isClubSpecific = false;
            //   this.mg2uUtil.setClubSpecific(false);
            //   this.setCompClubId(true)
            // }
          });

        if (this.hasParam) {
          this.isClubSpecific = true;
          this.mg2uUtil.setClubSpecific(true);
          this.setCompClubId();
        } else if (
          this.appType === 'main' &&
          (!_hasClubThemes || (_hasClubThemes && _hasClubThemes.length === 0))
        ) {
          this.updateColor(null, true);
          this.mg2uUtil.setClubSpecific(false);
          this.isClubSpecific = false;
          this.setCompClubId(true);
        } else if (_hasClubThemes?.length > 0) {
          this.isClubSpecific = true;
          this.mg2uUtil.setClubSpecific(true);
          this.setCompClubId();
          this.mg2uUtil.setClubMembership(this.homeClubMembership);
        }
      } else if (this.appType === 'main') {
        this.updateColor(null, true);
        this.setCompClubId(true);
      } else {
        this.setCompClubId(true);
      }

      // else this.updateColor(null, true)

      // if (this.hasParam) this.mg2uUtil.setClubSpecific(true);
      // else this.mg2uUtil.setClubSpecific(this.isClubSpecific);
      // if (this.isClubSpecific) {
      //   this.mg2uUtil.setClubMembership(this.selClubMembership);
      //   if (this.hasParam) this.mg2uUtil.setClubId(this.homeClubId); // .setHomeClub(this.homeClubId);
      //   else this.mg2uUtil.setHomeClub(this.selClubMembership.club);
      // }
    }
  }

  getClubStatusLabel() {
    let _status: string = this.homeClubMembership.status.toLowerCase();
    let _statusLabel = this.homeClubMembership?.status;
    let _currDate = moment();
    let _validUntil = moment(this.homeClubMembership.validUntil, 'YYYY-MM-DD');
    let _isTerm = this.homeClubMembership?.membershipType?.termMembership;
    if (_status === 'pending') {
      _statusLabel = 'Pending status';
    } else if (_status === 'inactive') {
      _statusLabel = 'Inactive status';
    } else if (_status === 'suspended') {
      _statusLabel = 'Suspended status';
    } else if (moment(_validUntil).isBefore(_currDate, 'days')) {
      _statusLabel = 'Expired status';
    }
    return _statusLabel;
  }

  getClubStatusText() {
    let _status: string = this.homeClubMembership.status.toLowerCase();
    let _statusText = this.homeClubMembership?.status;
    let _currDate = moment();
    let _validUntil = moment(this.homeClubMembership.validUntil, 'YYYY-MM-DD');
    let _isTerm = this.homeClubMembership?.membershipType?.termMembership;
    if (_status === 'pending') {
      _statusText = 'Pending Club Approval';
    } else if (_status === 'inactive') {
      _statusText = 'Membership Inactive. Please contact club.';
    } else if (_status === 'suspended') {
      let _statusHistory = this.homeClubMembership.statusHistories
        .filter((sh: ClubMembershipStatusHistory) => {
          return sh.status.toLowerCase() === 'suspended';
        })
        .pop();
      _statusText = `${_statusHistory?.remarks}`;
    } else if (moment(_validUntil).isBefore(_currDate, 'days')) {
      _statusText = 'Membership Expired. Please contact club.';
    }
    return _statusText;
  }

  async onClickClubNonActiveStatus() {
    let _message = {
      title: this.getClubStatusLabel(),
      content: `<span style="color: #E94444 !important;font-style: italic !important;" ><b>${this.getClubStatusText()}</b></span>`,
    };

    const modal = await this.modalCtl.create({
      mode: 'ios',
      component: CommonPullupMenuComponent,
      cssClass: 'self-adjustable-modal',
      componentProps: {
        app: null,
        message: _message,
        mode: 'infoDisplay',
      },
    });
    await modal.present().then(() => {
      const height = this.platform.height() - 250;
      document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
    });
    modal.onDidDismiss().then((data: any) => {});
  }

  isMembershipActive() {
    let _status: string = this.homeClubMembership.status.toLowerCase();
    let _isActive: boolean = true;
    let _currDate = moment();
    let _validUntil = moment(this.homeClubMembership.validUntil, 'YYYY-MM-DD');
    let _isTerm = this.homeClubMembership?.membershipType?.termMembership;
    if (_status === 'pending') {
      _isActive = false;
    } else if (_status === 'inactive') {
      _isActive = false;
    } else if (_status === 'suspended') {
      _isActive = false;
    } else if (moment(_validUntil).isBefore(_currDate, 'days')) {
      _isActive = false;
    }
    return _isActive;
  }

  clearAllStates() {
    this.sessionActions.clearAllStates();
    this.playerHomeActions.clearAllStates();
  }

  getFilteredNewsList() {
    let _filtered = [];
    if (this.newsList?.length > 0) {
      _filtered = this.newsList.sort((a, b) => {
        if (a.startDate < b.startDate) return 1;
        else if (a.startDate > b.startDate) return -1;
        else return 0;
      });
    }
    return _filtered;
  }

  getFilteredPromoList() {
    let _filtered = [];
    if (this.promoAdsList?.length > 0) {
      _filtered = this.promoAdsList.sort((a, b) => {
        if (a.startDate < b.startDate) return 1;
        else if (a.startDate > b.startDate) return -1;
        else return 0;
      });
    }
    return _filtered;
  }

  goHandicapCalculator() {
    if (!this.appAttribute) return;
    let _url = this.appAttribute?.hcpCalculatorURL;
    let _playerId: number = null;
    this.player$.pipe(take(1)).subscribe(player => {
      _playerId = player.playerId || player.id;
      if (_playerId) _url += `?playerId=${_playerId}`;
    });

    window.open(_url, '_system');
  }

  onClickTest() {
    console.debug('test click');
  }

  subRegisterAppVisit: Subscription;
  registerAppVisit() {
    if (this.subRegisterAppVisit) return;
    this.subRegisterAppVisit = this.flightService.registerAppVisit().subscribe(
      (data: any) => {
        if (data) {
          console.debug('register app visit ', data);
        }
      },
      error => {}
    );
  }

  getDefHcpSystem() {
    let _hcpSystemName = 'Handicap';
    if (this.handicapSystem?.length > 0)
      _hcpSystemName = this.handicapSystem.find(hcp => {
        return hcp.id === this.defaultHcpSystem;
      })?.shortCode;
    return _hcpSystemName;
  }

  setCommunalMode(communalMode: boolean) {
    if (communalMode) {
      this.mg2uUtil.setPref('communalMode', true);

      this.clubSpecificSelected = false;
      this.isClubSpecific = false;
      this.getPlayerCredits();
      this.updateColor(null, true);
      this.mg2uUtil.setClubSpecific(this.isClubSpecific);
      this.setCompClubId(true);
      this.mg2uUtil.setPersistClubTheme('communal');
    } else {
      this.mg2uUtil.setPref('communalMode', false);
      // let _cm = this.memberships.filter((cm) => {
      //   return cm.club && cm.club.clubId === this.homeClubId
      // }).pop();
      this.selClubMembership = this.homeClubMembership;
      this.changeTheme(this.homeClubMembership);

      this.mg2uUtil.setClubMembership(this.homeClubMembership);
      this.mg2uUtil.setHomeClub(this.homeClubMembership);
      this.setCompClubId();
    }
  }
  goMatchplayScoring() {
    let navigationExtras: NavigationExtras = {
      state: {
        // scorecard: scorecard,
        // competition: comp,
        // currentPlayer: player,
        // compId: comp?.competitionId || _compId,
      },
    };
    this.router.navigate(['matchplay-scoring'], navigationExtras);
  }

  goMatchplayMatches(compData, playerMatches) {
    this.onDismissPageLoader();
    let navigationExtras: NavigationExtras = {
      state: {
        // scorecard: scorecard,
        // competition: this.competition,
        compData: compData,
        playerMatch: playerMatches[0],

        // compId: this.compId,
        // currentPlayer: _player,
        // editingScorecard:
        //   _isScorer && _isScorer.length > 0
        //     ? true
        //     : false,
      },
    };
    this.router.navigate(['matchplay-scoring'], navigationExtras);
  }

  playerMatches: Array<CompetitionMatch>;
  getCompMatches(compId: number) {
    return new Promise((resolve, reject) => {
      this.playerMatches = [];
      let _player: PlayerInfo;
      this.player$.pipe(take(1)).subscribe(player => {
        _player = player;
      });
      this.flightService.getCompMatches(compId, 1).subscribe(
        (compMatches: Array<CompetitionMatch>) => {
          console.debug('get comp matches', compMatches);

          let _currentPlayerMatches = compMatches?.filter((cm: CompetitionMatch) => {
            return (
              cm?.participants?.some((p: CompetitionMatchParticipant) => {
                return p?.player?.id === _player?.playerId;
              }) &&
              (cm?.status === 'InProgress' ||
                cm?.status === 'Pending' ||
                cm?.status === 'Completed')
            );
          });
          if (_currentPlayerMatches?.length > 0)
            //this.playerMatches = _currentPlayerMatches;
            this.playerMatches = _currentPlayerMatches
              ?.filter((pm: CompetitionMatch) => {
                return pm?.status !== 'Abandoned' && pm?.status !== 'Submitted';
              })
              .sort((a: CompetitionMatch, b: CompetitionMatch) => {
                if (a?.status === 'Completed' && b?.status === 'Pending') return -1;
                else if (a?.status === 'Pending' && b?.status === 'Completed') return 1;
                else if (a?.status === 'InProgress' && b?.status === 'Pending') return -1;
                else if (a?.status === 'Pending' && b?.status === 'InProgress') return 1;
                else {
                  if (a?.startTime < b?.startTime) return -1;
                  else if (a?.startTime > b?.startTime) return 1;
                  else return 0;
                }
              });
          console.debug(
            'get comp matches - current player ',
            compMatches,
            _player,
            _currentPlayerMatches,
            this.playerMatches
          );
          resolve(this.playerMatches);
        },
        error => {
          reject(error);
        }
      );
    });
  }

  checkWhetherCompMatch(comp) {
    return new Promise((resolve, reject) => {
      let _continue: boolean = true;
      let _compId = comp?.competitionId;
      if (!_compId) resolve(true);
      if (!this.hasActiveCompsToday()) {
        resolve(true);
        return;
      }
      // if(a?.compsActiveToday?.length === 1) _compId = a?.compsActiveToday[0]?.competitionId
      this.getCompetitionData(Number(_compId))
        .then(async (compData: CompetitionData) => {
          console.debug(
            'get comp data ',
            compData,
            compData?.addlSettings,
            compData?.teamEvent,
            compData?.matchPlay
          );
          if (!compData?.addlSettings?.matchPlayDetailedScoring) {
            await this.initPageLoader('Getting scorecard. Please wait...');
            if (compData?.teamEvent && compData?.matchPlay) {
              this.pageLoader.present();
              this.getCompMatches(compData?.id).then((playerMatches: Array<CompetitionMatch>) => {
                if (playerMatches?.length) {
                  if (playerMatches?.length > 0) this.playCompClicked = false;
                  this.goMatchplayMatches(compData, playerMatches);
                } else resolve(true);
              });
            } else resolve(true);
          } else resolve(true);
        })
        .catch(error => {
          resolve(true);
        });
    });
  }
  onStayPlayClick() {
    console.debug('on stay play click', this.playCompClicked, this.pageLoader);
    // if(this.playCompClicked) return;
    // if(this.pageLoader) return;
    this.router.navigate(['package-booking'], { replaceUrl: true });
  }

  onDismissPageLoader() {
    if (this.pageLoader) {
      this.pageLoader.dismiss();
    }
    this.pageLoader = null;
    this.playCompClicked = null;
    this.playGolfClicked = null;
  }
  checkAndDisplayConnection() {
    if (this.connService.getCurrentNetworkStatus()) {
      return true;
    } else {
      let msg = 'You have no internet connection. Cannot proceed';
      MessageDisplayUtil.showErrorToast(msg, this.platform, this.toastCtl, 5000, 'bottom');
      return false;
    }
  }
}
